export const hu: { [key: string]: string } = {
  subscribe_with_click: 'Feliratkozás egy kattintással',
  subscribe: 'Feliratkozás egy kattintással',
  minimum_number_characters: 'minimum 2 karakter',
  request_details: 'Részletek kérése',
  form_title: 'Hamarosan felvesszük Önnel a kapcsolatot',
  form_required: 'A *-gal jelölt mezők kitöltése kötelező',
  form_name_placeholder: 'Név',
  form_email_placeholder: 'E-mail',
  form_phone_placeholder: 'Telefonszám',
  form_company_placeholder: 'Cég',
  form_submit: 'Küldés',
  form_1: 'Hozzájárulok személyes adataim kezeléséhez az alábbiak szerint:',
  form_2: 'Adatvédelmi szabályzat',
  validation_privacy_policy: 'Kérjük, fogadja el az Adatvédelmi szabályzatot',
  validation_phone: 'Érvénytelen telefonszám',
  validation_email: 'Érvénytelen e-mail-formátum',
  validation_required: 'A kötelező mezők nincsenek kitöltve',
  submit_error: 'Hiba történt az űrlap mentése során',
  footer_1: 'Partnereink:',
  footer_2: 'Módszerek',
  footer_3: 'Termékek',
  footer_4: 'Kapcsolat:',
  footer_5: 'Impresszum',
  footer_6: 'Adatvédelmi szabályzat',
  footer_7: 'Piackutatás',
  about_us_1: 'A 4Service vállalati társadalmi felelősségvállalása',
  about_us_2:
    'Csapatunk minden tagjának szívéből és lelkéből fakad. Mindent megteszünk azért, hogy minden munkatársunkban megőrizzük a kedvesség szikráját, és egy kicsit jobbá tegyük a körülöttünk lévő világot',
  about_us_3: 'A 4Service vállalati társadalmi felelősségvállalása',
  about_us_4:
    'Csapatunk minden tagjának szívéből és lelkéből fakad. Mindent megteszünk azért, hogy minden munkatársunkban megőrizzük a kedvesség szikráját, és egy kicsit jobbá tegyük a körülöttünk lévő világot',
  about_us_5: 'Service Mania üzleti játék',
  about_us_6: 'Gyermekeket és diákokat támogató kezdeményezéseink',
  about_us_7: 'Jótékonyság / Önkéntesség',
  about_us_8:
    'Árvaházak, idősek otthonai és az ukrán hadsereg támogatása önkéntes munkával. Tevékenységünk legmeghatóbb része',
  about_us_9: 'Állatvédelem',
  about_us_10:
    'Bárki betérhet az irodánkba háziállatával. Segítjük az állatmenhelyeket, adományokat gyűjtünk eledelre, és időnként megpróbálunk otthont találni a gazdátlan állatoknak',
  about_us_11: '4Service Group',
  about_us_12: 'Nemzetközi kutatóvállalat, amely az ügyfélélményt kezeli.',
  about_us_13:
    'Komplex projekteket valósítunk meg az értékesítés növelése és az ügyfélközpontú vállalatok üzletfejlesztése érdekében.',
  about_us_14:
    'Nemzetközi kutatási holding, amelynek központja Bécsben, Ausztriában található. A vállalat 2001-ben alakult azzal a céllal, hogy javítsa ügyfelei, valamint az üzleti vállalkozásokkal kapcsolatba kerülő, azok szolgáltatásait igénybe vevő és termékeit fogyasztó emberek életminőségét. Nem véletlenül választottuk a „Forservice” nevet egy olyan vállalat számára, amely az ügyfélszolgálatot és a jó minőséget képviseli.',
  about_us_15:
    'Így kezdődött a 4Service története Kijevben, Ukrajnában, mint a mystery shopping szolgáltatások vezető szolgáltatójának története. Azóta kutatóvállalatként sikeresen működünk 52 országban, új lehetőségeket kínálva az ügyfélélmény teljes láncolatának átfogó elemzésére és fejlesztésére',
  about_us_16: 'a szolgáltatás jegyében született',
  about_us_17: 'az első Ukrajnán kívüli iroda megnyitása',
  about_us_18: 'a központ áthelyezése Bécsbe',
  about_us_19: 'elit MSPA-tag, Európa TOP-10 ügynöksége',
  about_us_20: 'irodák létrehozása 9 országban',
  about_us_21: 'első digitális projektek, Voicer',
  about_us_22: 'a DesignThinkers Academy partnerei',
  about_us_23: 'első globális CX-projektek',
  about_us_24: 'Küldetés',
  about_us_25:
    'Küldetésünk, hogy világszerte javítsuk az ügyfélszolgálat színvonalát! Inspirációnkat azok a minőségi változások jelentik, amelyeket az általunk támogatott emberek és vállalatok életében látunk.',
  about_us_26: '20+ év ügyfélélmény-tapasztalat',
  about_us_27: '95 ország',
  about_us_28:
    'A világ minden tájáról összegyűjtjük és megosztjuk az iparág legjobb tapasztalatait',
  about_us_29: 'Központi iroda Bécsben',
  about_us_30:
    'ország. A világ minden tájáról összegyűjtjük és megosztjuk az iparág legjobb tapasztalatait',
  about_us_31: 'szolgáltatásminőségi értékelés',
  about_us_32: 'Európa TOP-10 CX-ügynöksége között vagyunk',
  about_us_33: 'képviseleti irodák / központ Ausztriában',
  about_us_34: 'aktív projektek',
  about_us_35: 'Az Ön jövőbeli munkahelye',
  about_us_36: 'Irodáink',
  about_us_37:
    'A 4Service ™ mindent megtesz annak érdekében, hogy kényelmes munkakörnyezetet teremtsen munkatársai számára. Munkatársaink helyben, távolról vagy hibrid munkarendben dolgozhatnak, mindenki számára a legkényelmesebb és leghatékonyabb módon. Pihenőhelyiségek, ingyenes pszichológiai támogatás és barátságos környezet várja őket. Ember- és állatbarátok vagyunk.',
  about_us_38: 'Egy csapat, amely ragyog',
  about_us_39:
    'Nemzetközi csapatunk elkötelezett amellett, hogy meghallgassa ügyfeleinket, nyitott legyen a visszajelzésekre, és együtt fejlődjön velük. Ügyfeleink ügyfélútjának feltérképezése számunkra éppolyan fontos, mint új termékek bevezetése vagy pénzügyi céljaink elérése. Tevékenységünk célja, hogy pozitív hatást gyakoroljunk a körülöttünk lévő közösségekre, valamint innovatív és emberközpontú megoldásokat biztosítsunk ügyfeleink számára.',
  about_us_40: 'Mind',
  about_us_41: 'Vezetőség',
  about_us_42: 'Globális csapat',
  about_us_43: 'Terméktulajdonosok',
  about_us_44: 'Partnereink',
  about_us_45:
    'Komplex projekteket valósítunk meg az értékesítés növelése és az ügyfélközpontú vállalatok üzletfejlesztése érdekében',
  about_us_46:
    'a világ egyik vezető „design driven” professzionális képzési intézménye, amely 25 országban van jelen, és kreatív, multidiszciplináris csapatokat és közösségeket képez, fejleszt és támogat a pozitív változások előmozdítása érdekében. A Design Thinking lehetővé teszi innovatív ötletek, változások és összetett problémákra adott megoldások kidolgozását és megvalósítását.',
  about_us_47:
    'Küldetésük, hogy teret és időt biztosítsanak a csapatok és egyének számára, hogy inspirációt és kihívást kapjanak, „tanuljanak a gyakorlatban”, és fejlesszék kreatív problémamegoldó képességüket, valamint segítsenek a szervezeteknek kialakítani a merész innováció elindításához szükséges környezetet és szemléletet.',
  about_us_48:
    'a Mystery Shopping iparágban működő vállalatokat képviselő szakmai szövetség. A szövetség regionális alapon működik világszerte, Amerikában, Európában/Afrikában és Ázsiában/Csendes-óceáni térségben működő szervezeti egységekkel. A tagvállalatok közös szervezetként egyesülnek azzal a céllal, hogy összehangolt erőfeszítésekkel és intézkedésekkel erősítsék a Mystery Shopping iparágat.',
  about_us_49:
    'nonprofit tagsági szervezet. Tagjai olyan közösséget alkotnak, amely hisz az adatelemzésben, a kutatásban és az insightokban rejlő lehetőségekben, amelyek hozzájárulhatnak a társadalmak, szervezetek és mindenki életének javításához.',
  about_us_50:
    'Az ESOMAR központja Amszterdamban, Hollandiában található. Az ESOMAR 1947 óta tagjain keresztül több mint 130 országban van jelen.',
  about_us_51:
    '(UCCA) a contact center és ügyfélszolgálati területen működő magánszakértők és vállalatok szakmai közössége, amelynek célja az együttműködés és a fejlődés előmozdítása. Az UCCA filozófiája a contact center iparág kultúrájának fejlesztése modern technológiák és magas szintű standardok alapján.',
  about_us_52: 'Az Ukrán Contact Center Szövetséget 2010-ben alapították',
  about_us_53:
    'a világ legjobb oktatási tapasztalatait tanulmányozza, hogy azokat az ukrán piacon adaptálja és alkalmazza. Ezért működik együtt az Academy DTEK vezető nemzetközi üzleti iskolákkal: az INSEAD-del, az IE Business Schoollal és a Stanford Egyetemmel.',
  about_us_54:
    'Az Academy DTEK a D.Client School, az ID School és az Executive Education keretében az ügyfélközpontú és innovatív kultúra fejlesztésére összpontosít: Energy of Innovation, Power of Communications, DX School digitális program, Effective Leader: Pre-MBA, Change Energy.',
  about_us_55: 'Sergey Pashkovsky',
  about_us_56: 'Viktoria Skorbota',
  about_us_57: 'Artem Fomin',
  about_us_58: 'Max Papka',
  about_us_59: 'Nemzetközi értékesítési menedzser',
  bht_1: 'Márka',
  bht_2: 'egészségi állapotának nyomon követése',
  bht_3: 'A márkák rendkívül erőteljesek',
  bht_4: 'Tudja meg, hogyan teljesít összességében a márkája',
  bht_5: 'Rólunk',
  bht_6: 'Mi az a Brand Health Tracking?',
  bht_7:
    'Ez egy olyan piackutatási forma, amelyet meghatározott rendszerességgel (kéthetente, havonta stb.) végeznek annak érdekében, hogy információt szerezzenek a',
  bht_8:
    'márka piaci helyzetéről olyan mutatók alapján, mint az ismertség, a kereslet, az imázs, a fogyasztók jellemzői, a márka egészsége stb.',
  bht_9: 'Leggyakrabban vásárolja a márkát',
  bht_10: 'Hűséges',
  bht_11: '3 hónapja vásárolja a márkát',
  bht_12: 'Visszatérő / rendszeres vásárlók',
  bht_13: '6 hónapja vásárolja a márkát',
  bht_14: 'Rövid távú ügyfelek',
  bht_15: 'Egy éve vásárolja a márkát',
  bht_16: 'Hosszú távú ügyfelek',
  bht_17: 'Ismeri a márkát, de még soha nem használta / vásárolta',
  bht_18: 'Ismeri, de nem vásárló',
  bht_19: 'Nem ismeri: még soha nem hallott a márkáról',
  bht_20: 'Nem ismeri',
  bht_21: 'A márka vásárlóinak profilja',
  bht_22:
    'A márkaépítés érdekében hosszú távon tett erőfeszítések következetességének értékelése',
  bht_23: 'A fogyasztók márkaismeretének szintjének mérése',
  bht_24: 'A reklám- és információs kampányok hatékonyságának bemutatása',
  bht_25:
    'Annak meghatározása, hogy az intenzív reklámtevékenység időszaka milyen hatással van a versenytársak értékesítési / marketingtevékenységére',
  bht_26:
    'Folyamatos kontroll biztosítása a vállalkozás tulajdonosa számára a folyamatosan változó piaci környezetben',
  bht_27: 'Milyen feladatokat lehet megoldani a BHT segítségével:',
  bht_28: 'Kutatás igénylése',
  bht_29: 'Megoldandó feladat',
  bht_30: 'Például,',
  bht_31:
    'ha egy vállalatnak a piaci részesedés mérése során negyedévente csak egy BHT-mérésre van szüksége, akkor a válaszadók körében gyakrabban kell felmérést végezni, amikor a reklámok alapján a márka ismertségét mérik.',
  bht_32: 'CATI',
  bht_33: 'Személyes interjú',
  bht_53: 'Interjúk',
  bht_34: 'CAWI',
  bht_35: 'Megoldandó feladat',
  bht_36: 'Információgyűjtéssel',
  bht_37:
    'különböző módszerekkel a márkakövetés általában három szakaszra oszlik a célközönség és annak elérhetőségének nehézsége alapján:',
  bht_38:
    'Az adatgyűjtéshez hagyományos és korszerű módszereket egyaránt alkalmazunk:',
  bht_39:
    'Két modellt alkalmazunk: az első egy egyszerű mutatókészletet tartalmaz, a második pedig olyan összetettebb iparágakat céloz meg, mint az élelmiszer- és szolgáltatóipar. Az összetettebb modell mélyreható vizsgálatot foglal magában, amely akár 10 értékelt indexet is tartalmaz.',
  bht_40: 'Kínálunk',
  bht_41: 'a kezdeti adatok ellenőrzését',
  bht_42: 'Lefedjük',
  bht_43: 'az egész országot',
  bht_44: 'Megoldást biztosítunk',
  bht_45:
    'nem dinamikus piacok / korlátozott számú szereplővel rendelkező piacok számára (Brand Point Analyze)',
  bht_46: 'Miért mi?',
  bht_47: 'Miért válasszon minket?',
  bht_50: 'Gyenge eredmény',
  bht_51: 'Jó eredmény',
  bht_52: 'Átlagos eredmény',
  cases_1:
    'Kihívás: Hogyan javítható az elektromos járművek vásárlási élménye a Hyundai bemutatótermeiben?',
  cases_2: 'Ügyfélút feltérképezése',
  cases_3: 'Ötletelés',
  cases_4: 'Kvalitatív kutatás',
  cases_5:
    'Kihívás: Min kellene változtatni az üzletekben (mind a szolgáltatási folyamatban, mind a belső térben, mind a márka megítélésében) annak érdekében, hogy felkeltsük az ügyfelek érdeklődését az Oppo márka iránt?',
  cases_6: 'Online CJM',
  cases_7: 'UI-tesztelés',
  cases_8: 'Interjúk',
  cases_9:
    'Kihívás: Min kellene változtatni az üzletekben annak érdekében, hogy felkeltsük az ügyfelek érdeklődését az Oppo márka iránt?',
  cases_10: 'Kvalitatív rész',
  cases_11: 'Ötletelés',
  cases_12: 'Kvantitatív rész',
  cases_13: 'Ügyfélút-térkép',
  cases_14: 'Esettanulmányok',
  cases_15: 'Összes',
  cases_16: 'Valósítsuk meg együtt nagyszerű projektünket',
  csi_1: 'Ügyfél',
  csi_2: 'elégedettségi index',
  csi_3: 'A fogyasztók',
  csi_4: 'elégedettségének és elégedetlenségének okainak meghatározása',
  csi_5: 'Ügyfélelégedettségi kutatás',
  csi_6:
    'azoknak a tényezőknek, okoknak és motivációknak a meghatározása, amelyek befolyásolják az ügyfél termék- vagy szolgáltatásvásárlással kapcsolatos döntését, valamint a célközönség viselkedését.',
  csi_7: 'Ügyfélelégedettségi felmérés',
  csi_8:
    'megmutatja, hogy az ügyfél mennyire elégedett vagy elégedetlen a szolgáltatás egy adott aspektusával vagy általában a termékkel.',
  csi_9: 'Az elégedettségi felmérés',
  csi_10:
    'a vállalat meglévő ügyfelei és bizonyos termékek / szolgáltatások felhasználói körében történik.',
  csi_11: 'Mi az a CSI?',
  csi_12:
    'Az ügyfélelégedettség azt méri, hogy vállalata által nyújtott termék vagy szolgáltatás megvásárlásával kapcsolatban milyen mértékben teljesültek az ügyfél elvárásai.',
  csi_13: 'Boldog ember',
  csi_14: 'Rólunk',
  csi_15: 'Rejtett tényezők azonosítása',
  csi_16: 'amelyek befolyásolhatják az ügyfélelégedettséget',
  csi_17: 'Az okok meghatározása',
  csi_18:
    'az áruk és szolgáltatások iránti kereslet növekedése / csökkenése mögött',
  csi_19: 'A vállalat',
  csi_20: 'üzleti folyamatainak optimalizálása',
  csi_21: 'Alkalmazásuk',
  csi_22: 'a modern fogyasztó igényeihez',
  csi_23: 'Hatékony reklámüzenet kialakítása',
  csi_24: 'és a termék pozicionálása az ügyfél igényeihez igazodva',
  csi_25: 'Megoldandó feladatok',
  csi_26: 'Milyen feladatokat oldhatnak meg az ügyfélelégedettségi felmérések?',
  csi_27: 'Férfi telefonnal',
  csi_28: 'Matematikai modellt készítünk',
  csi_29:
    'az ügyfélelégedettséget / ügyfélhűséget befolyásoló tényezőkről (regresszióanalízis)',
  csi_30: 'Optimalizáljuk a',
  csi_31: 'vállalat üzleti folyamatait',
  csi_32: 'Kiszámított ügyfélelégedettségi indexet építünk',
  csi_33: '(CSI), és összehasonlítjuk a deklaratív értékkel',
  csi_34: 'Kutatást végzünk',
  csi_35: 'mind a B2B, mind a B2C szegmensben.',
  csi_36: 'Kérdőíveinket egy elemzői csapat fejleszti',
  csi_37: 'kifejezetten ügyfeleink egyedi projektjeihez',
  csi_38: 'Miért mi?',
  csi_39: 'Miért válasszon minket?',
  csi_40: 'Információgyűjtési módszerek:',
  main_1:
    'ügyfelünk javítja pénzügyi teljesítményét azáltal, hogy tanul ügyfelei tapasztalataiból',
  main_2:
    'CX-kutatási és tanácsadási szolgáltatások: 360°-os nézőpont vállalkozása számára',
  main_3:
    'Fedezze fel megoldásaink és eszközeink kínálatát vállalkozása támogatására',
  main_4: 'Termékek',
  main_5:
    'A kvalitatív kutatás nem numerikus adatok gyűjtését és elemzését jelenti a fogalmak, vélemények vagy tapasztalatok megértése érdekében',
  main_6:
    'A kvantitatív kutatási módszerek a felmérések, kérdőívek és kutatások során gyűjtött adatok objektív mérését és számszerű elemzését jelentik',
  main_7:
    'A mystery shopping olyan piackutatási technika, amely egy előre meghatározott forgatókönyv alapján méri és nyomon követi az ügyfél és egy vállalat vagy szervezet közötti interakciókat',
  main_8:
    'Visszajelzés-kezelési rendszer. Ügyfelei hangja egyetlen rendszerben – ügyfél-visszajelzés-kezelési rendszer',
  main_9:
    'Mesterséges intelligenciával támogatott tartalomintelligencia-platform, amely betekintést nyújt a közönség véleményébe',
  main_10:
    'Teljesítménymenedzsment-szoftver. Gamifikált alkalmazás az értékesítés növelésére',
  main_11:
    'Az árfigyelés a versenytársak árainak gyűjtését, feldolgozását és elemzését jelenti',
  main_12:
    'az ügyfélközpontú szolgáltatások és termékek tervezése. A folyamat során kiegyensúlyozottan haladunk az ügyfelek igényeitől és elvárásaitól azok megvalósításának módjáig',
  main_13:
    'Elemzői csapatunk a legkorszerűbb és legmegalapozottabb megközelítéseket alkalmazza, amelyek számos ügyfélnél bizonyítottan sikeresnek bizonyultak',
  main_14: 'Módszertanok',
  main_15: 'Ügyfélút-térkép',
  main_16:
    'Az ügyfélút feltérképezése (CJM) a célközönség meghatározásáról, igényeik és környezetük megértéséről, majd egy vonzó élmény biztosítására szolgáló terv kialakításáról szól',
  main_17: 'CJM',
  main_18: 'Net Promoter Score',
  main_19:
    'A Net Promoter Score (NPS) az ügyfélélmény-mutatók arany standardja, amely egyetlen kérdésen alapul: Mennyire valószínű, hogy ajánlaná a szervezetet/terméket/szolgáltatást?',
  main_20: 'NPS',
  main_21: 'Brand Health Tracking',
  main_22:
    'A Brand Health Tracking (BHT) kutatás mérheti, hogyan teljesít márkája az ismertség és használat, a márkapozicionálás és a márkateljesítmény terén',
  main_23: 'BHT',
  main_24: 'Humánerőforrás-kutatás',
  main_25:
    'A humánerőforrás-kutatás a HR-gyakorlatok és a teljesítmény értékelésére szolgál, valamint részletes elemzést kínál a jelenlegi fejlődésről és menedzsmentről',
  main_26: 'HR-kutatás',
  main_27: 'Ügyfélelégedettségi index',
  main_28:
    'Az ügyfélelégedettségi index (CSI) azt mutatja meg, mennyire elégedettek ügyfelei a vállalat termékeivel / szolgáltatásaival.',
  main_29: 'CSI',
  main_30: 'UX-tesztelés',
  main_31:
    'A használhatósági (UX) tesztelés során azt vizsgáljuk, hogyan lépnek kapcsolatba valódi emberek egy weboldallal, alkalmazással vagy más termékkel, valamint megfigyeljük viselkedésüket és reakcióikat',
  main_32: 'Miért mi?',
  main_33:
    'Küldetésünk, hogy segítsük a vállalkozásokat rendkívül hatékony ügyfélélmény biztosításában',
  main_34: 'A minőségre összpontosítunk',
  main_35: 'Minőségbiztosítást alkalmazunk',
  main_36:
    'a kutatási adatok tekintetében. Minden adathalmazt elérhetővé teszünk ügyfeleink számára',
  main_37: 'Költséghatékony',
  main_38: 'Tapasztalatunk, erőforrásaink és optimalizált',
  main_39:
    'üzleti folyamataink lehetővé teszik, hogy időt és pénzt takarítsunk meg Önnek',
  main_40: 'Intelligens megoldások',
  main_41: 'Számos technikát',
  main_42: 'és eszköztárat alkalmazunk az Ön egyedi problémáinak megoldására',
  main_43: 'A minőségre összpontosítunk',
  main_44: 'Minőségbiztosítást alkalmazunk',
  main_45:
    'a kutatási adatok tekintetében. Minden adathalmazt elérhetővé teszünk ügyfeleink számára',
  main_46: 'Költséghatékony',
  main_47: 'Tapasztalatunk, erőforrásaink és optimalizált',
  main_48:
    'üzleti folyamataink lehetővé teszik, hogy időt és pénzt takarítsunk meg Önnek',
  main_49: 'Intelligens megoldások',
  main_50: 'Számos technikát',
  main_51: 'és eszköztárat alkalmazunk az Ön egyedi problémáinak megoldására',
  main_52: 'Cash & Carry',
  main_53: 'Elektronika',
  main_54: 'Luxus / Prémium',
  main_55: 'Vendéglátás és szállodaipar',
  main_56: 'Kiskereskedelem',
  main_57: 'Autóipar',
  main_58: 'Divat',
  main_59: 'Bankok',
  main_60: 'Utazás és szabadidő',
  main_61: 'Órák és ékszerek',
  main_62: 'Háztartás és háztartási gépek',
  main_63: 'Blog',
  main_64: 'Látogasson el blogunkra, és olvasson további érdekes bejegyzéseket',
  main_65: 'Kiskereskedelmi audit',
  main_66:
    'Gyűjtsön részletes adatokat üzletéről vagy márkájáról, elemezze a növekedés akadályait, és dolgozzon ki hatékony stratégiákat azok leküzdésére',
  main_73: 'Diary Study',
  main_74:
    'A naplóvizsgálatok hasznosak a hosszú távú tapasztalatok és ismétlődő tevékenységek feltárására. Kövesse nyomon és ismerje meg a felhasználói élmények és életmódok változásait mindennapi környezetükben, idővel.',
  main_75: 'Employee Experience (EX)',
  main_76:
    'Az Employee Experience (EX) módszertana olyan stratégiai megközelítés, amely segít a szervezeteknek az alkalmazottak elvárásaihoz és az üzleti célokhoz igazodó jobb folyamatok, kultúrák és környezetek kialakításában, ezáltal javítva mind a munkavállalók jóllétét, mind a vállalat teljesítményét',
  main_77: 'CATI',
  main_78: 'Számítógéppel támogatott telefonos interjúk (CATI)',
  main_79:
    'A CATI rugalmas és hatékony kutatási módszertan, amely kiváló minőségű adatok gyűjtését teszi lehetővé a különféle üzleti igényekhez igazítva – az ügyfélelégedettségtől és a munkavállalói elkötelezettségtől a piackutatásig és társadalomkutatásig –, pontos, időszerű és jól hasznosítható eredményeket biztosítva',
  cjm_1: 'Ügyfél',
  cjm_2: 'út-térkép',
  cjm_3:
    'Lépjen be az ügyfelek világába, és tapasztalja meg az ő szemszögükből',
  cjm_4: 'Mi az az Ügyfélút-térkép?',
  cjm_5:
    'A CJM vizuálisan ábrázolja a fogyasztó és egy termék, szolgáltatás, vállalat vagy márka közötti interakció történetét különböző csatornákon és egy meghatározott időszak alatt.',
  cjm_6:
    'Ez lehetővé teszi a vállalatok számára, hogy objektíven elemezzék az ügyfélinterakciók élményét, azonosítsák és megszüntessék a felmerülő akadályokat, valamint ajánlásokat fogalmazzanak meg a termék fejlesztésére.',
  cjm_7: 'Célközönség meghatározása, szegmentáció',
  cjm_8: 'Az ügyfélinterakció szakaszainak azonosítása',
  cjm_9: 'Az elsődleges ügyfélinterakciós csatornák azonosítása',
  cjm_10: 'Az ügyfélélmény kutatása',
  cjm_11: 'Az akadályok elemzése és optimalizálási hipotézisek felállítása',
  cjm_12: 'A hipotézisek megvalósítása és tesztelése',
  cjm_13: 'Az Ügyfélút-térkép kialakítása a következő lépésekből áll:',
  cjm_14: 'Az Ügyfélút-térkép bemutatja:',
  cjm_15:
    'A CJM vizuálisan ábrázolja a fogyasztó és egy termék, szolgáltatás, vállalat vagy márka közötti interakció történetét különböző csatornákon és egy meghatározott időszak alatt.',
  cjm_16: 'Biztosítjuk a csapatmunkát',
  cjm_17: 'az elemzők és a tervezők között',
  cjm_18: 'Egyéni megoldást kínálunk',
  cjm_19: 'megközelítést minden egyes ügyfél számára',
  cjm_20: 'Növelni tudjuk az általános',
  cjm_21:
    'ügyfélelégedettséget a szolgáltatással / termékkel kapcsolatban, és végső soron növelhetjük a vállalat iránti lojalitást',
  cjm_22: 'Garantáljuk a',
  cjm_23:
    'fogyasztói út optimalizálását, figyelembe véve a vállalat üzleti folyamatait',
  cjm_24: 'Ügyfeleink számára kínáljuk',
  cjm_25:
    'a kombinált megközelítések alkalmazásának lehetőségét: CATI, CAWI, fókuszcsoportok, mélyinterjúk, szakértői interjúk, etnográfia stb.',
  cjm_26: 'Miért válasszon minket?',
  methods_hr_1: 'Humánerőforrás-kutatás',
  methods_hr_2:
    'Szerezzen objektív betekintést csapatáról, és tudja meg, hogyan javíthatja a HR teljesítményét',
  methods_hr_3: 'Néhány ok, amiért szüksége lehet HR-kutatásra',
  methods_hr_4: 'megkérdezett munkatársak',
  methods_hr_5: 'megvalósított HR-projektek',
  methods_hr_6: 'megtartott munkatársi képzések',
  methods_hr_7:
    'Vezető európai holding az ügyfélélmény- és munkavállalói kutatás területén',
  methods_hr_8: 'A 4Service HR-kutatásai számokban',
  methods_hr_9:
    'A vállalat munkavállalói életciklusának minden szakaszában felmerülő problémák és gyenge pontok azonosítása: keresés/toborzás/beillesztés/karrierfejlesztés/újraminősítések',
  methods_hr_10:
    'Annak megértése, hogy milyen esetek indokolják a fizetésemelést és a bónuszokat',
  methods_hr_11:
    'Előre kell jelezni a munkavállalói elégedetlenséget, vagy megoldásokat kell kínálni rá',
  methods_hr_12:
    'A HR-kutatás révén új és korszerű módszerek alkalmazhatók a HR-politikák, programok és gyakorlatok értékelésére',
  methods_hr_13: 'A vállalat munkavállalóinak mentális egészségének javítása',
  methods_hr_14:
    'Ha célorientált megközelítéssel szeretné javítani a termelékenységet',
  methods_hr_15:
    'Ha nemzetközi és/vagy távoli csapata van, amelyet irányítania kell',
  methods_hr_16:
    'Annak megértése, mennyire vonzó munkáltatói márkája a potenciális munkavállalók számára',
  methods_hr_17: 'Munkavállalói elégedettség',
  methods_hr_18: 'Munkáltatói márkakutatás',
  methods_hr_19: 'Kulturális sokszínűség',
  methods_hr_20: 'Kompenzációs és fizetési tervek',
  methods_hr_21: 'Csapatelkötelezettség és lojalitás',
  methods_hr_22: 'Védett munkavállalói csoportok',
  methods_hr_23: 'Kutatási területek',
  methods_hr_24: '1. megoldás',
  methods_hr_25: 'eNPS, munkavállalói elégedettség, munkavállalói lojalitás',
  methods_hr_26: 'Mit mérünk:',
  methods_hr_27: 'Lojalitás:',
  methods_hr_28:
    'munkavállalói lojalitás, jövőbeli viselkedés előrejelzése, a lojalitást befolyásoló tényezők súlyának meghatározása',
  methods_hr_29: 'Részvétel:',
  methods_hr_30:
    'a munkavállalók bevonódása a munkába, érdeklődés az eredmények és teljesítmények iránt',
  methods_hr_31: 'Elkötelezettség:',
  methods_hr_32: 'a munkavállalói értékek és a vállalati értékek azonosítása',
  methods_hr_33: 'Bizalom 360:',
  methods_hr_34:
    'bizalom a vezetésben, munkatársakban, beosztottakban, valamint a munkáltató stratégiáiban és politikáiban',
  methods_hr_35: 'Elégedettség:',
  methods_hr_36:
    'az egyes vállalatokra jellemző egyedi tényezők meghatározása, az elégedettség értékelése minden, a lojalitást befolyásoló kulcstényező mentén',
  methods_hr_37: '2. megoldás',
  methods_hr_38: 'Munkáltatói márkaépítés',
  methods_hr_39: 'Belső munkáltatói',
  methods_hr_40:
    'márkaelemzés (munkatársak, érintettek, belső toborzók és HR-szakemberek felmérése)',
  methods_hr_41: 'Külső munkáltatói elemzés',
  methods_hr_42:
    '(versenytársak EVP-elemzése, külső toborzók felmérése, álláskeresők felmérése)',
  methods_hr_43: 'Márkaismertség és reputáció',
  methods_hr_44: 'elemzése',
  methods_hr_45: 'Munkáltatói jelenlét',
  methods_hr_47: 'Munkáltatói referenciák',
  methods_hr_48: 'gyűjtése',
  methods_hr_49: 'Versenytársi benchmarking',
  methods_hr_50: 'olyan kulcstényezők alapján, mint',
  methods_hr_51: 'Fizetés,',
  methods_hr_52: 'munkakörnyezet, légkör, a munka jellege',
  methods_hr_53: 'Az igények és elvárások elemzése',
  methods_hr_54: 'az álláskeresők körében',
  methods_hr_55: 'Mélyinterjúk,',
  methods_hr_56: 'desk research és kvantitatív kutatás alkalmazásával',
  methods_hr_57: '3. megoldás',
  methods_hr_58: 'Munkavállalói út térképe / Mystery Employee',
  methods_hr_59: 'az álláskeresői út kialakítása és azonosítása',
  methods_hr_60:
    'a keresés fő szakaszainak, kommunikációs csatornáknak, kiválasztási kritériumoknak és az álláskeresők értékelésének',
  methods_hr_61: 'minden szakasz nyomon követése',
  methods_hr_62:
    'és a mystery álláskeresőkkel folytatott kommunikáció csatornáinak követése (interjúidőpont-egyeztetés, interjú, szakmai gyakorlat a vállalatnál)',
  methods_hr_63: 'Azonosítás',
  methods_hr_64: 'a toborzási és beillesztési folyamatok gyenge pontjainak',
  methods_hr_65: 'Fejlesztési ajánlások,',
  methods_hr_66: 'benchmarking az iparág vezető szereplőivel',
  mystery_shopping_1: 'Mystery',
  mystery_shopping_2: 'Shopping',
  mystery_shopping_3: 'Értékelje szolgáltatását valódi ügyfelek segítségével',
  mystery_shopping_4:
    'Ellenőrizze a standardokat, értékelje munkatársait, kerüljön közelebb ügyfeleihez',
  mystery_shopping_5:
    'Az MSPA Europe vezető szakmai Mystery Shopping Providers szövetségének Elite tagjai vagyunk',
  mystery_shopping_6: 'tapasztalat',
  mystery_shopping_7: 'látogatás havonta',
  mystery_shopping_8: 'mystery shopper világszerte',
  mystery_shopping_9: 'Aktív projektek',
  mystery_shopping_10: 'irodák, központ Ausztriában',
  mystery_shopping_11: 'Európai Mystery Shopping Providers',
  mystery_shopping_12: 'szolgáltatásminőségi értékelések',
  mystery_shopping_13: 'Kérdőív',
  mystery_shopping_14: 'Szoftver',
  mystery_shopping_15: 'Mystery Shopper profilja',
  mystery_shopping_16: 'Validáció és kifogáskezelés',
  mystery_shopping_17: 'Elemzés',
  mystery_shopping_18:
    'Ezzel az 5 lépéssel a 4Service garantálja a Mystery Shopping szolgáltatás minőségét',
  mystery_shopping_19: 'Program',
  mystery_shopping_20: 'A 4Service Mystery Shopping programjának 5 eleme',
  mystery_shopping_21: 'Kérdőív:',
  mystery_shopping_22: 'a program központi eleme',
  mystery_shopping_23:
    'A program ezen része minden érintett számára hozzáférhető',
  mystery_shopping_24: 'Felsővezetők számára.',
  mystery_shopping_25:
    'A folyamat minden fontos lépésének és részletének bemutatása',
  mystery_shopping_26: 'Munkatársak számára.',
  mystery_shopping_27:
    'Tükrözi a munkáltatók velük szemben támasztott elvárásait',
  mystery_shopping_28: 'Mystery Shopperek számára.',
  mystery_shopping_29:
    'Egyértelmű és strukturált a félreértések és az elfogultság elkerülése érdekében',
  mystery_shopping_30: 'Shopmetrics szoftver:',
  mystery_shopping_31: 'felhasználóbarát és innovatív',
  mystery_shopping_32: 'Előnyök:',
  mystery_shopping_33: 'Integrálható',
  mystery_shopping_34: 'az Ön üzleti folyamataival és szoftvereivel',
  mystery_shopping_35: 'GDPR-központú',
  mystery_shopping_36: 'adatvédelmi menedzsment eszköztár',
  mystery_shopping_37: 'Részletes',
  mystery_shopping_38: 'jogi megfelelőségi csomag',
  mystery_shopping_39: 'Jelentés',
  mystery_shopping_40: 'készítő',
  mystery_shopping_41: 'Hozzáférési szintek',
  mystery_shopping_42: 'kezelése',
  mystery_shopping_43: 'A kérdőívek többsége',
  mystery_shopping_44: 'egy órán belül elkészül',
  mystery_shopping_45: 'Mystery Shopper profilja:',
  mystery_shopping_46: '200 000+ Mystery Shopper világszerte',
  mystery_shopping_47:
    'Fő szempontok: a lehető legnagyobb közelség a célközönségéhez, valamint korábbi tapasztalat az Ön vállalatával vagy versenytársaival',
  mystery_shopping_48: 'Mystery Shopper-képzés:',
  mystery_shopping_49: 'Bevezető képzési teszt',
  mystery_shopping_50: 'Skype-/telefonhívás',
  mystery_shopping_51: 'Értékelési teszt (opcionális)',
  mystery_shopping_52: 'Validáció és kifogáskezelés',
  mystery_shopping_53: 'Validáció',
  mystery_shopping_54: 'Rendszer',
  mystery_shopping_55: 'A jelentések 100%-a',
  mystery_shopping_56: 'áttekintésre kerül a validációs csapat által',
  mystery_shopping_57: 'További hívások',
  mystery_shopping_58: 'a pontosítás érdekében',
  mystery_shopping_59: 'Hangfelvételek',
  mystery_shopping_60: 'a látogatás után a legfontosabb kérdések rögzítéséhez',
  mystery_shopping_61: 'Munkatársi visszaélések',
  mystery_shopping_62: 'megelőzését szolgáló rendszer',
  mystery_shopping_63: 'Kifogáskezelés',
  mystery_shopping_64: 'Rendszer',
  mystery_shopping_65: 'Bármely Mystery Shopper értékelése',
  mystery_shopping_66:
    'közvetlenül kifogásolható a munkatárs által a weboldalon',
  mystery_shopping_67: 'Minden kifogás',
  mystery_shopping_68:
    'elbírálásra kerül, és a helyi validációs csapat választ ad rá',
  mystery_shopping_69: 'Megtekintheti a statisztikát',
  mystery_shopping_70: 'a kifogásokról',
  mystery_shopping_71: 'Elemzés.',
  mystery_shopping_72:
    'A jelentéseket személyesen mutatjuk be, és azok tartalmazzák:',
  mystery_shopping_73: 'A vállalat',
  mystery_shopping_74: 'problémás területeit és aggályait',
  mystery_shopping_75: 'Dinamika',
  mystery_shopping_76: 'részlegek és szekciók szerint',
  mystery_shopping_77: 'Korreláció',
  mystery_shopping_78: 'a standardok betartása és az ügyfélelégedettség között',
  mystery_shopping_79: 'Benchmarking',
  mystery_shopping_80: 'a versenytársakkal szemben',
  mystery_shopping_81: 'Gyakorlati',
  mystery_shopping_82: 'ajánlások a szolgáltatás fejlesztésére',
  mystery_shopping_83: 'Mi különböztet meg minket?',
  mystery_shopping_84: 'Ötletbörze-üléseket tartunk',
  mystery_shopping_85:
    'Nemcsak azt javasoljuk, mit kell tenni, hanem Önnel együtt keresünk gyakorlati megoldásokat a szolgáltatással kapcsolatos problémákra.',
  mystery_shopping_86:
    'Az ötletbörze-ülések hatékony eszközt jelentenek, amely segít nekünk:',
  mystery_shopping_87:
    'Irányokat kidolgozni a termékek vagy szolgáltatások fejlesztéséhez',
  mystery_shopping_88:
    'Új bevételi források és üzleti stratégiák lehetőségeinek feltárásához',
  mystery_shopping_89:
    'Megoldásokat találni az összetett, ügyfélközpontú kihívásokra',
  mystery_shopping_90:
    'Az ügyfelek problémás pontjait pozitív élményekké alakítani',
  mystery_shopping_91: 'Videóinterjúkat készítünk',
  mystery_shopping_92:
    'Nemcsak kérdőíveket gyűjtünk – a mystery shoppertől származó élő visszajelzéseket is kapunk',
  mystery_shopping_93: 'Ezt azért tesszük, hogy:',
  mystery_shopping_94:
    'Facilitátoraink mélyinterjúkat készítenek, és hatékony visszajelzést adnak',
  mystery_shopping_95: 'Az ügyfél szemszögéből lássuk az élményt',
  mystery_shopping_96: 'Fejlesszük tartalommarketing-stratégiáját',
  mystery_shopping_97: 'Előre jelezzük az ügyfelek viselkedését',
  mystery_shopping_98: 'Ügyfélút-térképet készítünk',
  mystery_shopping_99:
    'Az ügyfélút feltérképezése segít nekünk abban, hogy az ügyfelek helyébe lépjünk, és megértsük igényeiket és kihívásaikat.',
  mystery_shopping_100: 'Az ügyfélút kialakítása a legjobb módja annak, hogy:',
  mystery_shopping_101: 'Az ügyfél szemszögéből lássuk az élményt',
  mystery_shopping_102: 'Fejlesszük tartalommarketing-stratégiáját',
  mystery_shopping_103: 'Előre jelezzük az ügyfelek viselkedését',
  mystery_shopping_104:
    'Azonosítsuk a szolgáltatásban vagy a kommunikációban fennálló hiányosságokat',
  mystery_shopping_105: 'A Mystery Shopping különböző típusait kínáljuk',
  mystery_shopping_106: 'A Mystery Shopping típusai',
  mystery_shopping_107: 'Mystery Caller',
  mystery_shopping_108:
    'Felhívja vezetőit és/vagy call centerét, hogy meghatározza a telefonon nyújtott szolgáltatás minőségét',
  mystery_shopping_109: 'Luxury Mystery Shopping',
  mystery_shopping_110:
    'A szolgáltatás ellenőrzése prémium helyszíneken, a mystery shoppe­rek speciális kategóriájának bevonásával',
  mystery_shopping_111: 'Versenytársi látogatások',
  mystery_shopping_112:
    'A legegyszerűbb módja annak, hogy megértse, hogyan működik versenytársa',
  mystery_shopping_113: 'Mystery Employee',
  mystery_shopping_114:
    'Segít megérteni munkatársa teljes munkavállalói útját (felvétel, beilleszkedés, irodai folyamatok stb.)',
  mystery_shopping_115: 'Motivációs látogatások',
  mystery_shopping_116:
    'Hasznos eszköz további szolgáltatások és/vagy termékek, illetve meghatározott termékek értékesítésének ösztönzésére',
  mystery_shopping_117: 'Online Mystery Shopper',
  mystery_shopping_118:
    'Szimulálja és méri az ügyfélélményt az Ön online áruházában, weboldalán vagy alkalmazásában',
  mystery_shopping_119: 'Értékesítés és promóciók ellenőrzése',
  mystery_shopping_120:
    'Segít azonosítani, hogyan jelennek meg a promóciók minden helyszínen, és mennyire hatékonyan működnek',
  mystery_shopping_121: 'Vásárlási és visszaküldési látogatások',
  mystery_shopping_122:
    'Segít feltérképezni a teljes folyamatot a vásárlástól a visszaküldésig az ügyfélélmény javítása érdekében',
  mystery_shopping_123: '> 20 év',
  nps_1: 'Net Promoter',
  nps_2: 'Score',
  nps_3: 'Mérje, kövesse nyomon és javítsa az ügyfélhűséget',
  nps_4: '0 és 6 közötti pontszámot adnak.',
  nps_5:
    'Lehet, hogy rossz tapasztalatuk volt, ezért valószínűleg nem vásárolnak Öntől újra, sőt másokat is lebeszélhetnek arról, hogy Öntől vásároljanak.',
  nps_6: 'Ezek azok a válaszadók, akik 7 vagy 8 pontot adnak.',
  nps_7:
    'Elégedettek a szolgáltatásával, de nem elégedettek annyira, hogy promótereknek tekintsük őket.',
  nps_8:
    'Ezek azok a válaszadók, akik 9 vagy 10 pontra értékelik vállalkozását.',
  nps_9:
    'Ez azt jelenti, hogy ajánlanák Önt egy barátjuknak vagy kollégájuknak, és ezáltal pozitívan képviselik Önt.',
  nps_10: 'Mi az NPS?',
  nps_11: 'Az ügyfél megítélését egy egyszerű kérdés alapján méri:',
  nps_12:
    'Mennyire valószínű, hogy ajánlaná a [Szervezetet/Terméket/Szolgáltatást] egy barátjának vagy kollégájának?',
  nps_13: 'Szüksége van rá a vállalatomnak?',
  nps_14: 'Az NPS az Ön fenntartható növekedése',
  nps_15: 'Értse meg az ügyfélhűség dinamikáját',
  nps_16: 'Motiválja munkatársait',
  nps_17: 'Értse meg a különböző termékekhez való viszonyulást',
  nps_18:
    'Hasonlítsa össze, hogyan viszonyulnak Önhöz és versenytársaihoz az ügyfelek',
  nps_19: 'Mit tehetek az NPS-sel?',
  nps_20: 'Milyen vállalkozások számára releváns az NPS?',
  nps_21: 'Információgyűjtési módszerek:',
  nps_22: 'Ajánlásaink az NPS alkalmazásához',
  nps_23:
    'Ez azt jelenti, hogy iránymutatásokat dolgozunk ki annak érdekében, hogy a detraktorokat promóterekké alakítsuk',
  nps_24: '„Zárt hurkú” módszerrel dolgozunk',
  nps_25:
    'Az NPS egy nyomon követésen alapuló kutatás, amelyben az ügyfélhűség változásait követjük',
  nps_26: 'Nyomon követjük a dinamikát',
  nps_27:
    'A mélyebb elemzés érdekében mindig javasoljuk a piaci szegmensében működő versenytársak értékelését',
  nps_28: 'Versenytársak értékelése',
  price_monitoring_1: 'Árfigyelés',
  price_monitoring_2: 'Kiskereskedelmi monitoring',
  price_monitoring_3:
    'Növelje értékesítési potenciálját és optimalizálja árképzési politikáját a versenytársak árainak nyomon követésével',
  price_monitoring_4:
    'A 4Service több mint 20 éve nyújt árfigyelési szolgáltatásokat világszerte',
  price_monitoring_5:
    'Képzett, saját alkalmazásban álló auditorcsapatunk rövid idő alatt ellenőrzi az árakat, így gyorsan reagálhatunk a versenytársak árainak változásaira',
  price_monitoring_6:
    'Milyen kihívások megoldásában segíthet vállalatunk az árfigyeléssel?',
  price_monitoring_7: 'A versenytársak árképzésének értékelése',
  price_monitoring_8: 'és termékpolitikájának elemzése',
  price_monitoring_9: 'Promóciók nyomon követése',
  price_monitoring_10: 'és különleges ajánlatok',
  price_monitoring_11: 'A piaci feltételek nyomon követése',
  price_monitoring_12: 'és a piaci környezet elemzése',
  price_monitoring_13: 'Értékesítési helyek ellenőrzése és kontrollja',
  price_monitoring_14: 'speciális berendezések és árukészlet tekintetében',
  price_monitoring_15: 'Termékkezelés',
  price_monitoring_16: 'termékáramlás a kereskedelemben',
  price_monitoring_17: 'A feltételek optimalizálása',
  price_monitoring_18:
    'a beszállítókkal és kereskedőkkel való jobb együttműködés érdekében',
  price_monitoring_19: 'Polcfelület mérése,',
  price_monitoring_20:
    'a termékek elhelyezésének és a készlet elérhetőségének értékelése',
  price_monitoring_21: 'Főbb mutatók és monitoringkritériumok',
  price_monitoring_22:
    'Minden adat egyetlen felületen kerül összegyűjtésre, beleértve:',
  price_monitoring_23: 'a termék',
  price_monitoring_24: 'és a márkakategória megnevezését',
  price_monitoring_25: 'elérhetőség',
  price_monitoring_26: 'promóciós anyagok',
  price_monitoring_27: 'ár',
  price_monitoring_28: 'és az akciós ajánlatok elérhetősége',
  price_monitoring_29: 'polc',
  price_monitoring_30: 'mérete',
  price_monitoring_31: 'termék',
  price_monitoring_32: 'kihelyezése',
  price_monitoring_33: 'SKU',
  price_monitoring_34: 'facing',
  price_monitoring_35: 'típus',
  price_monitoring_36: 'csomagolás',
  price_monitoring_37: 'minden egyéb',
  price_monitoring_38: 'általános információ',
  price_monitoring_39: 'Projekt előtti elemzés:',
  price_monitoring_40: 'Megvizsgáljuk',
  price_monitoring_41:
    'az Ön vállalatának ár- és termékpolitikáját, valamint az üzleti és iparági gyakorlatokat',
  price_monitoring_42: 'Biztosítjuk',
  price_monitoring_43:
    'az auditorok gyors betanítását, tesztelését és tanúsítását',
  price_monitoring_44: 'Testreszabjuk',
  price_monitoring_45: 'és beállítjuk a szoftvert',
  price_monitoring_46: 'Terepi munka:',
  price_monitoring_47: 'Kiskereskedelmi',
  price_monitoring_48: 'értékesítési pontok látogatása',
  price_monitoring_49: 'Jelentéskészítés:',
  price_monitoring_50: 'Elemzőcsapatunk',
  price_monitoring_51:
    'online jelentéseket készít a vállalat személyes fiókjaiban',
  price_monitoring_52: 'Biztosítunk',
  price_monitoring_53:
    'teljes körű fotóriportot, PPT-jelentést és Excel-jelentést a településtípus, a hálózat neve és az értékesítési pont címe szerinti bontásban',
  price_monitoring_54: 'Hogyan',
  price_monitoring_55: 'működik',
  price_monitoring_56: 'az egyedi kedvezmények mértéke',
  price_monitoring_57: 'költségszámítás',
  price_monitoring_58: 'az egyedi bónuszok mértéke',
  price_monitoring_59: 'hűségprogramok',
  price_monitoring_60: 'stb.',
  price_monitoring_61: 'Speciális szoftvereket használunk:',
  price_monitoring_62:
    'PRADATA, Shopmetrics, valamint átfogó technikai támogatást biztosítunk',
  price_monitoring_63: 'Gyors bevezetés',
  price_monitoring_64: 'és skálázás (már az első naptól)',
  price_monitoring_65: 'Minden adat megerősítve',
  price_monitoring_66: 'fotókkal és GPS-címkézéssel',
  price_monitoring_67: 'Rendelkezünk a szükséges számú',
  price_monitoring_68: 'terepi munkatárssal bármely országban',
  price_monitoring_69: 'Nagy mennyiségű',
  price_monitoring_70: 'adattal is tudunk dolgozni',
  price_monitoring_71: 'Egyedi árak monitoringja',
  price_monitoring_72:
    'Ha összetett termékekkel rendelkezik – segítünk meghatározni árstratégiáját',
  price_monitoring_73:
    'Figyelemmel kísérhetjük az egyes versenytársak árait, például:',
  price_monitoring_74: 'Alacsony',
  price_monitoring_75: 'költség',
  price_monitoring_76: 'Magas',
  price_monitoring_77: 'hatékonyság',
  price_monitoring_78: 'Excel-jelentés',
  price_monitoring_79: 'PPT-jelentés',
  price_monitoring_80: 'BI-jelentés',
  price_monitoring_81:
    'A versenytársak árazási adatai segítenek meghozni a legjobb árképzési döntéseket',
  price_monitoring_82:
    'Teljes körű fotóriportot, PPT-jelentést és Excel-jelentést biztosítunk a településtípus szerinti bontásban',
  qualitative_research_1: 'Kvalitatív',
  qualitative_research_2: 'kutatások',
  qualitative_research_3:
    'Ügyfelei cselekedeteinek és szavainak megfigyelésén keresztül gyűjtjük, elemezzük és értelmezzük az adatokat',
  qualitative_research_4: 'Értékek',
  qualitative_research_5: 'Viselkedés',
  qualitative_research_6: 'Háttér',
  qualitative_research_7: 'Elvárások',
  qualitative_research_8: 'Környezet',
  qualitative_research_9: 'Félelmek/Akadályok',
  qualitative_research_10: 'Mi áll az ügyfél választásának hátterében?',
  qualitative_research_11: 'Férfi telefonnal',
  qualitative_research_12: 'márka',
  qualitative_research_13: 'kategória',
  qualitative_research_14: 'reklám',
  qualitative_research_15: 'termék',
  qualitative_research_16:
    'A kvalitatív módszerek egyedisége abban rejlik, hogy lehetővé teszik a fogyasztói magatartás okainak és motivációinak megértését',
  qualitative_research_17:
    'A fogyasztó egy adott jelenséggel kapcsolatos attitűdjének elemzése',
  qualitative_research_18: 'Egyéni nézőpontok és tapasztalatok',
  qualitative_research_19: 'Felmérésekkel nem vizsgálható témák',
  qualitative_research_20: 'Érzékeny témák',
  qualitative_research_21: 'Nehezen elérhető célközönség',
  qualitative_research_22: 'Összetett földrajzi lefedettség',
  qualitative_research_23: 'A mélyinterjúk hasznosak az alábbiakhoz:',
  qualitative_research_24: 'Mélyinterjúk',
  qualitative_research_25:
    'A mélyinterjú olyan kvalitatív kutatási technika, amely során egyéni interjúkat készítünk a válaszadókkal, hogy feltárjuk egy adott ötlettel, programmal vagy helyzettel kapcsolatos nézőpontjaikat. A mélyinterjú részletesen vizsgálja az egyéni tapasztalatokat / percepciókat / gyakorlatokat.',
  qualitative_research_26: 'Célok:',
  qualitative_research_27: 'A társadalmi és kulturális normák jellemzése',
  qualitative_research_28: 'Nehezen elérhető célközönség',
  qualitative_research_29:
    'Megosztás és összehasonlítás (Morgan) felmérésekkel vizsgálva',
  qualitative_research_30: 'Felmérésekkel nem vizsgálható témák',
  qualitative_research_31:
    'A mélyreható fókuszcsoportok hasznosak az alábbiakhoz:',
  qualitative_research_32: 'Fókuszcsoportok',
  qualitative_research_33:
    'Az egyéni találkozók, a kialakuló beszélgetések, valamint a csoport moderátorának hatására megjelenő megnyilvánulások közötti interakciók mélyreható feltárása.',
  qualitative_research_34:
    'A közös tapasztalatok és társadalmi normák megértését szolgáló insightok generálása csoportos beszélgetésen, fókuszált diskurzuson alapuló narratív adatok segítségével.',
  qualitative_research_36: 'Előnyök:',
  qualitative_research_37:
    'A fogyasztó életmódjának és viselkedésének vizsgálata különböző valós körülmények között (otthon, az értékesítési ponton, munkahelyen stb.)',
  qualitative_research_38:
    'Insightok keresése új termékek, csomagolások fejlesztéséhez, a szolgáltatás javításához stb.',
  qualitative_research_39:
    'A mélyreható etnográfiai kutatás hasznos az alábbiakhoz:',
  qualitative_research_40: 'Etnográfiai kutatás',
  qualitative_research_41:
    'Az etnográfia olyan kvalitatív kutatási módszer, amelynek során egy adott közösségbe vagy szervezetbe beilleszkedve, közelről figyeljük meg annak viselkedését és interakcióit.',
  qualitative_research_42:
    'Az etnográfia rugalmas kutatási módszer, amely lehetővé teszi egy csoport közös kultúrájának, szokásainak és társadalmi dinamikájának mélyreható megértését. Ugyanakkor gyakorlati és etikai kihívásokkal is jár.',
  qualitative_research_43: 'Módszerek:',
  qualitative_research_44:
    'Az etnográfia a fogyasztó vizsgálata valós élethelyzetekben, valamint a termékkel/szolgáltatással való interakció során',
  qualitative_research_45: 'A velünk való együttműködés előnyei',
  qualitative_research_46:
    'Bármely célközönségből találunk válaszadókat. A toborzás minőségét pedig ellenőrizzük',
  qualitative_research_47: 'Bármilyen összetettségű toborzás',
  qualitative_research_48:
    'Moderátoraink többnyelvűek és facilitációs készségekkel rendelkeznek',
  qualitative_research_49: 'Szakértő moderátorok',
  qualitative_research_50: 'Online/offline munkavégzés',
  qualitative_research_51: 'Audio-/videófelvételeket',
  qualitative_research_52: 'biztosítunk',
  qualitative_research_53:
    'Bármely településen képesek vagyunk kvalitatív kutatást végezni',
  quantitative_research_1: 'Ügyfélelégedettség vizsgálata',
  quantitative_research_2:
    'egy adott termékkel vagy szolgáltatással kapcsolatban (SCI, NPS)',
  quantitative_research_3: 'Szegmentációs',
  quantitative_research_4: 'kutatások végzése különböző piacokon',
  quantitative_research_5: 'Piackutatás',
  quantitative_research_6: 'NPS-menedzsment',
  quantitative_research_7: 'Versenytárselemzés',
  quantitative_research_8: 'Kvantitatív',
  quantitative_research_9: 'kutatások',
  quantitative_research_10:
    'Olyan kutatási módszertan, amely objektív, numerikus és statisztikai adatok alapján vizsgálja az emberek attitűdjeire és viselkedésére vonatkozó elméleteket',
  quantitative_research_11: 'év',
  quantitative_research_12: 'CX-tapasztalat világszerte',
  quantitative_research_13: 'panel',
  quantitative_research_14: 'válaszadókból',
  quantitative_research_15: 'ország',
  quantitative_research_16: 'világszerte végzünk projekteket',
  quantitative_research_17: 'Kik vagyunk?',
  quantitative_research_18:
    'A 4Service egy globális piackutatási és CX-holding. Szakértői adatgyűjtési szolgáltatásokat kínálunk számos különböző vállalkozás számára',
  quantitative_research_19: '4Service számokban',
  quantitative_research_20: 'Számítógéppel támogatott',
  quantitative_research_21: 'webes interjúkészítés',
  quantitative_research_22:
    'Internetalapú kérdezési technika. A válaszadó kérdezőbiztos segítsége nélkül tölti ki az elektronikus kérdőívet. A kérdőív elektronikus úton küldhető el vagy a weboldalon tehető közzé.',
  quantitative_research_23: 'Számítógéppel támogatott webes interjúkészítés',
  quantitative_research_24: 'A legtöbb esetben',
  quantitative_research_25:
    'ez a módszer a legköltséghatékonyabb az anyag- és időráfordítás szempontjából',
  quantitative_research_26: 'Ez a felmérés lehetőséget biztosít',
  quantitative_research_27: 'nehezen elérhető célközönség megkérdezésére',
  quantitative_research_28: 'Széles körű lehetőségeket kínál',
  quantitative_research_29:
    'videó- és hanganyagok, valamint képek bemutatására',
  quantitative_research_30: 'A válaszadók',
  quantitative_research_31: 'a világ bármely pontján tartózkodhatnak',
  quantitative_research_32: 'Lehetővé teszi',
  quantitative_research_33:
    'az internetes közönség sajátos viselkedésének vizsgálatát. A főbb eredményekhez az ügyfél valós időben, webes felületen keresztül férhet hozzá',
  quantitative_research_34: 'Alkalmas bármilyen bizalmas,',
  quantitative_research_35:
    'érzékeny vagy személyes témához, illetve olyan kérdéshez, amelyre a válaszadók vonakodhattak válaszolni egy kérdezőbiztossal folytatott beszélgetés során',
  quantitative_research_36: '150 000+ válaszadói panel',
  quantitative_research_37:
    'Saját válaszadói panellel rendelkezünk világszerte',
  quantitative_research_38:
    'Összetett és kihívást jelentő megkeresésekkel is dolgozunk',
  quantitative_research_39:
    'A kiegészítő eszközök (közösségi média, hirdetések) használatával megtaláljuk a meghatározott célközönséget és a válaszadó részletes profilját',
  quantitative_research_40: 'Motiváljuk válaszadóinkat',
  quantitative_research_41:
    'Kidolgoztunk egy keretrendszert a hosszú kérdőívek kitöltésének ösztönzésére anyagi juttatások biztosításával',
  quantitative_research_42: 'Személyes interjúk',
  quantitative_research_43: 'tabletek használatával végzett',
  quantitative_research_44:
    'Ez a kvantitatív adatok gyűjtésének egyik fő módszere, amelynek során az interjúztató közvetlenül kommunikál a válaszadóval egy szigorúan strukturált kérdőív alapján.',
  quantitative_research_45:
    'A személyes interjúk a válaszadók munkahelyén vagy lakóhelyén, az utcán vagy kijelölt értékesítési helyeken, tablet használatával végezhetők',
  quantitative_research_46: 'Tablettel végzett személyes interjúk',
  quantitative_research_47: 'A szint meghatározása',
  quantitative_research_48:
    'a népszerűség és a márkaismertség szintjének meghatározása',
  quantitative_research_49: 'Fogyasztói szegmentáció',
  quantitative_research_50: 'vásárlási magatartásuk alapján',
  quantitative_research_51: 'A hatékonyság elemzése',
  quantitative_research_52: 'a reklámkampányé',
  quantitative_research_53: 'Ügyfélelégedettség',
  quantitative_research_54: 'mérése',
  quantitative_research_55: 'A legjobb ár meghatározása',
  quantitative_research_56: 'a termékhez vagy szolgáltatáshoz',
  quantitative_research_57: 'A fogyasztói preferenciák',
  quantitative_research_58: 'elemzése',
  quantitative_research_59: 'Annak vizsgálata',
  quantitative_research_60: 'hogyan vásárolnak a fogyasztók',
  quantitative_research_61: 'A piaci kapacitás',
  quantitative_research_62: 'felmérése',
  quantitative_research_63: 'DigSee szoftver',
  quantitative_research_64:
    'Speciális, hangrögzítéssel és GPS-szel ellátott szoftvert használunk',
  quantitative_research_65: 'Interjúztatók és szupervizorok',
  quantitative_research_66:
    'Bármilyen nyelven képesek vagyunk interjúkat készíteni, majd azokat az ügyfél által preferált nyelvre lefordítani',
  quantitative_research_67: 'Mintavétel',
  quantitative_research_68:
    'Az elemző részleg kidolgozza a válaszadók toborzási rendszerét a lehető legjobb eredmény elérése érdekében',
  quantitative_research_69: 'Számítógéppel támogatott',
  quantitative_research_70: 'telefonos interjúkészítés',
  quantitative_research_71:
    'A kvantitatív információk gyűjtésének módszertana telefonos interjúk segítségével, egyértelműen strukturált kérdőív alapján.',
  quantitative_research_72:
    'Számítógéppel támogatott telefonos interjúkészítés',
  quantitative_research_73: 'Saját call centereink vannak',
  quantitative_research_74:
    'Speciális, hangrögzítéssel és GPS-szel ellátott szoftvert használunk',
  quantitative_research_75: 'Képzett operátorok',
  quantitative_research_76:
    'Operátoraink különböző nyelveken beszélnek, képzettek, alaposan teszteltek, és folyamatosan fejlesztik készségeiket',
  quantitative_research_77: 'Adatbázisok',
  quantitative_research_78:
    'Saját adatbázisainkkal és az Ön ügyféladatbázisaival is dolgozunk',
  quantitative_research_79: 'SLA',
  quantitative_research_80:
    'Garantáljuk a minőséget, és SLA-t (Service Level Agreement) kötünk',
  quantitative_research_81: 'Célmeghatározás',
  quantitative_research_82: 'A módszertan meghatározása',
  quantitative_research_83: 'Szegmentáció és mintavétel',
  quantitative_research_84: 'Az adatgyűjtési csatornák meghatározása',
  quantitative_research_85: 'A válaszadó számára logikus kérdőív létrehozása',
  quantitative_research_86: 'Adatgyűjtési folyamat',
  quantitative_research_87: 'Minőségbiztosítás',
  quantitative_research_88: 'Elemzési technikák',
  quantitative_research_89: 'Adatfeldolgozás',
  quantitative_research_90: 'Kérdőívtervezés',
  quantitative_research_91: 'Az interjúztatók GPS-alapú helymeghatározása',
  quantitative_research_92: 'Adatellenőrzés',
  quantitative_research_93: 'A kérdőív programozása és tesztelése',
  quantitative_research_94: 'Adatvalidálás',
  quantitative_research_95:
    'Hangfelvételek készítése a GDPR-követelmények betartásával',
  quantitative_research_96: 'A kutatási munkatársak képzése és kompetenciája',
  quantitative_research_97: 'Minőségbiztosítás',
  quantitative_research_98: 'Faktorelemzés',
  quantitative_research_99: 'Szegmentáció',
  quantitative_research_100: 'Perceptuális térkép készítése',
  quantitative_research_101: 'Korreláció',
  quantitative_research_102: 'Konverziós modell',
  quantitative_research_103: 'Jaccard',
  quantitative_research_104: 'Klaszterelemzés',
  quantitative_research_105: 'stb.',
  quantitative_research_106: 'Analitikai jelentések',
  quantitative_research_107:
    'SPSS®-t és más eszközöket használunk analitikai jelentések készítéséhez különböző módszertanok alkalmazásával',
  quantitative_research_108: 'Milyen üzleti kihívások oldhatók meg:',
  quantitative_research_109: 'Milyen üzleti kihívások oldhatók meg:',
  social_responsibility_1:
    'A 4Service vállalati társadalmi felelősségvállalása',
  social_responsibility_2:
    'Csapatunk minden tagjának szívéből és lelkéből. Igyekszünk megőrizni a kedvesség szikráját minden munkatársunkban, és egy kicsit jobbá tenni a körülöttünk lévő világot',
  social_responsibility_3: 'Oktatási tevékenységek / Fiatalok támogatása',
  social_responsibility_4:
    'Gyermekeknek és diákoknak szóló ismeretterjesztő kezdeményezéseink',
  social_responsibility_5: 'Service Mania üzleti játék',
  social_responsibility_6:
    'Képzési tevékenységünk egyik fontos része a Service Mania üzleti játék.',
  social_responsibility_7:
    'A Service Mania arra ösztönöz, hogy stratégiailag gondolkodj arról, hogyan kezeld a szokatlan helyzeteket.',
  social_responsibility_8: 'Kutatási prezentáció / Diiya. Business',
  social_responsibility_9:
    'Üzleti és ügyfélperspektíva a szolgáltatási helyzetről: a 4Service kutatási eredményeinek bemutatása Victoria Skorbota, a 4Service Ukraine fejlesztési vezetője által',
  social_responsibility_10: 'Service Design workshopok',
  social_responsibility_11:
    'A Service Design módszertan a 4Service fontos részét képezi. Néhány évvel ezelőtt a DesignThinkers Academy partnerévé váltunk, és nemcsak a legjobb gyakorlatokat alkalmazzuk munkánk során, hanem aktívan képzéseket is tartunk a vezető vállalatok számára',
  social_responsibility_12: 'Jótékonyság / Önkéntesség',
  social_responsibility_13:
    'Árvaházak, idősek otthonai és önkéntes munka az ukrán hadsereg támogatására. Tevékenységünk legmeghatóbb része',
  social_responsibility_14: '#HelpEasyWith4ServiceGroup',
  social_responsibility_15:
    'A Blagomai Jótékonysági Alappal együttműködve igyekszünk ünnepi pillanatokat szerezni és segíteni azoknak, akiknek sürgős szükségük van rá',
  social_responsibility_16: 'Adománygyűjtés árvaházak és idősotthonok számára',
  social_responsibility_17:
    'A 4Service-nél több adománygyűjtést is kezdeményeztünk idősotthonok és árvaházak számára, hogy megvásároljuk a legszükségesebb alapvető dolgokat',
  social_responsibility_18: '#SaveUkraine',
  social_responsibility_19:
    'A háború sok munkatársunkat és közeli barátunkat érintette. Mindannyian annyit segítünk, amennyit csak tudunk',
  social_responsibility_20: 'Állatvédelem',
  social_responsibility_21:
    'Bárki bejöhet az irodánkba a háziállatával. Segítünk az állatmenhelyeknek, adományokat gyűjtünk élelemre, és időnként otthont is keresünk a gazdátlan állatoknak',
  social_responsibility_22: 'Állatmenhelyek támogatása',
  social_responsibility_23:
    'A gazdátlan állatoknak ugyanúgy szükségük van segítségre, mint társadalmunk minden más kiszolgáltatott tagjának.',
  social_responsibility_24:
    'Cégünk gondozásába vette a Sirius Kóbor Állatok Menhelyét (Kijevi régió, Ukrajna).',
  social_responsibility_25:
    'Kreatív kezdeményezések a gazdátlan állatok megsegítésére',
  social_responsibility_26:
    'Hogyan hívhatjuk fel ügyfeleink és partnereink figyelmét az állatmenhelyek sürgető problémájára?',
  social_responsibility_27: 'Állatbarát iroda',
  social_responsibility_28:
    'Csapatunk számos tagjának van háziállata. Olyan egészséges környezetet alakítottunk ki, ahol mindenki behozhatja kedvencét az irodába, és kényelmesen érezheti magát',
  ux_testing_1: 'UX-tesztelés',
  ux_testing_1_1: 'UX-tesztelés',
  ux_testing_2:
    'Emberi és mesterséges intelligencián alapuló megközelítés webhelyei és alkalmazásai teszteléséhez és fejlesztéséhez',
  ux_testing_3: 'Mi az UX-tesztelés',
  ux_testing_4:
    'Az UX-tesztelés segít megérteni, hogyan lépnek kapcsolatba az emberek a termékével, alkalmazásával vagy webhelyével',
  ux_testing_5: 'A navigáció nem túl egyértelmű',
  ux_testing_6: 'Fogalmam sincs, hogyan adhatok le rendelést',
  ux_testing_7: 'Nincs elég fénykép a katalógusban',
  ux_testing_8: 'Ön:',
  ux_testing_9: 'Felfedezheti a fejlesztési lehetőségeket',
  ux_testing_10:
    'Azonosíthatja a tervezési és az ügyféllel való interakció problémáit',
  ux_testing_11:
    'Megtudhatja, milyen nehézségekkel szembesül a felhasználó az oldallal való interakció során',
  ux_testing_12: 'Megfigyelheti az ügyfél útját',
  ux_testing_13:
    'Felismerheti, mikor és miért hagyja el a célközönsége az oldalt',
  ux_testing_14:
    'Meghatározhatja, mely szakaszok keltik a legkisebb és a legnagyobb érdeklődést és érzelmi reakciót',
  ux_testing_15: 'Felhasználóalapú UX-tesztelés',
  ux_testing_16:
    'A 4Service biztosítja azokat a valós felhasználói visszajelzéseket, amelyekre szüksége van ügyfélközpontú webhelyek és alkalmazások létrehozásához kvalitatív és kvantitatív módszerekkel',
  ux_testing_17:
    'Nem értem, hogyan kell használni az oldalt. Hol van elrejtve a menü?',
  ux_testing_18:
    'Szerintem túl nagy a betűk közötti távolság, a szöveg olvashatatlan',
  ux_testing_19: 'A képek átfedik egymást. Ennek így kell lennie?',
  ux_testing_20:
    'Az UX-tesztelés segít megérteni, hogyan lépnek kapcsolatba az emberek a termékével, alkalmazásával vagy webhelyével',
  ux_testing_21: 'Felhasználóalapú UX-tesztelési kutatás tervezése:',
  ux_testing_22: 'Felfedezheti a fejlesztési lehetőségeket',
  ux_testing_23:
    'A tesztelés típusának és módszerének meghatározása (kvalitatív/kvantitatív)',
  ux_testing_24: 'Hipotézisek és felhasználói forgatókönyvek kidolgozása',
  ux_testing_25: 'A teszteredmények elemzése és jelentés készítése',
  ux_testing_26: 'Két megoldás',
  ux_testing_27: 'Két megközelítést kínálunk a sikeres UX-teszteléshez',
  ux_testing_28: 'Felhasználóalapú UX-tesztelés',
  ux_testing_29: 'AI + emberalapú UX-tesztelés',
  ux_testing_30: 'Erősségeink:',
  ux_testing_31: 'Elemezni tudjuk a versenykörnyezetet',
  ux_testing_32:
    'Speciális szakértőket is bevonhatunk az interjúk lebonyolításába és azokon való részvételbe',
  ux_testing_33:
    'Különböző nyelveken is készíthetünk interjúkat, és lefordíthatjuk azokat a szükséges nyelvre',
  ux_testing_34: 'meglévő használhatósági',
  ux_testing_35: 'mutatókkal vagy szabványokkal',
  ux_testing_36: 'az Ön teljesítményét',
  ux_testing_37: 'egy versenytárs',
  ux_testing_38: 'verzióival',
  ux_testing_39: 'ugyanazon termék',
  ux_testing_40: 'Elégedettségi értékelés',
  ux_testing_41: 'NPS',
  ux_testing_42: 'Sikerességi arány',
  ux_testing_43: 'Hibaarány',
  ux_testing_44: 'Feladat elvégzésének ideje',
  ux_testing_45: 'Felhasználóalapú UX-tesztelés',
  ux_testing_46: 'Kvantitatív módszer',
  ux_testing_47:
    'Ebben a szakaszban legalább 100 embert vonunk be az UX-tesztelésbe',
  ux_testing_48:
    'Akkor releváns, ha összehasonlításra van szüksége a webhelye vagy alkalmazása:',
  ux_testing_49: 'A kvantitatív módszer mérései:',
  ux_testing_50: 'Megfigyelés',
  ux_testing_51:
    'A felhasználóval vagy felhasználók egy csoportjával töltött idő, miközben megfigyeljük a termékkel kapcsolatos viselkedésüket, ahogyan azt a mindennapi életben használják',
  ux_testing_52: 'Mélyinterjú',
  ux_testing_53:
    'Lehetővé teszi a webhelyére érkező felhasználók attitűdjeinek, meggyőződéseinek, vágyainak és tapasztalatainak megismerését. 15–20 interjú lefolytatását javasoljuk',
  ux_testing_54: 'Etnográfiai kutatás',
  ux_testing_55:
    'A válaszadók környezetében végezzük, ahol használni fogják a terméket. A megfigyelés révén alaposan megismerheti a felhasználók pszichológiáját és az érzelmi kihívásokat, amelyekkel szembesülnek.',
  ux_testing_56: 'Felhasználóalapú UX-tesztelés',
  ux_testing_57: 'Kvalitatív módszer',
  ux_testing_58:
    'Ez a módszer segít megérteni a felhasználók viselkedésének motivációit és logikáját',
  ux_testing_59: 'A következőket alkalmazzuk:',
  ux_testing_60:
    'Ügyfélút-térképet készítünk kutatásunk eredményeinek szemléltetésére',
  ux_testing_61: '30 résztvevő (férfi/nő)',
  ux_testing_62:
    'A válaszadókat előzetesen szűrjük, majd meghívjuk őket a felmérésben való részvételre',
  ux_testing_63: 'Távoli online interjúkészítés a Wantent platformon',
  ux_testing_64: 'AI + emberalapú',
  ux_testing_65: 'AI + emberalapú UX-tesztelés',
  ux_testing_66:
    'Az egyedülálló Wantent mesterségesintelligencia-technológia és valódi felhasználók kombinációja',
  ux_testing_67: 'A címsor nagy betűmérete felkeltette a figyelmet',
  ux_testing_68:
    "A felhasználók megnézik a 'hangosan beszélő' számokat, de nem olvassák el a mellettük található információkat",
  ux_testing_69:
    'A UX-tesztelés segít megérteni, hogyan lépnek kapcsolatba az emberek a termékével, alkalmazásával vagy webhelyével',
  ux_testing_70: 'Az AI + emberalapú tesztelés kutatási terve',
  ux_testing_71: 'Hogyan működik',
  ux_testing_72:
    'A Wantent egy mesterséges intelligencián alapuló content-market fit megoldás.',
  ux_testing_73:
    'A Wantent ML-technológiák alkalmazásával értékeli a webhelyek és alkalmazások hatékonyságát, elemezve a közönség érzelmi reakcióit és bevonódását.',
  ux_testing_74:
    'Az eredmények értelmezéséhez storytelling technikákat, sokszínűséget és empátiát alkalmazunk a teljesítmény és a növekedés ösztönzésére.',
  ux_testing_75:
    'A felhasználó figyelme és érzelmei az oldalak közötti átmenetek során',
  ux_testing_76:
    'Statisztikák résztvevői csoportonként (figyelem és fókusz a teljes munkamenet során)',
  ux_testing_77: 'Az oldalak konverzióinak elemzése',
  ux_testing_78: 'Figyelem és érzelmek a feladatok végrehajtása során',
  ux_testing_79: 'Megállapítások a webhely',
  ux_testing_80: 'különböző résztvevői csoportok általi észleléséről',
  ux_testing_81: 'Az oldalak közötti navigáció',
  ux_testing_82:
    'egyszerűségének és a fontos elemek megtalálásának könnyűségének elemzése',
  ux_testing_83: 'A webhelyen biztosított',
  ux_testing_84: 'információk észlelésének elemzése',
  ux_testing_85: 'A fejlesztendő területek',
  ux_testing_86:
    'meghatározása az egyes oldalakon belül (navigáció, információs blokkok stb.)',
  ux_testing_87: 'Részletesen elemezzük',
  ux_testing_88: 'A kutatás legfontosabb eredményeit',
  ux_testing_89:
    'Javaslatok a webhely és az egyes oldalak szerkezetének javítására',
  ux_testing_90: 'Gondosan választjuk ki a Usability Testing célközönségét.',
  ux_testing_91:
    'Különböző országokban, különböző nyelveken és különböző felhasználói csoportok körében végzünk kutatásokat',
  ux_testing_92: 'Alkalmazásokban is tudunk tesztelni',
  ux_testing_93:
    'és a versenytársak webhelyein, valamint összehasonlító elemzést biztosítunk',
  ux_testing_94: 'Különböző kutatási módszereket kombinálunk.',
  ux_testing_95:
    'Képzett facilitátoraink végigvezetik a résztvevőt a tesztelési folyamaton.',
  ux_testing_96: 'Tesztelést végzünk',
  ux_testing_97: 'különböző eszközökön és szoftververziókon',
  ux_testing_98: 'Miért válasszon minket?',
  wantent_1: '4Service x',
  wantent_2: 'Wantent',
  wantent_3:
    'A 4Service és a Wantent egyedülálló partneri projektje © A mesterséges intelligencia és az emberalapú megközelítés kombinációja a tartalomelemzéshez',
  wantent_4: 'a siker mérése a tartalom közzététele előtt',
  wantent_5: 'a sokszínűséggel kapcsolatos problémák kockázatainak mérséklése',
  wantent_6: 'mélyreható betekintések és ajánlások a tartalom javításához',
  wantent_7: 'objektív döntések a tartalomról és a marketingstratégiáról',
  wantent_8:
    'A Wantent egy mesterséges intelligencián alapuló content-market fit megoldás.',
  wantent_9:
    'A Wantent egy mesterséges intelligencián alapuló megoldás a tartalom és a piac összehangolására. A Wantent ML-technológiák alkalmazásával értékeli a videotartalmak hatékonyságát, elemzi az érzelmi reakciókat és a közönség bevonódását.',
  wantent_10:
    'A Wantent segít meghatározni a content-market fitet és maximalizálni a tartalom hatékonyságát az alábbiak révén:',
  wantent_11: 'Forgatókönyv beállítása és résztvevők toborzása',
  wantent_12: 'személyre szabott projekttervezés és közönség világszerte',
  wantent_13: 'A nézők reakcióinak összegyűjtése',
  wantent_14: 'részletes és egyértelmű visszajelzés a közönségtől',
  wantent_15: 'A tartalom észlelésének elemzése',
  wantent_16: 'a viselkedés és az érzelmi reakciók AI-alapú elemzése',
  wantent_17: 'Elemzések átadása a végső összegzéshez',
  wantent_18: 'fejlesztési javaslatok',
  wantent_19: 'A Wantent maximalizálja a tartalom hatékonyságát',
  wantent_20: 'Reklámkoncepció előzetes tesztelése',
  wantent_21: 'Kreatív koncepció tesztelése',
  wantent_22:
    'A jövőbeli kreatív és a kidolgozott stratégia összhangjának ellenőrzése, valamint a célközönség reakcióinak megértése a kreatív koncepciók/üzenetek lehetséges módosításához',
  wantent_23: 'A márkaelemek láthatóságának tesztelése (utómunka)',
  wantent_24: 'A reklám-/szponzorációs befektetés hatékonyságának megerősítése',
  wantent_25: 'Reklámtesztelés',
  wantent_26: 'A/B tesztelés',
  wantent_27:
    'A kreatív anyagok hatékonyságának összehasonlítása, valamint a bevonódás és a figyelem növelése a gyártási szakaszban',
  wantent_28: 'Már elindított reklám tesztelése',
  wantent_29:
    'Az üzenetek teljesítményének meghatározása és ajánlások készítése a hanganyag és a vizuális elemek javítására',
  wantent_30: 'Megoldások televízióhoz',
  wantent_31:
    'Pilotok, promóciós anyagok, új formátumok, TV-műsorvezetők tesztelése',
  wantent_32:
    'Összehasonlító elemzés végzése a leginkább bevonó változat azonosítására és annak megerősítésére',
  wantent_33: 'TV-műsorok és játékfilmek tesztelése',
  wantent_34:
    'A nézők bevonódásának, figyelmi szintjének és érzelmi reakcióinak elemzése hosszú tartalmak természetes körülmények között történő megtekintése során. Automatikusan azonosítjuk a közönség érdeklődésének csúcspontjait és a figyelemelterelés pillanatait a videóvágás értékelése és javítása érdekében',
  wantent_35: 'UI/UX-tesztelés',
  wantent_36: 'Webhelyprototípusok és mobilalkalmazások tesztelése',
  wantent_37:
    'A felhasználói reakciók és érzelmek elemzése a Wantent technológiájával:',
  wantent_38: 'figyelmi szint',
  wantent_39: 'érzelmi reakciók',
  wantent_40: 'a résztvevők tekintetének irányát ábrázoló hőtérképek',
  wantent_41:
    'A weboldal és az alkalmazás használhatóságának elemzése a résztvevők visszajelzései alapján:',
  wantent_42: 'Rendszerhasználhatósági skála (SUS)',
  wantent_43: 'Ügyfélerőfeszítés-mutató (az interakció egyszerűsége)',
  wantent_44: 'Net Promoter Score (NPS)',
  wantent_45: 'GDPR-megfelelés és a felhasználók adatainak védelme',
  wantent_46:
    'A Wantent teljes mértékben megfelel a GDPR- és CCPA-előírásoknak, valamint betartja a résztvevők személyes adatainak gyűjtésére, tárolására, feldolgozására és védelmére vonatkozó elveket',
  wantent_47: 'Nikita Lobyntsev',
  wantent_48: 'CDO, Reface (Média és szórakoztatóipar)',
  wantent_49:
    'Nap mint nap rengeteg új tartalomötlettel kísérletezünk gépi tanulási technológiák segítségével. A Wantent segít megérteni és értékelni a kockázatokat és előnyöket, feltárni a felhasználói visszajelzéseket, viselkedést és percepciókat, valamint megérteni megoldásaink különböző aspektusainak ok-okozati összefüggéseit.',
  wantent_50: 'Alexander Smirnov',
  wantent_51: 'a TABASCO társtulajdonosa (Reklámipar)',
  wantent_52:
    'A Wantent valóban egyedülálló szolgáltatást nyújt, amely segít megismerni a fogyasztók preferenciáinak és ellenérzéseinek legapróbb részleteit is. Nincs lehetőség csalásra, nincs lehetőség hazudni – a Wantent mindig tudja az igazságot, így marketinges szakértőként felbecsülhetetlen értékű (hahaha – pontosan ismerjük az árát, és megfizethető) iránymutatást kapunk kommunikációnk fejlesztéséhez.',
  wantent_53: 'Vélemények',
  terms_1: 'Felhasználási feltételek',
  terms_2: 'Felhasználási megállapodás',
  terms_3:
    'Kérjük, figyelmesen olvassa el ezt a Felhasználási megállapodást („felhasználási feltételek”, „megállapodás”), mielőtt használni kezdi a weboldalt',
  terms_4:
    '(„weboldal”), amelyet a 4Service Holdings GmbH („4Service”, „mi”, „minket”, „miénk”) üzemeltet.',
  terms_5:
    'Használati feltételekA weboldal használatával Ön kijelenti, hogy elolvasta és áttekintette ezt a Megállapodást, és vállalja annak feltételeinek betartását. Ha nem kívánja magára nézve kötelezőnek elfogadni a Megállapodás feltételeit, kérjük, hagyja el a weboldalt. A 4Service kizárólag azoknak biztosítja a weboldal, termékei és szolgáltatásai használatát és az azokhoz való hozzáférést, akik elfogadták a feltételeket.',
  terms_6: 'Adatvédelmi szabályzat',
  terms_7:
    'Mielőtt folytatná weboldalunk használatát, javasoljuk, hogy olvassa el az adatainak gyűjtésére vonatkozó Adatvédelmi szabályzatunkat. Ez segít Önnek jobban megérteni adatkezelési gyakorlatunkat.',
  terms_8: 'Korhatár',
  terms_9:
    'A weboldal használatához legalább 16 (tizenhat) évesnek kell lennie. A weboldal használatával Ön garantálja, hogy legalább 16 (tizenhat) éves, és jogszerűen elfogadhatja ezt a Megállapodást. A 4Service nem vállal felelősséget az életkor valótlan feltüntetéséből eredő kötelezettségekért.',
  terms_10: 'Szellemi tulajdon',
  terms_11:
    'Ön elfogadja, hogy a weboldalon biztosított valamennyi anyag, termék és szolgáltatás a 4Service, kapcsolt vállalkozásai, igazgatói, tisztségviselői, alkalmazottai, ügynökei, beszállítói vagy licencadói tulajdonát képezi, beleértve valamennyi szerzői jogot, üzleti titkot, védjegyet, szabadalmat és egyéb szellemi tulajdonjogot. Ön azt is elfogadja, hogy a 4Service szellemi tulajdonát semmilyen módon nem sokszorosítja vagy terjeszti újra, beleértve az elektronikus, digitális vagy új védjegybejegyzéseket is.',
  terms_12: 'Weboldalunk elérése',
  terms_13:
    'Weboldalunkhoz való hozzáférés ideiglenes jelleggel engedélyezett, és fenntartjuk a jogot arra, hogy értesítés nélkül visszavonjuk vagy módosítsuk az általunk a weboldalon nyújtott szolgáltatást. Nem vállalunk felelősséget azért, ha weboldalunk bármilyen okból bármikor vagy bármely időszakban nem érhető el. Időről időre korlátozhatjuk weboldalunk egyes részeihez vagy teljes egészéhez való hozzáférést az általunk regisztrált felhasználók számára. Ön felelős minden olyan intézkedés megtételéért, amely a weboldalunkhoz való hozzáféréshez szükséges, beleértve a weboldalunkkal kompatibilis eszközök használatát. Ön továbbá felelős azért, hogy az internetkapcsolatán keresztül weboldalunkhoz hozzáférő valamennyi személy tisztában legyen ezekkel a feltételekkel, és betartsa azokat.',
  terms_14: 'Alkalmazandó jog',
  terms_15:
    'A weboldal meglátogatásával Ön elfogadja, hogy ezekre a feltételekre, illetve a 4Service és Ön között esetlegesen felmerülő bármilyen vitára az Osztrák Köztársaság joga irányadó, a kollíziós jogi elvek figyelembevétele nélkül.',
  terms_16: 'Jogviták',
  terms_17:
    'A weboldal Ön általi látogatásával bármilyen módon kapcsolatos jogvitát a Bécsi Kereskedelmi Bíróság előtt kell választottbírósági eljárásban rendezni.',
  terms_18: 'Kártalanítás',
  terms_19:
    'Ön vállalja, hogy kártalanítja a 4Service-t és kapcsolt vállalkozásait, valamint mentesíti a 4Service-t minden olyan jogi igénnyel és követeléssel szemben, amely weboldalunk Ön általi használatából vagy helytelen használatából eredhet. Fenntartjuk a jogot saját jogi képviselőnk kiválasztására.',
  terms_20: 'A tárolás időtartama',
  terms_21:
    'Az adatkezelés céljait figyelembe véve a Felhasználók személyes adatainak tárolási időtartama (megőrzési idő) 24 hónap attól a naptól számítva, amikor az adatkezeléshez szükséges hozzájárulást Öntől megfelelően megkaptuk.',
  terms_22: 'A felelősség korlátozása',
  terms_23:
    'A 4Service nem vállal felelősséget az olyan károkért, amelyek weboldalunk Ön általi helytelen használata következtében érhetik Önt. A 4Service fenntartja a jogot, hogy előzetes értesítés nélkül bármikor szerkessze, módosítsa és megváltoztassa ezt a Megállapodást a jelen közzététel frissítésével. A weboldal további használata a módosítások vagy változtatások közzététele után azt jelenti, hogy Ön elfogadja ezeket a módosításokat vagy változtatásokat. Ha a Megállapodás bármely része jogellenesnek, semmisnek vagy végrehajthatatlannak minősül, az adott rész elválaszthatónak tekintendő, és nem érinti a fennmaradó rendelkezések érvényességét és végrehajthatóságát. A weboldal illegális célú használatára utaló esetleges bizonyítékokat átadjuk a bűnüldöző hatóságoknak. Ez a Megállapodás a 4Service és a felhasználó közötti megállapodást képezi.',
  terms_24:
    'Kérjük, minden adatvédelemmel vagy használattal kapcsolatos kérdését és aggályát az alábbi címre küldje:',
  terms_25: '4Service Holdings GmbH',
  terms_26: 'Tegetthoffstrasse 7',
  terms_27: '1010 Bécs',
  terms_28: 'Ausztria',
  terms_29: 'Helyesbítés',
  terms_30:
    'Amennyiben az Ön által megadott személyes adatok pontatlanok, jogosult kérni azok helyesbítését (GDPR 16. cikk).',
  thank_you_1: 'Köszönjük!',
  thank_you_2: '24 órán belül felvesszük Önnel a kapcsolatot',
  thank_you_3:
    'Ui.: Menedzsereink már áttekintik kérését, hogy összeállítsák az Ön számára legmegfelelőbb ajánlatot',
  thank_you_4: 'Menü',
  thank_you_5: 'Nő gépel',
  privacy_policy_1:
    'Adatvédelmi tájékoztató az érintettek (a weboldal felhasználói) számára',
  privacy_policy_2:
    'Jelen Adatvédelmi tájékoztató (Adatvédelmi tájékoztató) azon természetes személyeknek (Érintettek) szól, akiknek személyes adatait a 4Service Holdings GmbH gyűjti a GDPR követelményeivel összhangban a weboldal látogatása során',
  privacy_policy_3:
    '(a továbbiakban Weboldal, illetve a Weboldal Felhasználói/Felhasználók).',
  privacy_policy_4:
    'A 4Service Holdings GmbH Érintettek (a Weboldal Felhasználói) számára készült Adatvédelmi tájékoztatója a 4Service Csoport valamennyi olyan vállalatára vonatkozik, amelyek jogi hatáskörük, felügyeletük vagy ellenőrzésük tekintetében a 4Service Holdings GmbH alá tartoznak.',
  privacy_policy_5: 'Kapcsolat',
  privacy_policy_6: '4Service Holdings GmbH',
  privacy_policy_7: '(Vállalat/mi/minket),',
  privacy_policy_8: 'Cím:',
  privacy_policy_9: 'Tegetthoffstraße 7, 1010 Bécs, Ausztria.',
  privacy_policy_10: 'E-mail:',
  privacy_policy_12: 'Kik vagyunk?',
  privacy_policy_13:
    'Olyan magánszemély (Ön), aki bármilyen célból meglátogatja a Weboldalt. Jelen Dokumentum alkalmazásában Önt Felhasználóként is megjelöljük.',
  privacy_policy_14: 'Az Öntől gyűjtött személyes adatok',
  privacy_policy_15:
    'Amikor belép Weboldalunkra, Adatvédelmi tájékoztatót küldünk Önnek, amelyben arra kérjük, hogy járuljon hozzá az alábbi információk feldolgozásához:',
  privacy_policy_16:
    'IP-cím, felhasználó keresztneve, vezetékneve, címe, telefonszáma (vezetékes vagy mobil), e-mail-címe, címe, cégneve, országa, e-mail-címe, keresztneve, vezetékneve, telefonszáma, tartománya, állama és irányítószáma, használati adatok, a külső közösségi hálózatokkal vagy platformokkal való interakcióra vonatkozó adatok, a weboldalon történő regisztrációval és hitelesítéssel kapcsolatos információk',
  privacy_policy_17: 'földrajzi helyzet.',
  privacy_policy_18:
    'Amennyiben Ön kifejezi erre irányuló szándékát és megadja hozzájárulását, megkezdjük az Öntől származó ilyen információk feldolgozását.',
  privacy_policy_19: 'Jogszerűség (hozzájárulás)',
  privacy_policy_20:
    'Amikor belép Weboldalunkra, Adatvédelmi tájékoztatót küldünk Önnek, amelyben arra kérjük, hogy járuljon hozzá az alábbi információk feldolgozásához:',
  privacy_policy_21:
    'A személyes adatok feldolgozásának jogalapja az Ön hozzájárulása, amelyet az alábbi linken található hozzájárulási űrlap kitöltésével kívánunk megszerezni:',
  privacy_policy_22:
    'Ha kitölti a hozzájárulási űrlapot, az azt jelenti, hogy megértette és elfogadja a jelen Adatvédelmi tájékoztatóban meghatározott valamennyi feltételt.',
  privacy_policy_23: 'A hozzájárulás visszavonása',
  privacy_policy_24:
    'Ön bármikor jogosult visszavonni a korábban megadott hozzájárulását. A hozzájárulás visszavonása nem érinti a visszavonás előtt a hozzájárulás alapján végzett adatkezelés jogszerűségét. Hozzájárulását az alábbi e-mail-címre küldött megfelelő kérelemmel vonhatja vissza: withdraw@4service-group.com, a kérelem űrlapja pedig az alábbi linken érhető el:',
  privacy_policy_25: 'Felhasználói hozzájárulás-visszavonási űrlap',
  privacy_policy_26: 'Az adatkezelés céljai',
  privacy_policy_27: 'Személyes adatait az alábbi célokra kezeljük:',
  privacy_policy_28:
    '– az ügyfélszolgáltatások javítása (lehetővé teszi az ügyfelek kéréseire való hatékonyabb reagálást); – a Felhasználók élményének személyre szabása (lehetővé teszi annak meghatározását, hogy kit érdekelnek jobban a szolgáltatások); – a Weboldal fejlesztése (lehetővé teszi a termékek és szolgáltatások minőségének, használatuk kényelmének javítását, új Szolgáltatások fejlesztését, valamint termékeink és szolgáltatásaink továbbfejlesztését); – kommunikáció a Felhasználóval hírlevelek, marketing- vagy promóciós anyagok és egyéb, híreinket, frissítéseinket, szolgáltatásainkkal kapcsolatos információkat tartalmazó kommunikáció révén, az utólagos e-mailek fogadásáról való leiratkozásra vonatkozó utasításokkal; – statisztikai és egyéb kutatások, valamint elemzések végzése anonimizált adatok alapján; – személyre szabott szolgáltatások nyújtása a Felhasználó számára, valamint megállapodások és szerződések teljesítése; – a Felhasználó részvétele az általunk a Weboldalon keresztül megvalósított különböző projektekben, a Felhasználó Weboldalon keresztül benyújtott megkereséseire való válaszadás, kutatás, fiókok és nyilvántartások kezelése, valamint a szolgáltatások népszerűsítése.',
  privacy_policy_29:
    'Azok a személyek, akikhez a személyes adatok továbbíthatók',
  privacy_policy_30:
    'Személyes adatainak feldolgozása során személyes adatait olyan szervezeteknek továbbítjuk, amelyek a Vállalat adatfeldolgozóiként járnak el. A Vállalat adatfeldolgozói kizárólag a Vállalat utasításai alapján járnak el. A Vállalat adatfeldolgozói által végzett tevékenységek részletei és az adatfeldolgozók listája az Adatvédelmi és adatbiztonsági szabályzatban található az alábbi linken: Adatvédelmi és adatbiztonsági szabályzat',
  privacy_policy_31:
    'Azok az országok, amelyekbe a személyes adatok továbbíthatók',
  privacy_policy_32:
    'A Vállalat az Ön személyes adatait a GDPR és az Európai Bizottság által meghatározott megfelelőségi határozat alapján továbbítja. Az USA-ba történő személyesadat-továbbítással kapcsolatos további információk az Adatvédelmi és adatbiztonsági szabályzatban találhatók az alábbi linken: Adatvédelmi és adatbiztonsági szabályzat.',
  privacy_policy_33: 'A tárolás időtartama',
  privacy_policy_34:
    'Az adatkezelés céljait figyelembe véve a Felhasználók személyes adatainak tárolási időtartama (megőrzési idő) 24 hónap attól a naptól számítva, amikor az adatkezeléshez szükséges hozzájárulást Öntől megfelelően megkaptuk.',
  privacy_policy_35: 'Hozzáférési jog',
  privacy_policy_36:
    'Ön jogosult megtudni, hogy az Önre vonatkozó személyes adatok feldolgozása folyamatban van-e, és 2) amennyiben igen, jogosult hozzáférni ezekhez az adatokhoz a GDPR 15. cikkében meghatározott további rendelkezések figyelembevételével.',
  privacy_policy_37: 'Helyesbítéshez való jog',
  privacy_policy_38:
    'Amennyiben az Ön által megadott személyes adatok pontatlanok, jogosult kérni azok helyesbítését (GDPR 16. cikk).',
  privacy_policy_39: 'Törléshez való jog (az elfeledtetéshez való jog)',
  privacy_policy_40:
    'Ön jogosult arra, hogy indokolatlan késedelem nélkül kérje tőlünk személyes adatainak törlését, és kötelesek vagyunk indokolatlan késedelem nélkül törölni személyes adatait, amennyiben a GDPR 17. cikkében meghatározott feltételek fennállnak.',
  privacy_policy_41: 'Az adatkezelés korlátozásához való jog',
  privacy_policy_42:
    'Ön jogosult arra, hogy korlátozza személyes adatainak kezelését, néhány, a GDPR hatálya alá tartozó kivétellel, különösen a GDPR 18. cikkében meghatározottak szerint.',
  privacy_policy_43:
    'Kötelesek vagyunk tájékoztatni Önt arról, hogy milyen adatokat gyűjtünk, hogyan használjuk fel azokat, mennyi ideig őrizzük meg őket, és hogy megosztjuk-e azokat harmadik felekkel. Ezt az információt tömören és közérthető nyelven kell közölni.',
  privacy_policy_44: 'Az adathordozhatósághoz való jog',
  privacy_policy_45:
    'Ön jogosult személyes adatainak megszerzésére és újbóli felhasználására saját céljaira, különböző szolgáltatások között.',
  privacy_policy_46: 'Tiltakozáshoz való jog',
  privacy_policy_47:
    'Ön jogosult tiltakozni a Vállalat által végzett személyesadat-kezelés ellen. Meg kell szüntetnünk a személyes adatok kezelését, kivéve, ha olyan kényszerítő erejű jogos indokot igazolunk az adatkezelésre, amely elsőbbséget élvez az érintett érdekeivel, jogaival és szabadságaival szemben, vagy ha az adatkezelés jogi igények előterjesztéséhez, érvényesítéséhez vagy védelméhez szükséges.',
  privacy_policy_48:
    'Az kizárólag automatizált adatkezelésen alapuló döntés hatálya alá kerülés elkerüléséhez való jog',
  privacy_policy_49:
    'Ön jogosult tiltakozni minden olyan automatizált profilalkotás ellen, amely hozzájárulás nélkül történik. Ezen túlmenően Ön jogosult arra, hogy személyes adatait emberi beavatkozással kezeljék.',
  privacy_policy_50: 'Panaszok',
  privacy_policy_51:
    'Amennyiben panaszt kíván tenni azzal kapcsolatban, hogy a Vállalat (vagy a fent leírt adatfeldolgozók) hogyan kezeli személyes adatait, illetve hogyan kezelték panaszát, Ön jogosult közvetlenül a felügyeleti hatóságnál és a Vállalatnál panaszt benyújtani.',
  privacy_policy_52: 'Az egyes kapcsolattartási lehetőségek adatai:',
  privacy_policy_53: 'Felügyeleti hatóság:',
  privacy_policy_54: 'Osztrák Adatvédelmi Hatóság',
  privacy_policy_55: 'Österreichische Datenschutzbehörde',
  privacy_policy_56: 'Wickenburggasse 8',
  privacy_policy_57: '1080 Bécs',
  privacy_policy_58: 'Ausztria / Európa',
  privacy_policy_59: 'Vállalat:',
  privacy_policy_60: '4Service Holdings GmbH (Vállalat/mi/minket),',
  privacy_policy_61: 'Cím: Tegetthoffstraße 7, 1010 Bécs, Ausztria.',
  privacy_policy_62: 'E-mail:',
  privacy_policy_63: 'Adatvédelmi és adatbiztonsági szabályzat',
  privacy_policy_64:
    'Itt olvashat bővebben arról, hogyan és miért használjuk fel az Ön adatait: Adatvédelmi és adatbiztonsági szabályzat',
  privacy_policy_65: 'Jóváhagyás',
  privacy_policy_66:
    'A Vállalat valamennyi belső dokumentumot kidolgozta a személyes adatok Vállalaton belüli kezelésével kapcsolatos munkatársi szerepek meghatározására; különösen jelen dokumentum jogszerűségének jóváhagyásáért és felülvizsgálatáért az ügyvezető igazgató felelős.',
  contacts_1: 'Ügyfeleknek',
  contacts_2:
    'Mindenféle vállalkozás, piackutató ügynökség és nagyvállalat, üzleti partner és média számára.',
  contacts_3: 'Tegetthoffstrasse 7, Bécs, Ausztria',
  contacts_4: 'Mystery Shoppereknek',
  contacts_5:
    'Helyiek és utazók, sofőrök és diákok, professzionális mystery shopperek és otthonülők.',
  contacts_6: 'Vegye fel velünk a kapcsolatot az Ön országából:',
  contacts_7: 'Olaszország',
  contacts_8: 'USA',
  contacts_9: 'Egyesült Királyság',
  contacts_10: 'Svájc',
  contacts_11: 'Hollandia',
  contacts_12: 'Szlovákia',
  contacts_13: 'Szlovénia',
  contacts_14: 'Románia',
  contacts_15: 'AZ',
  contacts_16: 'Ukrajna',
  contacts_17: 'Kazahsztán',
  contacts_18: 'A világ többi része',
  menu_1: 'CJM',
  menu_2: 'NPS',
  menu_3: 'CSI',
  menu_4: 'BHT',
  menu_5: 'UX-tesztelés',
  menu_6: 'HR-kutatás',
  menu_7: 'Kvalitatív kutatás',
  menu_8: 'Kvantitatív kutatás',
  menu_9: 'Mystery Shopping',
  menu_10: 'Voicer',
  menu_11: 'Play4Sales',
  menu_12: 'Wantent',
  menu_13: 'Árfigyelés',
  menu_14: 'Rólunk',
  menu_15: 'Kapcsolat',
  menu_16: 'Blog',
  menu_17: 'Módszerek',
  menu_18: 'Termékek',
  menu_19: 'Mystery Shopper \n platform',
  menu_20: 'CSR',
  menu_21: 'Autóipari árak elemzése',
  menu_22: 'Létesítmény-ellenőrzési audit',
  menu_23: 'Szolgáltatástervezés',
  menu_24: 'CX',
  nps_passives: 'Passzívak',
  nps_detractors: 'Kritikusok',
  nps_promoters: 'Promóterek',
  nps_a_score: 'pontszám',
  area: 'Terület',
  products_tabs_1:
    'A maximális hatékonyság elérése érdekében összetett kutatásokat is végzünk:',
  products_tabs_2: 'Termékek',
  products_tabs_3:
    'A kvalitatív kutatás nem numerikus adatok gyűjtését és elemzését jelenti a fogalmak, vélemények vagy tapasztalatok megértése érdekében',
  products_tabs_4:
    'A kvantitatív kutatási módszerek objektív mérést és a közvélemény-kutatások, kérdőívek és felmérések során gyűjtött adatok numerikus elemzését jelentik',
  our_clients_1: 'Ügyfeleink',
  preview_cases_section_1: 'Esettanulmányok',
  preview_cases_section_2:
    'Látogasson el az esettanulmányokhoz további érdekes bejegyzésekért',
  blog_1: 'Érdekes tartalmak blogja',
  blog_2: 'A kéréséhez nem érhető el bejegyzés',
  about: 'Rólunk',
  why_us: 'Miért mi?',
  about_us: 'Rólunk',
  key_features: 'Főbb jellemzők',
  solutions: 'Megoldások',
  monitoring: 'Monitoring',
  how: 'Hogyan',
  how_it_works: 'Hogyan működik',
  when_to_use: 'Mikor használható',
  mystery_shopping: 'Mystery Shopping',
  voicer: 'Ügyfélhang',
  wantent: 'Videótartalom-tesztelés',
  play4sales: 'Play4Sales',
  price_monitoring: 'Árfigyelés',
  service_design: 'Szolgáltatástervezés',
  qualitative_research: 'Kvalitatív kutatás',
  quantitative_research: 'Kvantitatív kutatás',
  cawi: 'CAWI',
  f2f: 'F2F',
  cati: 'CATI',
  hashtag_automotive: '#Automotive',
  hashtag_retayl: '#Retail',
  hashtag_all_posts: '#All_posts',
  hashtag_feedback: '#feedback',
  hashtag_4Service_csr: '#4Service_CSR',
  hashtag_cases: '#Cases',
  hashtag_market_research: '#market_research',
  more: 'Több',
  speak_to_an_expert: 'Beszéljen szakértőnkkel',
  book_consultancy: 'Tanácsadás lefoglalása',
  read_all: 'Összes elolvasása',
  find_out_more: 'Tudjon meg többet',
  address: 'Cím',
  mon_fri: 'Hétfő–péntek',
  phone_number: 'Telefonszám',
  flag: 'zászló',
  scroll_to_left: 'görgetés balra',
  online: 'online',
  tel: 'Tel.',
  email: 'E-mail',
  light_it_up: 'Tegye ragyogóvá',
  about_us_60: 'Alina Andreieva',
  about_us_61: 'Üzletfejlesztési igazgató',
  about_us_62: 'Julia Kravchenko',
  about_us_63: 'Senior projektmenedzser',
  about_us_64: 'Olga Aksonova',
  about_us_65: 'Üzletfejlesztési menedzser',
  about_us_66: 'Zhelevskiy Dmitriy',
  about_us_67: 'Operációs igazgató',
  about_us_roles_1: 'Vezetőség',
  about_us_roles_2: 'Globális csapat',
  about_us_roles_3: 'Terméktulajdonosok',
  ad_testing_1: 'Reklámtesztelés',
  ad_testing_2:
    'Egy reklámkampány hatalmas befektetés. Győződjön meg róla, hogy reklámjai hatásosak és maximális ROI-t biztosítanak',
  ad_testing_3: 'zár',
  ad_testing_4: 'Iparágak, amelyekben szolgáltatást nyújtunk',
  ad_testing_5: 'A 4Service globális ügyfélélmény-kutatási holding',
  ad_testing_6:
    'A 4Service globális marketingkutatási és CX holding. Széles körű vállalkozások számára kínálunk szakértői adatgyűjtési szolgáltatásokat',
  ad_testing_7: 'Cash & Carry',
  ad_testing_8: 'Kiskereskedelem',
  ad_testing_9: 'Elektronika',
  ad_testing_10: 'Luxus/Premium',
  ad_testing_11: 'Vendéglátás és szállodaipar',
  ad_testing_12: 'Autóipar',
  ad_testing_13: 'Utazás és szabadidő',
  ad_testing_14: 'Divat',
  ad_testing_15: 'Bankok',
  ad_testing_16: 'Órák és ékszerek',
  ad_testing_17: 'Háztartási cikkek és készülékek',
  ad_testing_18: 'Esomar-tag',
  ad_testing_19:
    'Különböző területeken működő vállalkozások reklámjait teszteltük reklámtesztelési kutatások keretében',
  ad_testing_20: 'Reklámtesztelésre van szüksége, ha Ön',
  ad_testing_21: 'Új terméket vagy szolgáltatást népszerűsít',
  ad_testing_22: 'Érzékeny témát érint',
  ad_testing_23: 'Új célcsoportot vagy piacot próbál elérni',
  ad_testing_24: 'Több különböző dizájnopciót mérlegel',
  ad_testing_25:
    'Koncepcióigazolásra van szüksége a vezetőség vagy a befektetők számára',
  ad_testing_26: 'Válaszokat kap az alábbi kérdésekre',
  ad_testing_27:
    'Mely reklámcsatornák a legalkalmasabbak ezekhez a hirdetésekhez?',
  ad_testing_28:
    'A megfelelő vizuális elemeket használjuk az üzenet közvetítéséhez?',
  ad_testing_29:
    'Összhangban vannak a reklámszövegek és üzenetek a célközönség elvárásaival?',
  ad_testing_30:
    'Mely reklámcsatornák a legalkalmasabbak ezekhez a hirdetésekhez?',
  ad_testing_31: 'Mi kelti fel először a figyelmüket?',
  ad_testing_32: 'Könnyen érthető a reklám elhelyezése és elrendezése?',
  ad_testing_33: 'Értékeljük',
  ad_testing_34: 'Márkaelemek',
  ad_testing_35:
    'hogyan kapcsolódik márkája a reklámhoz, és mennyire lesz emlékezetes',
  ad_testing_36: 'Főbb mutatók',
  ad_testing_37: 'Integráció',
  ad_testing_38: 'Felismerés',
  ad_testing_39: 'Illeszkedés',
  ad_testing_40: 'Kreatív',
  ad_testing_41:
    'Hogyan emelkedik ki reklámja a többi közül, és hogyan kelti fel az emberek figyelmét',
  ad_testing_42: 'Főbb mutatók',
  ad_testing_43: 'FELISMERÉS',
  ad_testing_44: 'KEDVELTSÉG',
  ad_testing_45: 'MTO',
  ad_testing_46: 'MOTIVÁCIÓ',
  ad_testing_47: 'Ügyfélélmény, érzelmi bevonódás',
  ad_testing_48:
    'Mesterségesintelligencia-technológia és szakértő elemzők segítségével elemezzük az emberek valós érzelmeit, és betekintést nyerünk abba, hogyan érzékelik a reklámokat',
  ad_testing_49: 'Értékelés',
  ad_testing_50: 'Férfi',
  ad_testing_51: 'Nő',
  ad_testing_52: 'Magas bevonódás',
  ad_testing_53: 'Figyelem',
  ad_testing_54: 'Mit kedvelt és mire emlékezett a közönség?',
  ad_testing_55: 'Színésznő',
  ad_testing_56: 'Egyenlőség',
  ad_testing_57: 'Zenei háttér',
  ad_testing_58: 'Pozitív érzelmek',
  ad_testing_59: 'Különböző rasszú és megjelenésű emberek',
  ad_testing_60: 'Kültéri felvételek',
  ad_testing_61: 'Mit NEM kedvelt és mire NEM emlékezett a közönség?',
  ad_testing_62: 'Az előadó hangja nem illett ahhoz, ami a képernyőn történt',
  ad_testing_63: 'Alacsony figyelem a termékre',
  ad_testing_64: 'Túl dinamikus',
  ad_testing_65: 'Nehezen érthető',
  ad_testing_66: 'TRP',
  ad_testing_67: 'Megjelenések',
  ad_testing_68: 'Megjelenítések',
  ad_testing_69: 'Konverzió',
  ad_testing_70: 'Média',
  ad_testing_71:
    'A reklámkampány hatékonyságát a médiaaktivitással együtt mérjük, kiszámítva a különböző csatornákba fektetett médiabefektetések hatását a mért eredményekre.',
  ad_testing_72:
    'Bármilyen formátumban, platformon vagy csatornán végzünk reklámkutatást',
  ad_testing_73: 'videótartalom',
  ad_testing_74: 'köztéri reklám',
  ad_testing_75: 'TV-reklámok',
  ad_testing_76: 'nyomtatott sajtó',
  ad_testing_77: 'digitális',
  ad_testing_78: 'reklámkampányok',
  ad_testing_79: 'POS-kihelyezés és reklám',
  ad_testing_80: 'animatikok',
  ad_testing_81: 'Segítségünkkel a reklámját bármely szakaszban tesztelheti',
  ad_testing_82: 'Koncepció',
  ad_testing_83: 'mely ötletekben rejlik nagyobb potenciál?',
  ad_testing_84: 'A gyártás korai szakasza',
  ad_testing_85: 'mely animatikok kerüljenek gyártásba?',
  ad_testing_86: 'Gyártás',
  ad_testing_87:
    'hogyan szerkesszük a videót úgy, hogy fenntartsa a figyelmet?',
  ad_testing_88: 'Média előtti szakasz',
  ad_testing_89:
    'mely kommunikációs csatornák működnek majd, és milyen eredmény várható?',
  ad_testing_90: 'Reklám utáni tesztelés',
  ad_testing_91: 'Gyártás',
  ad_testing_92:
    'leköti a reklámom a közönség figyelmét? Csökken a kreatív hatékonysága idővel?',
  ad_testing_93: 'Média előtti szakasz',
  ad_testing_94:
    'mennyire hatékony a reklámom számokban? hogyan teljesít a versenytársakhoz képest?',
  ad_testing_95: 'Reklám előzetes tesztelése',
  ad_testing_96:
    'A kiváló minőségű adatok biztosításához a következőket használjuk',
  ad_testing_97: 'Kvantitatív kutatási módszertan',
  ad_testing_98: 'CAWI',
  ad_testing_99: 'Kvalitatív kutatási módszertan',
  ad_testing_100: 'Fókuszcsoportok',
  ad_testing_101: 'AI',
  ad_testing_102: 'Wantent',
  ad_testing_103: 'Az Ön által kapott analitikai jelentések',
  ad_testing_104:
    'Elemzőkből, médiaszakértőkből és marketingesekből álló csapatunk részletes ajánlásokat tartalmazó, személyre szabott jelentést készít és mutat be Önnek',
  ad_testing_age: 'életkor',
  ad_testing_ad: 'Reklám',
  automotive_industry_price_analysis_1: 'Autóipari árak elemzése',
  automotive_industry_price_analysis_2:
    'A versenytársak árainak elemzése segíthet megelőzni a profitveszteséget, növelni a piaci részesedést és nyomon követni piaci pozícióját. Bízza ránk egy sikeres versenystratégia kialakítását!',
  automotive_industry_price_analysis_3: 'Árajánlat kérése',
  automotive_industry_price_analysis_4: 'Módszertanunk',
  automotive_industry_price_analysis_5:
    'Stílusos, elegáns emberek az autószalonban',
  automotive_industry_price_analysis_6:
    'A Mystery Shopping módszer az egyetlen olyan megközelítés, amely pontosan tükrözi a valós ügyfélélményt, és megbízható átfogó képet biztosít.',
  automotive_industry_price_analysis_7:
    'Pontos adatokat és megbízható, sokoldalú információkat biztosítunk',
  automotive_industry_price_analysis_8:
    'Globális lefedettséggel rendelkezünk a világ minden országában',
  automotive_industry_price_analysis_9:
    'Saját erőforrásaink közé tartoznak a mystery shop­perek és auditorok',
  automotive_industry_price_analysis_10: 'Ellenőrizzük adataink minőségét',
  automotive_industry_price_analysis_11: 'Előnyeink:',
  automotive_industry_price_analysis_12:
    'Az egyes versenytársak modelljeinek árfigyelése (B2B és B2C)',
  automotive_industry_price_analysis_13: 'Kedvezmények mértékének figyelése',
  automotive_industry_price_analysis_14:
    'A kiskereskedők készletének figyelése az Ön márkája és versenytársai esetében',
  automotive_industry_price_analysis_15:
    'Az autóipari e-kereskedelmi árak figyelése',
  automotive_industry_price_analysis_16: 'Az árkommunikáció elemzése',
  automotive_industry_price_analysis_17:
    'A kiskereskedők szállítási költségeinek nyomon követése',
  automotive_industry_price_analysis_18:
    'Akciók és értékesítési kampányok figyelése a kiskereskedőknél',
  automotive_industry_price_analysis_19:
    'A havi törlesztőrészletek meghatározása',
  automotive_industry_price_analysis_20: 'Lízingdíjak kiszámítása',
  automotive_industry_price_analysis_21:
    'Az elektromos járművek (EV-k) speciális árazási szempontjainak elemzése',
  automotive_industry_price_analysis_22:
    'A közvetlen értékesítési és kiskereskedelmi árak összehasonlítása',
  automotive_industry_price_analysis_23:
    'Előfizetéses árazási modellek kidolgozása',
  automotive_industry_price_analysis_24:
    'A 4Service globális ügyfélélmény-kutatási (CX) holding, több mint 20 éves tapasztalattal',
  automotive_industry_price_analysis_25:
    'A fogyasztók különböző funkciókért való fizetési hajlandóságára vonatkozó adatokat használhatja ajánlata optimalizálására, valamint a célügyfelek számára legfontosabb funkciók azonosítására.',
  automotive_industry_price_analysis_26:
    'A 4Service autóipari árelemzése magában foglalja:',
  automotive_industry_price_analysis_27:
    'A legalacsonyabb árak nem mindig jelentik a versenyképesség kulcsát az autómárkák számára. Segítünk hosszú távú árstratégia kialakításában',
  automotive_industry_price_analysis_28:
    'az ügyfelek megértik, hogy az árak minden márkánál emelkednek',
  automotive_industry_price_analysis_29: '29',
  automotive_industry_price_analysis_30:
    'az ügyfelek azt mondták, hogy akkor is megvásárolnák a nekik tetsző autót, ha a márka előre tájékoztatná őket a közelgő áremelésről,',
  automotive_industry_price_analysis_31: '31',
  automotive_industry_price_analysis_32:
    'az emberek számára a lízinget és a havi törlesztőrészleteket tartják a legelőnyösebb autóvásárlási modellnek',
  automotive_industry_price_analysis_33: '48',
  automotive_industry_price_analysis_34:
    'a kereskedők megemlítették az áremelés lehetőségét a kommunikációs/értékesítési folyamat során',
  automotive_industry_price_analysis_35: '47,6',
  automotive_industry_price_analysis_36: 'Főbb számadatok',
  automotive_industry_price_analysis_37:
    'Meg fogja tudni határozni, hogyan árazza termékét a modellpaletta többi járművéhez képest.',
  automotive_industry_price_analysis_38:
    'A fogyasztók különböző funkciókért való fizetési hajlandóságára vonatkozó adatokat használhatja ajánlata optimalizálására, valamint a célügyfelek számára legfontosabb funkciók azonosítására.',
  automotive_industry_price_analysis_39:
    'az ügyfelek azt mondták, hogy akkor is megvásárolnák a nekik tetsző autót, ha a márka előre tájékoztatná őket a közelgő áremelésről',
  automotive_industry_price_analysis_40:
    'Meg tudja határozni a megfelelő havi törlesztőrészletet és lízingdíjakat.',
  automotive_industry_price_analysis_41:
    'Milyen előnyöket szerez márkája vagy kereskedése:',
  automotive_industry_price_analysis_42: 'Ön benyújtja a kérelmet',
  automotive_industry_price_analysis_43:
    'Menedzserünk felveszi Önnel a kapcsolatot a fő célkitűzések meghatározása érdekében',
  automotive_industry_price_analysis_44: 'Marketingkutatást végzünk',
  automotive_industry_price_analysis_45:
    'Rendszeresen online formátumban biztosítunk jelentéseket és ajánlásokat',
  automotive_industry_price_analysis_46: 'Autó eladási matricával',
  automotive_industry_price_analysis_47: 'A projektet 1 nap alatt elindítjuk!',
  automotive_industry_price_analysis_48:
    'Átfogó jelentéscsomagot kínálunk, amely fotóriportokat, PPT-jelentéseket és Excel-jelentéseket tartalmaz, a településtípus szerint szegmentálva',
  retail_audit_1: 'TEREPI MARKETINGAUDIT/kiskereskedelmi audit',
  retail_audit_2:
    'Gyűjtsön részletes adatokat üzletéről vagy márkájáról, elemezze a növekedést akadályozó tényezőket, és dolgozzon ki hatékony stratégiákat azok leküzdésére',
  retail_audit_3: 'Árajánlat kérése',
  retail_audit_4:
    'A 4Service a márkák megbízásából helyszíni üzletauditokat végez, hogy felmérje promóciós stratégiáik, terepi végrehajtó csapataik és marketingtaktikáik hatékonyságát a kívánt célpiac elérésében.',
  retail_audit_5:
    'Aprólékosan figyelemmel kísérjük a promóciós kampányok végrehajtását, és biztosítjuk a promóciós irányelvek betartását.',
  retail_audit_6: 'Top 10',
  retail_audit_7: 'CX-ügynökség Európában',
  retail_audit_8: 'éves tapasztalat',
  retail_audit_9: 'országos lefedettség',
  retail_audit_10: '1,6 millió',
  retail_audit_11: 'értékelés évente',
  retail_audit_12: 'Mit követünk nyomon?',
  retail_audit_13:
    'Az értékesítési pontokon (POS) elhelyezett anyagok jelenléte',
  retail_audit_14:
    'A márkanagykövetek jelenléte és aktivizálása, a tervezett ütemterv betartásának biztosítása',
  retail_audit_15:
    'A márkanagykövetek részvételének értékelése az advocacy kampányokban',
  retail_audit_16:
    'A fogyasztókkal való interakció értékelése, a promóciós irányelvek és a márkaüzenetek betartásának biztosítása',
  retail_audit_17: 'Csalásmegelőzési intézkedések',
  retail_audit_18:
    'Vállalkozása a field marketing audit eredményeit a következőkre használhatja:',
  retail_audit_19:
    'A költségvetésnek és a folyamatoknak való megfelelés értékelése',
  retail_audit_20:
    'A tényleges eredmények összehasonlítása a kitűzött célokkal',
  retail_audit_21: 'A marketingkampányok teljesítményének javítása ',
  retail_audit_22: 'A jövő stratégiai megtervezése',
  retail_audit_23: 'Költségcsökkentési lehetőségek azonosítása',
  retail_audit_24: 'Az értékesítési és konverziós arányok javítása',
  retail_audit_25: 'A befektetés megtérülésének (ROI) optimalizálása',
  retail_audit_26:
    'ŐK A 4SERVICE-T VÁLASZTOTTÁK KERESKEDELMI BEFEKTETÉSI PARTNERÜKKÉNT',
  retail_audit_27:
    'Egy vezető nemzetközi dohánytermék-gyártó a 4Service-szel együttműködve fejlesztette márkáit és javította üzleten belüli teljesítményét. Csapataink helyszíni field marketing auditot és valós idejű fogyasztóiélmény-jelentést biztosítottak.',
  retail_audit_28:
    'a field marketing ügynökség tervezési pontosságának növekedése',
  retail_audit_29: 'a márkaüzenetek átadásának növekedése',
  retail_audit_30: 'a BA-k bevonódásának (fogyasztói aktiváció) növekedése',
  retail_audit_31:
    'az adatgyűjtés pontosságának és a GDPR-megfelelésnek a javulása',
  retail_audit_32: 'Milyen értékes felismeréseket szoktunk találni:',
  retail_audit_33:
    'Az SLA feltételei közötti következetlenség vagy akár ellentmondás jelentős, előzetesen nem jóváhagyott költségek felszámításához vezet az ügyfél számára',
  retail_audit_34:
    'A díjak helytelen felszámítása a nyújtott szolgáltatástípusok összekeverése miatt',
  retail_audit_35:
    'A field service nem kerül végrehajtásra, beleértve azt is, hogy a munkatársakat nem osztják be a tervezett helyszínre | POS',
  retail_audit_36:
    'A tényleges költségek helyett becslés alapján felszámított, majd nem egyeztetett díjak',
  retail_audit_37:
    'A promóciós irányelvek helytelen alkalmazása, amely hamis adatokhoz vezet',
  retail_audit_38: 'Hogyan dolgozunk?',
  retail_audit_39:
    'Auditorunk az ügynökség aktivációs terve alapján felkeresi a kijelölt értékesítési pontokat (POS).',
  retail_audit_40:
    'Értékeli a briefben meghatározott fő teljesítménymutatókat (KPI-ket), például a POS jelenlétét, a márkanagykövetek aktivitását, a promóciós irányelvek betartását és a csalásmegelőzési intézkedéseket.',
  retail_audit_41: 'Validálás:',
  retail_audit_42: 'Összegyűjtjük és összesítjük a kapott adatokat.',
  retail_audit_43: 'Elkészítjük az átfogó jelentést.',
  retail_audit_44:
    'Validációs csapatunk alaposan ellenőrzi az összes kérdőívet a pontosság érdekében, beleértve a projekt briefnek való megfelelést és az esetleges további megjegyzéseket is.',
  retail_audit_45: 'Online jelentési rendszer:',
  retail_audit_46:
    'A kitöltött és validált kérdőíveket 36 órán belül feltöltjük online portálunkra.',
  retail_audit_47:
    'Az ügyfelek hozzáférnek személyes fiókjukhoz a portálon, így bármikor nyomon követhetik a projekt előrehaladását.',
  retail_audit_48:
    'Átadjuk a végleges jelentést, amely tartalmazza az eredményeket és az ajánlásokat.',
  retail_audit_49: 'Beszéljen szakértőnkkel',
  retail_audit_50: 'Erősségeink:',
  facility_check_audit_1: 'Létesítmény',
  facility_check_audit_2: 'Ellenőrzési audit',
  facility_check_audit_3:
    'Emelje magasabb szintre a márkaélményt minden részletben',
  facility_check_audit_4: 'Ismerje meg megközelítésünket',
  facility_check_audit_5: 'Rólunk',
  facility_check_audit_6: 'Kik vagyunk?',
  facility_check_audit_7:
    'Globális customer experience holdingként a 4Service átfogó szolgáltatáscsomagot kínál, amely segít a márkáknak kivételes élményeket létrehozni és biztosítani ügyfeleik számára. ',
  facility_check_audit_8: 'Facility Check Audit szolgáltatásunk',
  facility_check_audit_9:
    'arra szolgál, hogy segítsen biztosítani: fizikai helyszínei és márkajelenléte a kiskereskedelmi üzletekben megfeleljenek márkastandardjainak, és pozitív benyomást keltsenek az ügyfelekben.',
  facility_check_audit_10: '1. megoldás',
  facility_check_audit_11: 'Facility Check Audit',
  facility_check_audit_12:
    'egy alapos ellenőrzés, amely értékeli, hogy kiskereskedelmi egységei vagy standjai mennyire felelnek meg márkája szabványainak. Nemcsak a fizikai jellemzőket ellenőrizzük, hanem azt is felmérjük, hogyan befolyásolják ezek az elemek márkája megítélését értékes ügyfelei körében.',
  facility_check_audit_13: 'Két megoldás',
  facility_check_audit_14: 'Két megvalósítási módszer',
  facility_check_audit_15: 'Módszer',
  facility_check_audit_16: 'Facility Check Audit szakértő auditorokkal',
  facility_check_audit_17: 'A Facility Check validálása',
  facility_check_audit_18: 'Jelentések',
  facility_check_audit_19:
    'Jelentéseket kap, amelyek vizuális bizonyítékokat és statisztikákat tartalmaznak, és 48 órán belül elérhetővé válnak',
  facility_check_audit_20:
    'A megfelelően végrehajtott Facility Check Audit számos előnyt biztosíthat márkája számára, többek között:',
  facility_check_audit_21: 'Az ügyfélkonverzió javítása:',
  facility_check_audit_22:
    'A pozitív ügyfélélmény növelheti az értékesítést és az ismételt vásárlásokat. Auditjaink segítenek azonosítani és kezelni azokat a területeket, amelyek hatással lehetnek az ügyfelek elégedettségére.',
  facility_check_audit_23: 'A márkaimázs erősítése:',
  facility_check_audit_24:
    'Fizikai helyszínei fontos kapcsolódási pontot jelentenek az ügyfelek számára, és jelentős szerepet játszhatnak márkaimázsa formálásában. Auditjaink segítenek biztosítani, hogy helyszínei összhangban legyenek márkaértékeivel, és pozitív benyomást keltsenek az ügyfelekben.',
  facility_check_audit_25: 'Miért mi?',
  facility_check_audit_26: 'Miért fontos a Facility Check Audit?',
  facility_check_audit_27:
    'A megfelelően végrehajtott Facility Check Audit számos előnyt biztosíthat márkája számára, többek között:',
  facility_check_audit_28: 'A márkaimázs erősítése:',
  facility_check_audit_29:
    'Fizikai helyszínei fontos kapcsolódási pontot jelentenek az ügyfelek számára, és jelentős szerepet játszhatnak márkaimázsa formálásában. Auditjaink segítenek biztosítani, hogy helyszínei összhangban legyenek márkaértékeivel, és pozitív benyomást keltsenek az ügyfelekben.',
  facility_check_audit_30: 'Az ügyfélkonverzió javítása:',
  facility_check_audit_31:
    'A pozitív ügyfélélmény növelheti az értékesítést és az ismételt vásárlásokat. Auditjaink segítenek azonosítani és kezelni azokat a területeket, amelyek hatással lehetnek az ügyfelek elégedettségére.',
  facility_check_audit_32: 'Kinek van szüksége',
  facility_check_audit_33: 'Kinek van szüksége Facility Check Auditra?',
  facility_check_audit_34:
    'A Facility Check Audit értékes szolgáltatás minden olyan márka számára, amely fizikai helyszínekkel és fizikai jelenléttel rendelkezik. Különösen fontos azoknak a márkáknak, amelyek szeretnék:',
  facility_check_audit_35: 'Biztosítani a márkastandardoknak való megfelelést:',
  facility_check_audit_36:
    'Auditjaink segítenek azonosítani azokat a területeket, ahol helyszínei eltérhetnek márkastandardjaitól.',
  facility_check_audit_37: 'Javítani az ügyfélélményt:',
  facility_check_audit_38:
    'Auditjaink segítenek azonosítani az ügyfélélmény javításának lehetőségeit helyszínein.',
  facility_check_audit_39: 'Erősebb márkát építeni:',
  facility_check_audit_40:
    'Auditjaink segítenek biztosítani, hogy fizikai helyszínei pozitív benyomást keltsenek az ügyfelekben.',
  facility_check_audit_41:
    'Az alkalmazott vagy a mystery shopper fényképet készít a helyszínről.',
  facility_check_audit_42:
    'Ezután kitölt egy kérdőívet, és csatolja a fényképet.',
  facility_check_audit_43:
    'A validátor megkapja a fényképet, és ellenőrzi, hogy megfelel-e a szabványoknak.',
  facility_check_audit_44: 'Facility Check Audit szakértő auditorokkal',
  facility_check_audit_45: 'Előkészítési szakasz:',
  facility_check_audit_46: 'Az audit ütemtervének közös jóváhagyása',
  facility_check_audit_47:
    'A kereskedőket előzetesen felkészítjük és tájékoztatjuk a közelgő auditról',
  facility_check_audit_48: 'Auditori képzés:',
  facility_check_audit_49:
    'Tapasztalt 4Service-trénereink felkészítik az auditorokat a márka irányelveire',
  facility_check_audit_50: 'Facility Audit szakasz:',
  facility_check_audit_51:
    'Az auditorok speciális meghatalmazó levelekkel felkeresik a helyszíneket',
  facility_check_audit_52:
    'Minden pont alapos ellenőrzése az irányelvek pontos követésével',
  facility_check_audit_53:
    'Vizuális dokumentáció, a központi követelmények szerinti értékelésekkel együtt',
  facility_check_audit_54: 'Összefoglaló PPT-jelentés',
  facility_check_audit_55:
    'Átfogó PowerPoint-jelentés, amely részletesen bemutatja a megállapításokat',
  facility_check_audit_56:
    'Az auditált eredmények interaktív online/offline bemutatása',
  facility_check_audit_57: 'A Facility Check validálása',
  facility_check_audit_58: 'Lépések:',
  facility_check_audit_59: 'Facility Audit szakasz:',
  facility_check_audit_60:
    'A márka képviselői a 4Service alkalmazás segítségével helyszíni fényképeket készítenek',
  facility_check_audit_61: 'A szigorú vizuális és leíró kritériumok betartása',
  facility_check_audit_62: 'Validálási szakasz:',
  facility_check_audit_63:
    'A gondos validátorok alaposan átvizsgálják az egyes jelentéseket',
  facility_check_audit_64:
    'A fényképek átfogó összehasonlítása a márkastandardokkal',
  facility_check_audit_65:
    'A jelentésbe megjegyzéseket és felismeréseket építünk be az egyértelműség érdekében',
  facility_check_audit_66:
    'Szükség esetén közvetlen kommunikáció a kereskedőkkel a pontosítások érdekében',
  facility_check_audit_67: 'Jelentési szakasz:',
  facility_check_audit_68:
    'A vizuális bizonyítékokkal és statisztikákkal kiegészített jelentések két napon belül elérhetők',
  facility_check_audit_69: 'Lépjen kapcsolatba velünk még ma',
  cx_solution_1: 'Nem csupán felismeréseket tárunk fel,',
  cx_solution_2: 'Üzletét új magasságokba emeljük',
  cx_solution_3:
    'A több mint 20 éves ügyfélélmény-szakértelemmel rendelkező szakértőink összetett megoldásokat tárnak fel, és konkrét cselekvési tervet biztosítanak, amely hozzájárul növekedéséhez',
  cx_solution_4:
    'Fedezze fel szolgáltatásaink egyedülálló kombinációját egy jövőbiztos megoldásban',
  cx_solution_5: 'All-in-one CX megoldás',
  cx_solution_6: 'Hirdetéstesztelés',
  cx_solution_7: 'AI és neuromarketing',
  cx_solution_8: 'Az ügyfél hangja',
  cx_solution_9: 'Szekunder kutatás',
  cx_solution_10: 'CJM',
  cx_solution_11: 'Mystery Shopping',
  cx_solution_12: 'CX tanácsadás',
  cx_solution_13: 'Közösségimédia-monitoring',
  cx_solution_14: 'Kvantitatív és kvalitatív kutatás',
  cx_solution_15: 'Szolgáltatástervezés',
  cx_solution_16: 'Marketingstratégia',
  cx_solution_17: 'UX/UI tesztelés',
  cx_solution_18: 'Közönséginsightok',
  cx_solution_19:
    'Megtiszteltetés számunkra, hogy hozzájárulhatunk az Ön sikeréhez',
  cx_solution_20:
    'Üzleti céljai és feladatai alapján testre szabjuk és kombináljuk eszközeinket és szolgáltatásainkat, hogy személyre szabott eredményeket biztosítsunk',
  cx_solution_21: 'Átfogó kutatás',
  cx_solution_22:
    'Támogatjuk a megalapozott döntéshozatalt, versenyelőnyt biztosítva az adatközpontú piacon.',
  cx_solution_23:
    'A kvalitatív kutatás nem numerikus adatok gyűjtését és elemzését jelenti a fogalmak, vélemények vagy tapasztalatok megértése érdekében',
  cx_solution_24:
    'A kvantitatív kutatási módszerek a közvélemény-kutatások, kérdőívek és felmérések során gyűjtött adatok objektív mérését és numerikus elemzését jelentik',
  cx_solution_25:
    'Az Ön egyedi igényei alapján különböző eszközöket alkalmazunk',
  cx_solution_26: 'Eszközök',
  cx_solution_27: 'CAWI',
  cx_solution_28:
    'A Computer-Assisted Web Interviewing fontos eszközünk, amely lehetővé teszi felmérések lebonyolítását és adatok gyűjtését online platformokon speciális szoftverek segítségével, biztosítva a hatékony és pontos adatgyűjtést ügyfeleink piackutatási igényeihez',
  cx_solution_29: 'CATI',
  cx_solution_30:
    'A Computer-Assisted Telephone Interviewing egy olyan módszer, amelyet felmérések lebonyolítására és értékes adatok telefonos gyűjtésére alkalmazunk, speciális szoftverek segítségével egyszerűsítve a folyamatot és biztosítva a pontosságot piackutatási munkánk során',
  cx_solution_31: 'F2F',
  cx_solution_32:
    'A Face-to-Face módszer szerves része megközelítésünknek, amely közvetlen interakciókat és személyre szabott kapcsolatot tesz lehetővé az ügyfelekkel és fogyasztókkal, ezáltal elősegítve a bizalmat, a megértést és a hatékony kommunikációt, amelyek elengedhetetlenek a tartós kapcsolatok kialakításához és az üzleti sikerhez',
  cx_solution_33: 'Szekunder kutatás',
  cx_solution_34:
    'A szekunder kutatás átfogó adatgyűjtést és -elemzést foglal magában, és kutatási folyamatunk alapvető lépéseként szolgál az insightok összegyűjtéséhez és az ügyfeleink stratégiai döntéshozatalának támogatásához',
  cx_solution_35: 'SWOT-elemzés',
  cx_solution_36:
    'A SWOT-elemzés olyan stratégiai értékelési eszköz, amely segít ügyfeleinknek azonosítani belső erősségeiket és gyengeségeiket, valamint külső lehetőségeiket és veszélyeiket, értékes insightokat biztosítva a döntéshozatalhoz és hatékony üzleti stratégiák kialakításához',
  cx_solution_37: 'Etnográfiai kutatás',
  cx_solution_38:
    'Az emberek és kultúrák tanulmányozása természetes környezetükben történő részvételen és megfigyelésen keresztül, amely gyakran mélyebb betekintést nyújt a viselkedésbe, meggyőződésekbe és társadalmi dinamikába',
  cx_solution_39: 'Mélyinterjúk',
  cx_solution_40:
    'A mélyinterjú olyan kvalitatív kutatási módszer, amelyet alapos, négyszemközti beszélgetések formájában alkalmazunk a résztvevők nézőpontjainak, tapasztalatainak és véleményeinek mélyreható feltárására, gazdag insightokat és megértést biztosítva ügyfeleink kutatási céljaihoz és döntéshozatali folyamataihoz',
  cx_solution_41: 'Ötletelési ülések',
  cx_solution_42:
    'Az ötletelési ülések olyan közös brainstorming-foglalkozások, amelyeket mi facilitálunk, különböző nézőpontokat és szakértelmet hozva össze ügyfeleink kihívásaira vagy lehetőségeire irányuló kreatív ötletek és megoldások generálásához, elősegítve az innovációt és a stratégiai kezdeményezések megvalósítását',
  cx_solution_43: 'Buyer personák',
  cx_solution_44:
    'A buyer personák olyan részletes profilok, amelyeket kutatás és adatelemzés alapján alakítunk ki ügyfeleink célcsoportjainak képviseletére, lehetővé téve számunkra, hogy jobban megértsük igényeiket, preferenciáikat és viselkedésüket, valamint stratégiáinkat és kommunikációnkat úgy alakítsuk, hogy hatékonyan megszólítsuk és bevonjuk őket, végső soron hozzájárulva az üzleti sikerhez',
  cx_solution_45: 'Mystery Shopping',
  cx_solution_46:
    'A Mystery Shopping egy stratégiai szolgáltatás, amelyet kínálunk, és amely egy előre meghatározott forgatókönyv alapján méri és monitorozza az ügyfél és a vállalat közötti interakciókat',
  cx_solution_47: 'Accompany checking',
  cx_solution_48:
    'Az Accompany checking a mystery shopping egy speciális formája, amelynek során értékelőink végigkísérik az ügyfeleket a teljes szolgáltatási élmény során, átfogó betekintést nyújtva az ügyfélút minden aspektusába, lehetővé téve ügyfeleink számára szolgáltatásnyújtásuk mélyebb megértését és megalapozott fejlesztések végrehajtását az általános ügyfél-elégedettség és lojalitás növelése érdekében',
  cx_solution_49: 'Visszajelzések gyűjtésének és elemzésének',
  cx_solution_50:
    'A visszajelzések gyűjtésének és elemzésének kritikus folyamatát végezzük, amely magában foglalja az ügyfél-visszajelzések szisztematikus összegyűjtését és elemzését különböző csatornákból, például felmérésekből, értékelésekből és közösségi médiából, lehetővé téve számunkra az értékes insightok kinyerését, a trendek azonosítását és adatvezérelt ajánlások megfogalmazását ügyfeleink termékeinek, szolgáltatásainak és általános ügyfélélményének javítására',
  cx_solution_51: 'Fókuszcsoportok',
  cx_solution_52:
    'A fókuszcsoportok dinamikus kutatási ülések, amelyeket mi facilitálunk, különböző résztvevőket hozva össze konkrét témák vagy termékek mélyreható megvitatására, lehetővé téve kvalitatív insightok gyűjtését, attitűdök, preferenciák és percepciók feltárását, valamint ötletek és koncepciók vizsgálatát, amelyek végső soron támogatják ügyfeleink döntéshozatali és stratégiaalkotási folyamatait',
  cx_solution_53: '20 év a kiváló ügyfélélmények kialakításában',
  cx_solution_54:
    'Biztosítsa, hogy üzenete megragadja és megszólítsa közönségét.',
  cx_solution_55:
    'Elkötelezettek vagyunk az Ön elvárásait meghaladó eredmények biztosítása mellett',
  cx_solution_56:
    'Összetett megoldásokat tárunk fel, amelyek hozzájárulnak növekedéséhez',
  cx_solution_57: 'Emelje magasabb szintre ügyfélélményét módszertanunkkal ',
  cx_solution_58:
    'A Customer Journey Mapping célja a célközönség meghatározása, igényeinek és környezetének megértése, majd egy vonzó élmény biztosítására szolgáló terv kialakítása',
  cx_solution_59: 'BHT',
  cx_solution_60:
    'A Brand Health Tracking kutatás mérheti, hogyan teljesít márkája az ismertség és használat, a márkapozicionálás és a márka teljesítménye terén',
  cx_solution_61: 'CSI',
  cx_solution_62:
    'A Customer Satisfaction Index egy olyan pontszám, amely azt mutatja, mennyire elégedettek ügyfelei a vállalat termékeivel / szolgáltatásaival.',
  cx_solution_63:
    'Az ármonitoring a versenytársak árainak gyűjtését, feldolgozását és elemzését jelenti',
  cx_solution_64: 'NPS',
  cx_solution_65:
    'A Net Promoter Score az ügyfélélménymutatók arany standardja, amely egyetlen kérdésen alapul: Mennyire valószínű, hogy ajánlaná a szervezetet/terméket/szolgáltatást?',
  cx_solution_66: 'HR-kutatás',
  cx_solution_67:
    'A Human Resource Research a HR-gyakorlatok és teljesítmény értékelésére szolgál, és részletes elemzést kínál a jelenlegi fejlesztési és menedzsmentfolyamatokról',
  cx_solution_68:
    'A használhatósági tesztelés azt vizsgálja, hogyan lépnek kapcsolatba valódi emberek egy weboldallal, alkalmazással vagy más termékkel, valamint megfigyeli viselkedésüket és reakcióikat',
  cx_solution_69: 'Egyéb',
  cx_solution_70:
    'Szakértőink kiválasztják az Ön vállalkozása számára legmegfelelőbb módszertant',
  cx_solution_71: 'Kezdjünk hozzá',
  cx_solution_72: '1 - KICK-OFF MEETING',
  cx_solution_73:
    'A kickoff meeting során azonosítjuk és meghatározzuk a legfontosabb feladatokat. Eredmény: a cél, a kutatási feladatok, a határidők, a módszerek és a felelősségi körök megértése.',
  cx_solution_74: '2 - KONCEPCIÓFEJLESZTÉS',
  cx_solution_75:
    'A 4Service elemzési osztálya összesíti az adatokat és koordinálja a jelentés struktúráját. Ezt követően bemutatjuk az eredményeket az ügyfélnek, kiegészítve az insightokkal és a megvalósításra vonatkozó ajánlásokkal.',
  cx_solution_76: '3 - FIELDWORK',
  cx_solution_77:
    'A kutatás elvégzéséhez résztvevőket toborzunk, interjúkat készítünk és elvégezzük a kutatás egyéb alapvető szakaszait. Az ügyfél megkapja az átírt audio-video interjúkat, valamint a tömör összefoglalókat.',
  cx_solution_78: '4 - ELEMZÉS',
  cx_solution_79:
    'A 4Service elemzési osztálya összesíti az adatokat és koordinálja a jelentés struktúráját. Ezt követően bemutatjuk az eredményeket az ügyfélnek, kiegészítve az insightokkal és a megvalósításra vonatkozó ajánlásokkal.',
  cx_solution_80: '5 - WORKSHOP',
  cx_solution_81: 'Megbeszélést tartunk az ügyféllel a megvalósítási tervről',
  cx_solution_82: 'Tudjon meg többet bevált gyakorlatainkról',
  cx_solution_83:
    'A Customer Journey Map lehetővé teszi az összes kommunikációs csatorna gyors áttekintését, a kritikus érintkezési pontokon jelentkező lehetséges hiányosságok azonosítását, valamint azon területek átfogó megértését, amelyek eltérhetnek a tervezett folyamattól.',
  cx_solution_84: 'Mikor érdemes használni?',
  cx_solution_85:
    'Személyre szabott reklámkampány kialakítása a közönségcsoportokról rendelkezésre álló valós adatok alapján',
  cx_solution_86:
    'A különböző célcsoport-szegmensek kiváltó tényezőinek feltárása és igényeik kielégítése',
  cx_solution_87:
    'Minden csoport pontos célzása és maximális konverzió elérése',
  cx_solution_88:
    'Az Accompany Checking technika lehetővé teszi az optimális célok eléréséhez vezető utak lehetőségeinek értékelését',
  cx_solution_89: 'Új weboldal vagy termék tesztelése a bevezetés előtt',
  cx_solution_90:
    'A kidolgozott folyamatok ellenőrzése a változtatások bevezetése előtt',
  cx_solution_91:
    'A weboldal vagy termék értékelése csökkenő értékesítés esetén',
  cx_solution_92: 'Új, az ügyfelek preferenciáihoz igazított termék bevezetése',
  cx_solution_93:
    'Versenytárs vállalatok vizsgálata a piaci vezető pozíció biztosítása érdekében',
  cx_solution_94:
    'Átfogó, 360°-os megközelítést kínálunk ügyfélközpontú szolgáltatási modell létrehozásához.',
  cx_solution_95: 'Munkatársak képzése és fejlesztése',
  cx_solution_96: 'A szolgáltatási standardok javítása',
  cx_solution_97: 'Az ügyfélforgalom és az értékesítés növelése',
  cx_solution_98:
    'KPI-k és motivációs rendszer kialakítása a munkatársak számára',
  cx_solution_99: 'Fedezze fel sikertörténeteinket',
  cx_solution_100: 'Autóipar',
  cx_solution_101: 'Dohányipar',
  cx_solution_102: 'Kiskereskedelem',
  cx_solution_103: 'Kvalitatív szakasz',
  cx_solution_104: 'Kvantitatív szakasz (szegmentáció)',
  cx_solution_105: 'Fókuszcsoportok',
  cx_solution_106: 'Online, világszintű célközönség-lefedettség',
  cx_solution_107: 'Interjúk során alkalmazott módszerek kombinációja',
  cx_solution_108: 'Csak nyitott kérdések',
  cx_solution_109: 'Válaszadói támogatás 24/7',
  cx_solution_110: 'A fontos részletek és az útvonal valós képének megőrzése',
  cx_solution_111: 'Piackutatás',
  cx_solution_112: 'A vállalat és a versenytársak diagnosztikája',
  cx_solution_113: 'Frissített szolgáltatási modellek és új üzleti folyamatok',
  cx_solution_114: 'Ügyfélközpontú szolgáltatás előmozdítása',
  cx_solution_115:
    'A változtatások bevezetése és a szolgáltatási stratégiák fejlesztésének ellenőrzése',
  usage_attitude_1: 'Használat és \n Attitűd (U&A)',
  usage_attitude_2:
    'Átfogó betekintést nyerhet abba, hogyan \n érzékeli, használja és hogyan lép kapcsolatba a célközönség a márkájával.',
  usage_attitude_3: 'Beszéljen szakértőnkkel',
  usage_attitude_4: 'Rólunk',
  usage_attitude_5:
    '<b>Fedezze fel a fogyasztói</b> szokásokat, hogy mélyrehatóan feltárja a preferenciákat és a befolyásoló tényezőket',
  usage_attitude_6:
    '<b>Fedezze fel a „miértet”</b> a fogyasztói döntések mögött részletes elemzésünk segítségével',
  usage_attitude_7:
    '<b>Értse meg, hogyan</b> lépnek kapcsolatba az ügyfelek termékeivel a stratégiai betekintések érdekében',
  usage_attitude_8:
    '<b>Nyújtson betekintést</b> a fogyasztói viselkedésbe, szokásokba és preferenciákba a megalapozott döntésekhez',
  usage_attitude_9: 'Tapasztalat',
  usage_attitude_10:
    'A több mint 20 éves ügyfélélmény-tapasztalattal rendelkező 4Service szakértői egyedi megoldásokat hoznak létre, amelyek segítik vállalkozása növekedését',
  usage_attitude_11: 'Lépjen kapcsolatba velünk',
  usage_attitude_12: 'Kinek',
  usage_attitude_13: 'Ki profitál a márkahasználati és attitűdvizsgálatból?',
  usage_attitude_14:
    'Különböző iparágak és szolgáltatási szektorok számára fontos:',
  usage_attitude_15: '<b>Az ügyféligények és fájdalompontok</b> felismerése',
  usage_attitude_16:
    '<b>A fogyasztás növelésére irányuló lehetőségek</b> azonosítása',
  usage_attitude_17:
    '<b>Új termékkategóriák vagy marketingstratégiák</b> kidolgozása',
  usage_attitude_18: '<b>A versenykörnyezet mélyreható megértése</b>',
  usage_attitude_19:
    'A módszertant az ügyfél igényei alapján egyedileg választjuk ki',
  usage_attitude_20:
    '<b>A kvalitatív kutatás</b> nem számszerű adatok gyűjtését és elemzését foglalja magában a fogalmak, vélemények vagy tapasztalatok megértése érdekében.',
  usage_attitude_21:
    '<b>A kvantitatív kutatási</b> módszerek a felmérések, kérdőívek és kutatások során gyűjtött adatok objektív mérését és számszerű elemzését jelentik.',
  usage_attitude_22:
    '<b>Az adatgyűjtést követően</b> szakértőink elemzik az információkat és következtetéseket vonnak le, hogy a legjobb ajánlásokat nyújtsák Önnek.',
  usage_attitude_23: 'Kinek van rá szüksége',
  usage_attitude_24: 'Az Ön sikertörténete itt kezdődik',
  usage_attitude_25:
    '<b>Egy kutatást kap</b> értékes betekintésekkel, amelyek támogatják a stratégiai döntéshozatalt, biztosítva, hogy a cselekvések a fogyasztói viselkedés mélyreható megértésén alapuljanak.',
  usage_attitude_26:
    '<b>A kutatás szilárd alapot biztosít a márkastratégiák finomításához</b> és optimalizálásához, hogy azok jobban igazodjanak a fogyasztói preferenciákhoz és attitűdökhöz.',
  usage_attitude_27: 'Megoldások',
  usage_attitude_28: 'Fedezzen fel számos lehetőséget megoldásainkkal',
  usage_attitude_29: 'Termékpreferencia a kategórián belül',
  usage_attitude_30:
    'Azonosítsa a fogyasztók legfontosabb preferenciáit különböző kategóriákban, beleértve az élelmiszereket, italokat, ruházatot, elektronikai termékeket és egyebeket.',
  usage_attitude_31: 'Fogyasztási / használati szokások',
  usage_attitude_32:
    'Elemezze az egyes termékek/szolgáltatások fogyasztásának vagy használatának gyakoriságát, és azonosítsa a használatukhoz kapcsolódó alkalmakat és pillanatokat.',
  usage_attitude_33: 'Vásárlási magatartás',
  usage_attitude_34:
    'Vizsgálja meg, milyen csatornákat használnak az ügyfelek vásárlásaikhoz, és azonosítsa azokat az információforrásokat, amelyekre támaszkodnak.',
  usage_attitude_35: 'Fogyasztói motivációk és igények',
  usage_attitude_36:
    'Vizsgálja meg a fogyasztást befolyásoló motivációkat és akadályokat. Értékelje a fogyasztói vásárlási döntésekre ható tényezőket. Fedezze fel a termékkategória megítélését, és elemezze, hogyan érzékelik az árat.',
  usage_attitude_37: 'Megközelítésünk',
  usage_attitude_38: 'Márkahasználati és attitűdvizsgálat',
  usage_attitude_39: 'Információ',
  usage_attitude_40: 'Kutatások végzése kvantitatív és kvalitatív módszerekkel',
  usage_attitude_41: 'Kezdés',
  usage_attitude_42:
    'Célok meghatározása és módszerek kiválasztása az egyedi igények alapján',
  usage_attitude_43: 'Elemzés',
  usage_attitude_44: 'Szakértőink által alkalmazott kifinomult technikák',
  usage_attitude_45:
    'Az Ön konkrét igényei alapján különböző eszközöket alkalmazunk',
  usage_attitude_46: 'СATI',
  usage_attitude_47:
    'A számítógéppel támogatott telefonos interjúztatás olyan módszer, amelyet felmérések lebonyolítására és értékes adatok telefonon történő gyűjtésére használunk, speciális szoftver segítségével a folyamat egyszerűsítése és a piackutatás során elért eredmények pontosságának biztosítása érdekében.',
  usage_attitude_48: 'CAWI',
  usage_attitude_49:
    'A számítógéppel támogatott webes interjúztatás fontos eszközünk, amely lehetővé teszi számunkra, hogy felméréseket végezzünk és adatokat gyűjtsünk online platformokon speciális szoftver segítségével, biztosítva ügyfeleink piackutatási igényeinek hatékony és pontos adatgyűjtését.',
  usage_attitude_50: 'CAPI',
  usage_attitude_51:
    'A számítógéppel támogatott személyes interjúztatás olyan módszer, amelyet az adatgyűjtési folyamatok optimalizálására, az interjúk gördülékenyebbé tételére és az Ön üzleti igényeinek megfelelő pontos, értékes eredmények biztosítására használunk.',
  usage_attitude_52: 'Fókuszcsoportok',
  usage_attitude_53:
    'A fókuszcsoportok dinamikus kutatási alkalmak, amelyeket mi moderálunk, különböző résztvevőket hozva össze konkrét témák vagy termékek mélyreható megvitatására. Lehetővé teszik kvalitatív betekintések gyűjtését, attitűdök, preferenciák és percepciók feltárását, valamint ötletek és koncepciók vizsgálatát, végső soron támogatva ügyfeleink döntéshozatali és stratégiafejlesztési folyamatait.',
  usage_attitude_54: 'F2F',
  usage_attitude_55:
    'A személyes interjúztatás szerves része megközelítésünknek, amely közvetlen interakciókat és személyre szabott kapcsolatokat tesz lehetővé az ügyfelekkel és fogyasztókkal, ezáltal elősegítve a bizalmat, a megértést és a hatékony kommunikációt, amelyek elengedhetetlenek a tartós kapcsolatok kialakításához és az üzleti sikerhez, valamint a fókuszcsoportokhoz.',
  usage_attitude_56: 'Etnográfiai kutatás',
  usage_attitude_57:
    'Az emberek és kultúrák tanulmányozása természetes környezetükben történő részvétellel és megfigyeléssel, amely gyakran mély betekintést nyújt a viselkedésbe, meggyőződésekbe és társadalmi dinamikákba.',
  thank_you_page:
    'Köszönjük az idejét! Menedzserünk hamarosan felveszi Önnel a kapcsolatot.',
  back_main: 'Vissza a főoldalra',
  opportunities_1: 'Tudjon meg többet eseteinkről',
  opportunities_2: 'Fedezze fel',
  opportunities_3: 'saját maga számára',
  opportunities_4: 'a lehetőségeket',
  opportunities_5:
    'a nemzetközi üzleti életben a 4Service kutatási holdinggal együtt',
  opportunities_6:
    'Milyen <span>termékekkel</span> erősíthetjük vállalkozását?',
  opportunities_7: 'CX',
  opportunities_8: 'Átfogó, személyre szabott megoldások vállalkozások számára',
  opportunities_9: 'A Mystery Shopping minden típusa',
  opportunities_10:
    'Rejtett munkatárs, rejtett hívó, luxus Mystery Shopper, autóipari Mystery Shopper és egyéb típusokat valósítunk meg',
  opportunities_11: 'Személyre szabott IT-megoldások vállalkozások számára',
  opportunities_12:
    'Saját IT-megoldások mesterséges intelligenciával, valamint platformok visszajelzések elemzésére és hívások átírására',
  opportunities_13: 'Piackutatás',
  opportunities_14:
    'Bármilyen üzleti igényhez (Brand Health Tracking, szegmentálás, NPS, eNPS, CJM, termék- és reklámtesztelés stb.)',
  opportunities_15: 'Auditok',
  opportunities_16:
    'Különböző szolgáltatási auditokat, valamint ármonitorozást végzünk (offline, meghatározott szegmensekben stb.)',
  opportunities_17: 'Szolgáltatástervezés',
  opportunities_18:
    'A 4Service a DesignThinkers Academy tanúsított partnere, vállalati képzéseket biztosít csapatok számára, és rendszeresen szervez workshopokat vállalkozásoknak',
  opportunities_19:
    'Megosztjuk tapasztalatainkat, ugyanakkor <span>tiszteletben tartjuk és nem zavarjuk meg</span> az Ön üzleti folyamatait.',
  opportunities_20:
    'Ismerjük azokat a nehézségeket, amelyekkel a vállalkozások fejlődésük során szembesülnek, és nemzetközi sikeres tapasztalatainknak köszönhetően azt is tudjuk, hogyan küzdhetők le ezek az akadályok. Nemcsak tapasztalatot, hanem erőforrásokat is biztosítunk.',
  opportunities_21: 'Együttműködésre hívjuk Önt!',
  opportunities_22:
    'Vállalkozása számára <span>partnerprogramot</span> kínálunk',
  opportunities_23:
    'A nemzetközileg elismert 4Service márka alatt pozitívan hozzájárulhat új ügyfelek vonzásához.',
  opportunities_24:
    'Partnereink átfogó támogatást kapnak, beleértve a képzéseket, marketinganyagokat és operatív segítséget.',
  opportunities_25:
    'A velünk való partnerség lehetővé teszi tervei megvalósítását anélkül, hogy megzavarná jelenlegi üzleti folyamatait.',
  opportunities_26: 'Irodáink',
  opportunities_27: 'Ügyfeleink',
  opportunities_28:
    'Több mint 20 éves tapasztalattal rendelkezünk a CX területén',
  opportunities_29: 'Lefedett országok',
  opportunities_30: 'ezer',
  opportunities_31: 'Egyedi projektek',
  opportunities_32: 'millió',
  opportunities_33: 'Titkos vásárlói látogatások',
  opportunities_34: 'Európa TOP 10 CX ügynöksége között szerepel',
  opportunities_35: 'Az Ön lehetőségei a 4Service-szel',
  opportunities_36: 'A profit növelése',
  opportunities_37: 'Hozzáférést kap nemzetközi megrendelésekhez',
  opportunities_38: 'Egyedülálló CX-megközelítés',
  opportunities_39: '20 éves tapasztalattal rendelkező szakértők támogatása',
  opportunities_40: 'Támogatás',
  opportunities_41: 'Csapatunk támogatja Önt a kívánt eredmények elérésében',
  opportunities_42: 'Értékesítés',
  opportunities_43: 'Segítünk kialakítani értékesítési rendszerét',
  opportunities_44: 'Hozzáférés a szoftverekhez',
  opportunities_45: 'Hozzáférést kap minden tanúsított IT-eszközünkhöz',
  opportunities_46: 'Képzés',
  opportunities_47:
    'Nemcsak betanítjuk munkatársait, hanem folyamatos tanácsadási szolgáltatásokat is biztosítunk',
  opportunities_48: 'Kinek ajánlott a partnerség?',
  opportunities_49: 'Vállalkozása kapcsolódik a marketingkutatáshoz?',
  opportunities_50: 'Vagy tervezi, hogy kipróbálja magát egy új területen',
  opportunities_51: 'A következőket tervezi:',
  opportunities_52: 'Innovációk bevezetése',
  opportunities_53: 'Nemzetközi márkákkal való együttműködés',
  opportunities_54: 'Termékportfóliójának bővítése',
  opportunities_55: 'Piaci pozíciójának megerősítése?',
  opportunities_56: 'Munkatársai képzése',
  opportunities_57: 'Vállalkozása növelése',
  opportunities_58: 'A mi erőforrásaink = az Ön erőforrásai',
  opportunities_59:
    'Kiterjedt tapasztalatunknak köszönhetően már az együttműködés első szakaszában készek vagyunk megosztani azt Önnel',
  opportunities_60: 'Adatelemzés:',
  opportunities_61: 'Nemzetközi elemzői csapat',
  opportunities_62: 'Adatfeldolgozási módszerek - SPSS, Power BI',
  opportunities_63: 'Innovatív módszertanok és módszerek széles választéka',
  opportunities_64: 'Jelentések bármilyen formátumban',
  opportunities_65: 'Szoftverek:',
  opportunities_66: 'Saját, testreszabott IT-fejlesztések',
  opportunities_67: 'DigSee Sure CAPI-hoz',
  opportunities_68: 'SurveyMonkey CAWI-hoz',
  opportunities_69: 'Shopmetrics',
  opportunities_70: 'VoIPTime (call center)',
  opportunities_71: 'Marketingtámogatás:',
  opportunities_72: 'PR-támogatás',
  opportunities_73: 'Támogatás a promócióban és a tartalomkészítésben',
  opportunities_74: 'Leadgenerálási folyamatok kialakítása',
  opportunities_75: 'IT-támogatás:',
  opportunities_76:
    'Technikai támogatás szoftvereink telepítéséhez, konfigurálásához és használatához.',
  opportunities_77: 'Távoli segítségnyújtás',
  opportunities_78: 'Biztonsági ellenőrzés',
  opportunities_79: 'Operatív támogatás:',
  opportunities_80: 'Támogatás a terepi folyamatok kialakításában',
  opportunities_81: 'Csalásmegelőző rendszer',
  opportunities_82: 'Bármilyen összetettségű toborzás',
  opportunities_83:
    'A projekt és a terepi részlegek csapatának operatív irányítása',
  opportunities_84: 'A toborzás minőségellenőrzése',
  opportunities_85: 'UpWork',
  opportunities_86: 'Milyen bónuszokat kap?',
  opportunities_87: 'Ügyfélkör bővítése',
  opportunities_88: 'Piaci imázs erősítése',
  opportunities_89: 'Az ügyfélvesztési kockázatok diverzifikálása',
  opportunities_90: 'Technológiai folyamatok optimalizálása',
  opportunities_91: 'Nemzetközi tapasztalat',
  opportunities_92: 'Több értékesítés meglévő ügyfelek számára',
  main_67:
    'A versenytársak árainak elemzése optimalizálja a kínálatot, növeli a profitot és erősíti a piaci részesedést azáltal, hogy a fogyasztók fizetési hajlandóságára vonatkozó adatok segítségével azonosítja a legfontosabb jellemzőket',
  main_68:
    'Biztosítja, hogy üzletei megfeleljenek a márka szabványainak, miközben értékeli a fizikai jellemzőket és azok hatását a vásárlói megítélésre',
  main_69: 'CX-megoldás',
  main_70:
    'Fedezze fel egyedülálló, 360 fokos CX-megoldásunkat: az Ön célkitűzései alapján testreszabjuk az eszközöket és szolgáltatásokat, hogy előmozdítsuk vállalkozása fejlődését',
  main_71: 'Beszédelemzés',
  main_72:
    'Fejlett beszédelemző eszközünk a beszélt nyelvet szöveggé alakítja, értékes betekintést nyújtva a vállalkozások számára az ügyfélélmény javításához, a teljesítmény nyomon követéséhez, a megfelelőség biztosításához és a növekedés ösztönzéséhez',
  parthership: 'Partnerség',
  banner_1:
    'CX-tanácsadás és szolgáltatások – 360°-os nézőpont vállalkozásáról',
  banner_2: 'Maradjon naprakész a legújabb kutatásokkal!',
  banner_3:
    'Hozzájárulok személyes adataim kezeléséhez az Adatvédelmi szabályzatnak megfelelően',
  banner_4: '*Válassza ki a piacot',
  banner_5: 'Köszönjük, hogy feliratkozott!',
  banner_6: 'Csak a legérdekesebb tartalmakat osztjuk meg Önnel!',
  banner_7: 'Küldés',
  banner_8: 'Ukrán',
  banner_9: 'Kazahsztán',
  brand_awareness_1: 'Márkaismertség',
  brand_awareness_2: 'és használat',
  brand_awareness_3:
    'Használja ki márkája ismertségében és használatában rejlő lehetőségeket az üzleti siker érdekében',
  brand_awareness_4: 'Beszéljen szakértőnkkel',
  brand_awareness_5: 'Rólunk',
  brand_awareness_6:
    '<b>Értékelje</b> márkája ismertségének és felismerhetőségének mértékét',
  brand_awareness_7:
    '<b>Határozza meg márkája </b> ismertségének szintjét a célpiacon',
  brand_awareness_8:
    '<b>Folyamatosan kövesse nyomon</b> a megtartási és lojalitási arányokat',
  brand_awareness_9:
    '<b>Válassza ki az optimális stratégiát</b> a szükséges mutatók javítására',
  brand_awareness_10: 'Fedezze fel a számos lehetőséget megoldásainkkal',
  brand_awareness_11: 'Márkaismertség',
  brand_awareness_12: 'Márkahasználat',
  brand_awareness_13:
    '<b>Fedezze fel</b> márkája ismertségét a fogyasztói szegmensek körében',
  brand_awareness_14:
    '<b>Kövesse nyomon</b> a célközönség márkaismertségének szintjét',
  brand_awareness_15:
    '<b>Vizsgálja meg</b> a fogyasztók spontán gondolatait vásárlás előtt',
  brand_awareness_16:
    '<b>Értse meg</b> a márkaismertségéhez leginkább hozzájáruló elsődleges forrásokat',
  brand_awareness_17:
    '<b>Vegye figyelembe</b> azoknak a fogyasztóknak a számát, akik kipróbálták márkája termékeit vagy szolgáltatásait',
  brand_awareness_18:
    '<b>Azonosítsa</b> azokat a fogyasztókat, akik az első kipróbálás után is kitartottak márkája mellett',
  brand_awareness_19:
    '<b>Fedezze fel</b> annak valószínűségét, hogy márkáját ajánlják másoknak',
  brand_awareness_20:
    '<b>Tárja fel</b> azon fogyasztók arányát, akik a jövőben is számolnak márkája használatával',
  brand_awareness_21:
    'Kik profitálhatnak a márkaismertség és márkahasználat vizsgálatából?',
  brand_awareness_22: 'Új terméket bevezető vállalkozások',
  brand_awareness_23: 'Meglévő márkát megújító vállalkozások',
  brand_awareness_24:
    'Minden olyan vállalkozás, amely meg szeretné érteni és javítani szeretné, hogyan ismerik fel és használják márkáját a fogyasztók',
  brand_awareness_25:
    'Módszertanaink értékes betekintést nyújtanak márkaismertsége és márkahasználata optimalizálásához',
  brand_awareness_26:
    'A módszertant az ügyfél igényei alapján egyedileg választjuk ki',
  brand_awareness_27: 'Márkahasználati tölcsér módszertan',
  brand_awareness_28:
    'A kipróbálási arány megmutatja azon célközönség arányát, amely ismeri a márkát, és kipróbálta annak termékeit vagy szolgáltatásait.',
  brand_awareness_29:
    'Az ismételt vásárlási arány azt mutatja meg, hogy a márkát ismerő és termékeit vagy szolgáltatásait már kipróbáló célközönség mekkora része folytatta a vásárlást vagy a szolgáltatások igénybevételét az elmúlt 12 hónapban.',
  brand_awareness_30:
    'A megtartási arány megmutatja azon személyek arányát, akik rendszeresen használták a márka termékeit vagy szolgáltatásait, vagyis azok százalékos arányát, akik az elmúlt 6 hónapban igénybe vették ezeket.',
  brand_awareness_31:
    'A megtartási arány azt mutatja meg, hogy azoknak az ügyfeleknek mekkora része marad hosszú távon hű a márkához, akik az elmúlt 6 hónapban használták annak termékeit vagy szolgáltatásait.',
  brand_awareness_32: 'Márkaismertségi módszertan',
  brand_awareness_33:
    'A Top of Mind (TOM) azt a márkát jelenti, amelyet a válaszadó elsőként említ spontán módon.',
  brand_awareness_34:
    'A teljes spontán ismertség a spontán említések teljes számát jelenti, beleértve a TOM-ot is.',
  brand_awareness_35:
    'A támogatott márkaismertség megmutatja, hogy a felhasználók mennyire ismerik fel márkáját, amikor arra rávezetéssel kérdezünk rá.',
  brand_awareness_36: 'Márkaattribútumok teljesítménytérképe',
  brand_awareness_37:
    'Ez az eszköz felméri és vizuálisan megjeleníti a különböző márkaattribútumok fontosságát, betekintést nyújtva abba, hogy ezek hogyan járulnak hozzá márkája általános teljesítményéhez és a fogyasztói megítéléshez.',
  brand_awareness_38:
    'Fedezze fel márkája hatásának növeléséhez szükséges kulcsfontosságú tényezőket átfogó elemzésünkkel.',
  brand_awareness_39: 'Márkák perceptuális térképe',
  brand_awareness_40:
    'Ez az eszköz vizuálisan jeleníti meg a fogyasztói percepciókat a versenypiaci környezetben. Ez a megközelítés kulcsfontosságú a márkák közötti különbségek egyértelmű meghatározásához, kiemelve a piac meghatározó jellemzőit.',
  brand_awareness_41:
    'Egyszerűbbé teszi a márkák és az ezeket meghatározó jellemzők közötti kapcsolatok megfigyelését és értelmezését.',
  brand_awareness_42:
    'Egy adott márka és bizonyos attribútumok közelsége azt jelzi, hogy a márka erősen kapcsolódik ezekhez a jellemzőkhöz. Hasonlóképpen, két márka közelsége hasonlóságukat jelzi, megmutatva a közös márkaképet és ennek következtében az azonos piaci szegmenshez való tartozást.',
  consumer_journey_map_1: 'Fogyasztói útvonal térképe',
  consumer_journey_map_2:
    'Fedezze fel és küzdje le vállalkozása akadályait Fogyasztói útvonal térképünkkel',
  consumer_journey_map_3: 'BÍZNAK BENNÜNK',
  consumer_journey_map_4: '4Service',
  consumer_journey_map_5:
    'Használja ki a CJM-ben rejlő lehetőségeket a fogyasztók és márkája közötti interakciók optimalizálására',
  consumer_journey_map_6:
    'Határozza meg, milyen lépéseket tesz a fogyasztó a termék megvásárlása előtt',
  consumer_journey_map_7:
    'Valós ügyfeleitől szerezzen betekintést, ne képzeletbeli ügyfelektől',
  consumer_journey_map_8: 'Szerezzen átfogó képet ügyfelei tapasztalatairól',
  consumer_journey_map_9:
    'Azonosítsa az elszalasztott lehetőségeket, és hasonlítsa össze teljesítményét versenytársaival',
  consumer_journey_map_10: 'Fedezze fel CJM-megközelítésünket',
  consumer_journey_map_11:
    'A fogyasztó és egy termék, szolgáltatás, vállalat vagy márka közötti interakció útvonalát különböző csatornákon és egy meghatározott időszak alatt alakítjuk ki.',
  consumer_journey_map_12:
    'Meghatározzuk azokat a szakaszokat, amelyeken fogyasztói végighaladnak a vásárlás befejezéséig, valamint az ügyfél elvárásait, érzelmeit és motivációit minden egyes szakaszban.',
  consumer_journey_map_13: 'Előnyök velünk',
  consumer_journey_map_14:
    'Tapasztalt szakemberekből álló csapatot biztosítunk, akik ismerik a globális üzleti siker összetettségét',
  consumer_journey_map_15:
    'Elkötelezettek vagyunk az Ön elvárásait meghaladó eredmények elérése mellett',
  consumer_journey_map_16:
    'Összetett megoldásokat fedezünk fel, amelyek hozzájárulnak vállalkozása növekedéséhez',
  consumer_journey_map_17:
    'Személyre szabott CJM-megoldások nyújtására specializálódtunk',
  consumer_journey_map_18: 'Foglaljon konzultációt',
  consumer_journey_map_19: 'Adatalapú döntések',
  consumer_journey_map_20:
    'Döntéseit feltételezések helyett valós adatokra alapozza',
  consumer_journey_map_21: 'Optimalizálja CJM-jét',
  consumer_journey_map_22:
    'Építsen erősebb kapcsolatokat ügyfeleivel azáltal, hogy az út minden szakaszában figyelembe veszi igényeiket és elvárásaikat',
  consumer_journey_map_23: 'Legyen az élen',
  consumer_journey_map_24:
    'Hasonlítsa össze magát versenytársaival, és maradjon a piac előtt',
  consumer_journey_map_25: 'Ajánlások',
  consumer_journey_map_26:
    'Valósítsa meg CJM-ajánlásainkat a siker eléréséhez, az ügyféllojalitás erősítéséhez, az értékesítés növeléséhez és vállalkozása lehetőségeinek maximalizálásához',
  consumer_journey_map_27:
    'Fedezze fel a valódi fogyasztói útvonalat Fogyasztói útvonal térképünkkel',
  consumer_journey_map_28:
    'Több mint 20 éves tapasztalattal rendelkező szakértők átfogó kutatást biztosítanak',
  consumer_journey_map_29:
    'A kvalitatív kutatás nem számszerű adatok gyűjtését és elemzését foglalja magában a fogalmak, vélemények vagy tapasztalatok megértése érdekében.',
  consumer_journey_map_30:
    'A kvantitatív kutatási módszerek a felmérések, kérdőívek és közvélemény-kutatások során gyűjtött adatok objektív mérését és számszerű elemzését jelentik.',
  consumer_journey_map_31:
    'Az adatok összegyűjtése után szakértőink elemzik az információkat és következtetéseket vonnak le, hogy a legjobb ajánlásokat biztosítsák Önnek.',
  boarding_1: 'Ügyfélút-térkép',
  boarding_2:
    'A Customer Journey Mapping (CJM) a célközönség meghatározását, igényeinek és környezetének megértését, majd egy vonzó élmény biztosítására alkalmas terv kidolgozását jelenti',
  boarding_3: 'Net Promoter Score',
  boarding_4:
    'A Net Promoter Score (NPS) az ügyfélélmény-mutatók arany standardja, amely egyetlen kérdésen alapul: Mennyire valószínű, hogy ajánlaná a szervezetet/terméket/szolgáltatást?',
  boarding_5: 'Márkaegészség-követés',
  boarding_6:
    'A Brand Health Tracking (BHT) kutatás mérheti márkája teljesítményét az ismertség és használat, a márkapozicionálás és a márka teljesítménye terén',
  boarding_7: 'Humánerőforrás-kutatás',
  boarding_8:
    'A humánerőforrás-kutatás a HR-gyakorlatok és teljesítmény értékelésére szolgál, és részletes elemzést kínál a jelenlegi fejlesztésről és menedzsmentről',
  boarding_9: 'UX-tesztelés',
  boarding_10:
    'A használhatósági (UX) tesztelés azt vizsgálja, hogyan lépnek kapcsolatba valódi emberek egy weboldallal, alkalmazással vagy más termékkel, valamint megfigyeli viselkedésüket és reakcióikat',
  boarding_11: 'Ügyfélelégedettségi index',
  boarding_12:
    'Az ügyfélelégedettség azt méri, hogy a vállalat által biztosított termék vagy szolgáltatás megvásárlásával kapcsolatban milyen mértékben teljesültek az ügyfelek elvárásai',
  boarding_13: 'Hirdetéstesztelés',
  boarding_14:
    'Egy reklámkampány hatalmas befektetés. Győződjön meg róla, hogy hirdetései hatásosak és maximális ROI-t biztosítanak',
  boarding_15: 'Field audit/Retail audit',
  boarding_16:
    'Gyűjtsön részletes adatokat üzletéről vagy márkájáról, elemezze a növekedés akadályait, és dolgozzon ki hatékony stratégiákat azok leküzdésére',
  boarding_17: 'Play4Sales',
  boarding_18:
    'Teljesítménymenedzsment-szoftver. Gamifikált alkalmazás az értékesítés növelésére',
  boarding_19: 'Voicer',
  boarding_20:
    'Visszajelzés-kezelő rendszer. Ügyfelei hangja egyetlen rendszerben. Ügyfél-visszajelzés-kezelő rendszer',
  boarding_21: 'Kvalitatív kutatás',
  boarding_22:
    'A kvalitatív kutatás nem számszerű adatok gyűjtése és elemzése a fogalmak, vélemények vagy tapasztalatok megértése érdekében',
  boarding_23: 'Kvantitatív kutatás',
  boarding_24:
    'A kvantitatív kutatási módszerek a felmérések, kérdőívek és közvélemény-kutatások során gyűjtött adatok objektív mérését és számszerű elemzését jelentik',
  boarding_25: 'Mystery Shopping',
  boarding_26:
    'A Mystery Shopping olyan piackutatási technika, amely egy előre meghatározott forgatókönyv alapján méri és monitorozza az ügyfél és a vállalat vagy szervezet közötti interakciókat',
  boarding_27: 'Wantent',
  boarding_28:
    'Mesterséges intelligenciával működő tartalomintelligencia-platform, amely betekintést nyújt a közönség reakcióiba',
  boarding_29: 'Ármonitoring ',
  boarding_30:
    'Az ármonitoring a versenytársak árainak gyűjtését, feldolgozását és elemzését jelenti',
  boarding_31: 'Szolgáltatástervezés',
  boarding_32:
    'A szolgáltatástervezés annak megértését jelenti, hogy mire van szükségük és mit szeretnének azoknak az embereknek, akik egy terméket vagy szolgáltatást használnak majd, azáltal, hogy időt töltünk velük',
  boarding_33: 'Autóipari árak elemzése',
  boarding_34:
    'A versenytársak árainak elemzése optimalizálja a kínálatot, növeli a profitot és a piaci részesedést azáltal, hogy a fogyasztók fizetési hajlandóságára vonatkozó adatok segítségével azonosítja a kulcsfontosságú jellemzőket',
  boarding_35: 'Létesítmény-ellenőrzési audit',
  boarding_36:
    'Biztosítja, hogy kiskereskedelmi üzletei megfeleljenek a márka szabványainak, értékelve a fizikai jellemzőket és azok hatását a fogyasztói megítélésre',
  boarding_37: 'CX-megoldás',
  boarding_38:
    'Fedezze fel egyedi, 360 fokos CX-megoldásunkat: az eszközöket és szolgáltatásokat az Ön üzleti céljaihoz igazítjuk',
  boarding_39: 'Beszédelemzés',
  boarding_40:
    'Fejlett beszédelemző eszközünk a beszélt nyelvet szöveggé alakítja, értékes betekintést nyújtva a vállalkozások számára az ügyfélélmény javításához, a teljesítmény nyomon követéséhez, a megfelelőség biztosításához és a növekedés ösztönzéséhez',
  boarding_41: 'Használat és attitűd',
  boarding_42:
    'A Használat és attitűd megközelítésünk azt vizsgálja, hogyan kapcsolódnak a célcsoportok a márkához a tényleges használati szokások és pszichológiai attitűdök elemzésén keresztül, lehetővé téve a személyre szabott marketing- és termékstratégiák kialakítását',
  boarding_43: 'Márkaismertség és használat',
  boarding_44:
    'A márkaismertség és használat magában foglalja a felismerés, az ismertség, az interakció gyakoriságának és a megtartásnak az értékelését a célpiacon a márka láthatóságának és elköteleződésének növelése érdekében',
  boarding_45: 'Márkaidentitás és pozicionálás',
  boarding_46:
    'A márkaidentitás és pozicionálás átfogó elemzés, amely feltárja a fogyasztói percepciókat, a különböző célcsoportok véleményét és azt, hogyan érzékelik a márkát',
  boarding_47: 'Ügyfélprofilalkotás és szegmentáció',
  boarding_48:
    'Az ügyfélprofilalkotás és szegmentáció során a célpiacot közös jellemzők alapján különálló csoportokra osztjuk, lehetővé téve olyan személyre szabott stratégiák kialakítását, amelyek megszólítják az egyes célcsoportokat',
  boarding_49: 'Fogyasztói útvonal térképe',
  boarding_50:
    'A fogyasztói útvonal térképe vizuálisan ábrázolja azokat a szakaszokat, érintkezési pontokat, érzelmeket és motivációkat, amelyeket a fogyasztó a termékével vagy márkájával való interakció során megtapasztal',
  boarding_51:
    'Ismerje meg azokat az innovatív technikákat, amelyek megalapozzák elkötelezettségünket a hasznosítható insightok biztosítása és az üzleti szempontból jelentős eredmények elérése iránt',
  boarding_52:
    'Fedezze fel adatvezérelt intelligenciával gazdag termékportfóliónkat, amelyet az Ön iparágára szabunk, hogy megalapozott döntéseket hozhasson és a versenytársak előtt járhasson',
  boarding_53:
    'Merüljön el mélyebben a piaci trendekben, a fogyasztói magatartásban és a versenykörnyezetben átfogó piackutatási megoldásainkkal',
  boarding_54: 'Ad hoc kutatás',
  boarding_55:
    'Az ad hoc kutatás egyedi igényekre szabott megközelítés, amely egy konkrét probléma megoldására szolgál, meglévő módszertanok kombinációjával vagy új megközelítés alkalmazásával személyre szabott megoldást létrehozva.',
  boarding_56: 'Szociológiai kutatás',
  boarding_57:
    'A szociológiai kutatás feltárja az emberi viselkedés és a társadalmi interakciók mintázatait, értékes insightokat biztosítva innovatív stratégiák kialakításához és a célközönséggel való tartalmas kapcsolatok létrehozásához.',
  not_found_1: 'Hoppá! Nem találjuk ezt az oldalt.',
  not_found_2: 'Miért nem nézi meg termékeinket?',
  not_found_3: 'Tanácsadás lefoglalása',
  customer_profiling_segmentation_1: 'Ügyfélprofilalkotás és szegmentáció',
  customer_profiling_segmentation_2:
    'Segítünk pontosan meghatározni a célközönségét, így stratégiája hatékonyabbá válhat',
  customer_profiling_segmentation_3:
    'Használja ki a piaci szegmentáció erejét, hogy üzenetei mindig hatékonyan eljussanak a megfelelő fogyasztói csoportokhoz',
  customer_profiling_segmentation_4: 'Ismerje meg mélyebben fogyasztóit',
  customer_profiling_segmentation_5:
    'Találja meg terméke számára a legmegfelelőbb célközönséget',
  customer_profiling_segmentation_6:
    'Fedezze fel az új, megszólítható szegmenseket',
  customer_profiling_segmentation_7: 'Fedezze fel a vásárlás akadályait',
  customer_profiling_segmentation_8:
    'Személyre szabott szegmentációs megoldások nyújtására specializálódtunk',
  customer_profiling_segmentation_9: 'Egyedi megközelítés',
  customer_profiling_segmentation_10:
    'Tapasztalja meg az Ön egyedi igényeire szabott, személyre kialakított szegmentációs megoldást',
  customer_profiling_segmentation_11: 'Célcsoportprofilok',
  customer_profiling_segmentation_12:
    'Mélyreható piacelemzés és átfogó kutatás alapján kialakított célcsoportprofilok',
  customer_profiling_segmentation_13: 'Új szegmensek',
  customer_profiling_segmentation_14:
    'Azonosítsa legértékesebb célcsoport-szegmenseit, és aknázza ki a személyre szabott célzás előnyeit',
  customer_profiling_segmentation_15: 'Ajánlások',
  customer_profiling_segmentation_16:
    'Valósítsa meg ajánlásainkat, érjen el sikert, erősítse az ügyfélhűséget, növelje az értékesítést és maximalizálja üzleti lehetőségeit',
  customer_profiling_segmentation_17:
    'A több mint 20 éves tapasztalattal rendelkező szakértők átfogó kutatást biztosítanak',
  customer_profiling_segmentation_18:
    'A kvalitatív kutatás nem számszerű adatok gyűjtését és elemzését foglalja magában a fogalmak, vélemények vagy tapasztalatok megértése érdekében.',
  customer_profiling_segmentation_19:
    'A kvantitatív kutatási módszerek a felmérések, kérdőívek és közvélemény-kutatások során gyűjtött adatok objektív mérését és számszerű elemzését jelentik.',
  customer_profiling_segmentation_20:
    'Az adatok összegyűjtése után szakértőink elemzik az információkat és következtetéseket vonnak le, hogy a legjobb ajánlásokat nyújtsák Önnek.',
  customer_profiling_segmentation_21:
    'Nem csupán méréseket végzünk, hanem egyértelmű, lépésről lépésre követhető cselekvési tervet is biztosítunk',
  customer_profiling_segmentation_22: 'Módszertanunk',
  customer_profiling_segmentation_23: 'Jaccard-index',
  customer_profiling_segmentation_24:
    'Amikor a válaszadókat közvetlenül kérdezik, a vállalatpreferenciákról adott válaszaik nem feltétlenül egyeznek tényleges viselkedésükkel. A közvetlen kérdezés helyett statisztikai Jaccard-elemzést alkalmazunk a vállalati jellemzők és a fogyasztói választás közötti kapcsolat megértésére.',
  customer_profiling_segmentation_25: 'Mozgatórugók',
  customer_profiling_segmentation_26:
    'Azonosítjuk a mozgatórugókat (egy adott eredményt befolyásoló tényezőket), és jelentőségük alapján kulcsfontosságú, közepes és jelentéktelen mozgatórugókba soroljuk őket.',
  customer_profiling_segmentation_27: 'Szegmentáció',
  customer_profiling_segmentation_28:
    'Egyértelmű jellemzőkkel rendelkező szegmentációt kap az ügyfelek választásairól.',
  customer_profiling_segmentation_29: 'Szegmentációs megközelítésünk',
  customer_profiling_segmentation_30: 'Demográfiai',
  customer_profiling_segmentation_31: 'életkor',
  customer_profiling_segmentation_32: 'nem',
  customer_profiling_segmentation_33: 'jövedelem',
  customer_profiling_segmentation_34:
    'Segít a termékek, szolgáltatások és marketingtevékenységek konkrét csoportokhoz igazításában, javítva azok relevanciáját és hatékonyságát',
  customer_profiling_segmentation_35: 'Pszichográfiai',
  customer_profiling_segmentation_36: 'életmód',
  customer_profiling_segmentation_37: 'értékek',
  customer_profiling_segmentation_38: 'viselkedés',
  customer_profiling_segmentation_39:
    'Lehetővé teszi a személyre szabott marketinget, az ügyfelekkel való mélyebb kapcsolatok kialakítását, valamint a vállalat ügyfélhűségének és értékesítésének növelését',
  customer_profiling_segmentation_40: 'Viselkedési',
  customer_profiling_segmentation_41: 'tevékenységek',
  customer_profiling_segmentation_42: 'motiváció',
  customer_profiling_segmentation_43: 'vásárlási gyakoriság',
  customer_profiling_segmentation_44:
    'Lehetővé teszi a célzott marketinget, az ügyfélelégedettség növelését, a megtartás javítását és a vállalat jövedelmezőségének növelését',
  customer_profiling_segmentation_45: 'Földrajzi',
  customer_profiling_segmentation_46: 'elhelyezkedés',
  customer_profiling_segmentation_47:
    ' Lehetővé teszi a célzott marketinget, a személyre szabott termékeket, a hatékony disztribúciót és a vállalat piaci penetrációjának növelését.',
  brands_identity_1: 'Márkaidentitás és pozicionálás',
  brands_identity_2:
    'Alakítsa át márkáját mélyreható elemzésünkkel, amely feltárja a fogyasztói percepciókat, és segít finomítani stratégiáját a siker érdekében',
  brands_identity_3: 'Beszéljen szakértővel',
  brands_identity_4: '<b>Fedezze fel az átfogó</b> márkaidentitás-elemzést',
  brands_identity_5:
    '<b>Fedezze fel a fogyasztói percepciókról</b> gyűjtött insightokat',
  brands_identity_6: '<b>Értse meg a célközönség</b> különböző nézőpontjait',
  brands_identity_7:
    '<b>Szerezzen betekintést</b> a fogyasztói viselkedésbe, szokásokba és preferenciákba a megalapozott döntések érdekében',
  brands_identity_8:
    'A több mint 20 éves ügyfélélmény-tapasztalattal rendelkező 4Service szakértői egyedi megoldásokat hoznak létre, amelyek segítik vállalkozása növekedését',
  brands_identity_9:
    '<b>Hozzáférést kap egy minden szükséges adattal felszerelt kutatási csomaghoz.</b> Diagnosztikai eszközként szolgál, kiemelve az erősségeket és azokat a területeket, amelyek figyelmet igényelhetnek',
  brands_identity_10:
    '<b>Szolgáltatásaink biztosítják a vállalkozások számára a szükséges eszközöket</b> a megalapozott döntések meghozatalához, a stratégiák finomításához és az iparágukban elért sikerhez.',
  brands_identity_11: 'Márkája pozíciójának erősítése a versenypiacon',
  brands_identity_12: 'A piaci jelenlétük erősítésére törekvő vállalkozások',
  brands_identity_13: 'A stratégiájuk fejlesztésére törekvő vállalkozások',
  brands_identity_14: 'Márkaidentitás',
  brands_identity_15: 'Márkapozicionálás',
  brands_identity_16:
    '<b>Fedezze fel márkája</b> megítélését a fogyasztói szegmensek körében.',
  brands_identity_17:
    '<b>Azonosítsa a márkájának és versenytársainak tulajdonított</b> tulajdonságokat.',
  brands_identity_18:
    '<b>Értékelje az erősségeket</b> és gyengeségeket a stratégiai fejlesztés érdekében.',
  brands_identity_19:
    '<b>Vizsgálja meg, hogy márkaimázsa összhangban van-e</b> a kommunikált értékekkel.',
  brands_identity_20: '<b>Értékelje márkája</b> észlelt megbízhatóságát.',
  brands_identity_21:
    '<b>Fedezze fel márkája archetípusos</b> és szimbolikus megítélését.',
  brands_identity_22:
    '<b>Azonosítsa márkája</b> egyedi értékesítési előnyeit és a versenytársakhoz képest meglévő megkülönböztető jegyeit.',
  brands_identity_23:
    '<b>Határozza meg a fogyasztói vásárlási hajlandóságot befolyásoló</b> kulcsfontosságú tulajdonságokat termékei/szolgáltatásai esetében.',
  brands_identity_24:
    '<b>Határozza meg, hogyan pozicionálódik jelenleg márkája</b> a fogyasztók fejében, és azonosítsa azokat a szempontokat, amelyeket kommunikálni kell a kívánt piaci szegmensek megszólításához.',
  brands_identity_25:
    'A módszertant egyedileg, az ügyfél igényei alapján választjuk ki',
  brands_identity_26: 'Márkaismertség és használat',
  brands_identity_27:
    'A márka szintjének értékelése magában foglalja az ismertség és a fogyasztási szintek mérését, amely az értékelés alapvető részét képezi.',
  brands_identity_28: 'Márkaígéret és bizalom',
  brands_identity_29:
    'Ez a mutató méri az ügyfelek ajánlási hajlandóságát, valamint a márka következetes képességét ígéretei teljesítésére, pozitív ügyfélélmények létrehozására és a bizalom kiépítésére.',
  brands_identity_30: 'Márkaimázs teljesítménye',
  brands_identity_31:
    'A márka teljesítményének értékelése magában foglalja a hat kulcsfontosságú értékhez (3 racionális és 3 érzelmi) való kapcsolódásának, a kategórián belüli megkülönböztethetőségének, valamint annak vizsgálatát, hogy képes-e büszkeséget ébreszteni a fogyasztókban.',
  brands_identity_32: 'Márkaegészség-pontszám',
  brands_identity_33:
    'A Brand Health Score átfogó képet ad arról, hogyan teljesít márkája a versenykörnyezetben.',
  sociological_research_1: 'Szociológiai kutatás',
  sociological_research_2:
    'Mélyreható elemzést végzünk társadalmi jelenségekről és folyamatokról, amely egyedi elemzési következtetések és ajánlások segítségével támogatja a megalapozott döntéshozatalt',
  sociological_research_3: 'Vegye fel velünk a kapcsolatot',
  sociological_research_4: 'Ügyfeleink',
  sociological_research_5: 'CAWI',
  sociological_research_6:
    'A CATI egy adatgyűjtési módszer, amely számítógép segítségével telefonos felmérések lebonyolítását teszi lehetővé. A CATI-szoftver automatizálja az adatgyűjtés, a válaszok rögzítése és a kérdőívek kezelése folyamatát. A CATI használata megkönnyíti a felmérés ellenőrzését, lehetővé teszi az adatok gyors elemzését és feldolgozását, valamint magas szintű standardizálást biztosít a felmérés során.',
  sociological_research_7: 'CATI',
  sociological_research_8:
    'A CAWI olyan adatgyűjtési módszer, amelyben a válaszadók online kérdőíveket töltenek ki vagy webes felületen válaszolnak a kérdésekre, az adatokat pedig speciális szoftver segítségével automatikusan gyűjtik és dolgozzák fel. A CAWI módszer lehetővé teszi nagyszabású felmérések lebonyolítását, valamint az adatok gyors gyűjtését és elemzését.',
  sociological_research_9: 'CAPI',
  sociological_research_10:
    'A CAPI egy személyes lekérdezésekhez használt adatgyűjtési módszer, amely során a kutató táblagépet vagy mobiltelefont használ a válaszadók kérdésekre adott válaszainak rögzítésére. Ez lehetővé teszi az adatgyűjtés automatizálását, csökkenti a rögzítési hibák számát és egyszerűsíti az eredmények elemzését.',
  sociological_research_11: 'Szakértőink számos különböző eszközt alkalmaznak',
  sociological_research_12: 'Minta',
  sociological_research_13:
    'Bármilyen összetettségű mintákat számítunk ki és alkalmazunk',
  sociological_research_14:
    'Munkánk során egyszerű, szisztematikus, rétegzett és klasztermintákat alkalmazunk',
  sociological_research_15:
    'Országosan reprezentatív személyes felmérésekhez rétegzett, többlépcsős mintavételi eljárásokat alkalmazunk',
  sociological_research_16:
    'A települések régiónkénti kiválasztása a település méretének és típusának megfelelően történik, számukat pedig az egyes régiókban képviselt arányuk alapján határozzuk meg',
  sociological_research_17: 'Amit végzünk',
  sociological_research_18: 'Közvélemény-kutatás',
  sociological_research_19: 'Társadalmi-gazdasági kutatás',
  sociological_research_20: 'Desk research',
  sociological_research_21: 'A szociális szolgáltatások minőségének értékelése',
  sociological_research_22: 'Esettanulmány',
  sociological_research_23: 'Munkaerő-kutatás',
  sociological_research_24:
    'Specifikus célcsoportok kutatása (kiszolgáltatott csoportok, beleértve a belső menekülteket, katonákat, fiatalokat stb.)',
  sociological_research_25: 'Minden ügyfelünkkel egyénileg dolgozunk',
  sociological_research_26: 'Ügyfeleink:',
  sociological_research_27: 'Jótékonysági alapítványok',
  sociological_research_28: 'Civil szervezetek és szakszervezetek',
  sociological_research_29: 'Állami szervek',
  sociological_research_30: 'Munkamódszerünk',
  sociological_research_31:
    'Munkánk során tudományos megközelítést és a jelenlegi valóság mélyreható ismeretét alkalmazzuk, valamint különböző kutatási módszereket használunk az adatok gyűjtésére.',
  sociological_research_32:
    'A konkrét igények kielégítéséhez megfelelő tapasztalattal rendelkező, magasan specializált szakértőket vonunk be, és különböző szakterületek szakértőiből álló szakértői hálózattal rendelkezünk.',
  sociological_research_33:
    'Belső elemző részlegünk a begyűjtött adatokat a feladat sajátosságaitól függően egyedi eszközkészlettel elemzi.',
  sociological_research_34:
    'Részletes következtetéseket és ajánlásokat tartalmazó jelentéseket készítünk, figyelembe véve a célközönség igényeit és elvárásait.',
  sociological_research_35:
    'Tanácsadást és támogatást nyújtunk az ajánlások megvalósítása során, segítve Önt a pozitív változások elérésében.',
  sociological_research_36: 'Kutatásaink a TV-ben',
  sociological_research_37: 'Tekintse meg jelentéseinket',
  sociological_research_38:
    'Munkánk tudományos megközelítése garantálja ügyfeleink számára a pontos és megbízható szociológiai adatokat Ukrajna és Európa egész területén, minimális hibahatár mellett',
  sociological_research_39:
    'Munkánkat a szociológiai kutatások végzésére vonatkozó valamennyi etikai alapelv és szabvány, valamint szabály betartásával végezzük.',
  sociological_research_40:
    'Betartjuk az Ukrán Szociológiai Szövetség szociológusokra vonatkozó Szakmai Etikai Kódexét és a kutatások etikai alapelveiről szóló Helsinki Nyilatkozatot. Az ESOMAR, az Ukrán Marketing Szövetség és az Ukrán Kontaktközpontok Összukrán Szövetségének tagjai vagyunk.',
  sociological_research_41: 'Field',
  sociological_research_42: 'online panel',
  sociological_research_43: 'rendszeres kérdezőbiztosok',
  sociological_research_44: 'supervisorok',
  sociological_research_45: 'A fieldwork minőségellenőrzése',
  sociological_research_46: 'A GPS-koordináták 100%-os rögzítése (CAPI)',
  sociological_research_47: 'Kérdőívek validálása (CAWI, CAPI, CATI, PAPI)',
  sociological_research_48: 'Az interjúk 100%-os rögzítése (CAPI, CATI)',
  sociological_research_49: 'Licencelt szoftvereket használunk:',
  sociological_research_50:
    'SPSS statisztikai adatok elemzésére és adathalmazok feldolgozására',
  sociological_research_51:
    'DigSee Sure CAPI-hoz: kérdőívlogika, geolokáció, interjúk hangfelvétele, videóanyagok bemutatása',
  sociological_research_52:
    'SurveyMonkey CAWI-hoz: kérdőívlogika, kényelmes formátum, vizualizáció',
  sociological_research_53:
    'VoIPTime (kontaktközpont): bármilyen összetettségű kérdőívek programozása, hangfelvételek továbbítása az ügyfél számára',
  sociological_research_54: 'Minta',
  sociological_research_55:
    'Bármilyen összetettségű mintákat számítunk ki és alkalmazunk',
  sociological_research_56:
    'Munkánk során egyszerű, szisztematikus, rétegzett és klasztermintákat alkalmazunk',
  sociological_research_57:
    'Országosan reprezentatív személyes felmérésekhez rétegzett, többlépcsős mintavételi eljárásokat alkalmazunk',
  sociological_research_58:
    'A települések régiónkénti kiválasztása a település méretének és típusának megfelelően történik, számukat pedig az egyes régiókban képviselt arányuk alapján határozzuk meg',
  sociological_research_59: 'Csapat',
  sociological_research_60:
    'Szociológusaink az Ukrán Szociológusok Szövetségének tagjai',
  sociological_research_61:
    '12 főállású elemzőnk van, akik különböző iparágakban szerzett tapasztalattal rendelkeznek mind kvantitatív, mind kvalitatív projektekben.',
  sociological_research_62:
    'Erős, több mint 10 éves kutatási tapasztalattal rendelkező szakemberekből álló elemzői csapattal rendelkezünk. Csapatunkban tudósok, PhD-fokozattal és MBI-végzettséggel rendelkező szakemberek is dolgoznak.',
  sociological_research_63: 'Iryna Maksymiuk',
  sociological_research_64:
    'A kutatási osztály vezetője. Több mint 15 éves tapasztalattal rendelkezik marketingkutatásban, a kutatások irányításában minden szakaszban, valamint elemző jelentések és prezentációk készítésében',
  sociological_research_65: 'Andriy Biloskursky',
  sociological_research_66:
    'Programozási és adatfeldolgozási vezető. 20 éves tapasztalattal rendelkezik marketing-, szociológiai és piackutatásban',
  sociological_research_67: 'Olena Somova',
  sociological_research_68:
    'Programozási szakértő. A DonSUU szociológia szakának posztgraduális hallgatója. 5 éves tapasztalattal rendelkezik marketingkutatásban. A Demokratikus Nők Szövetségének elnökségi tagja, fundraising vezető.',
  sociological_research_69: 'Anna Padalka',
  sociological_research_70:
    'A Kutatási Osztály Szociológiai Kutatási Divíziójának vezetője, 13 éves tapasztalattal rendelkezik nemzetközi és országos szintű szociológiai és társadalmi projektekben. PhD fokozattal rendelkezik szociológiából, valamint az Ukrán Kontaktközpontok Szövetsége Kutatási Bizottságának vezetője.',
  ad_hoc_1: 'Ad Hoc',
  ad_hoc_2: 'Fedezze fel alternatív kutatási megoldásainkat egyedi esetekhez',
  ad_hoc_3: 'Lépjen kapcsolatba velünk',
  ad_hoc_4: 'Megközelítésünk',
  ad_hoc_5:
    'Szakértői csapatunk gondosan elemzi a begyűjtött adatokat, és olyan összetett megoldásokat tár fel, amelyek hozzájárulnak vállalkozása növekedéséhez.',
  ad_hoc_6:
    'Egyedi, az Ön konkrét igényeire szabott kutatást tervezünk, amely számos módszertant ötvöz, beleértve a felméréseket, interjúkat, fókuszcsoportokat, adatelemzést és egyéb módszereket.',
  ad_hoc_7: 'Miért válassza az Ad Hoc kutatást?',
  ad_hoc_8: 'Rugalmasság',
  ad_hoc_9:
    'Nincs két egyforma kutatási projekt. Az Ad Hoc kutatás segítségével rugalmasan alakíthatjuk és fejleszthetjük az egyedi megközelítést az aktuális igényeknek megfelelően, így biztosítva, hogy az eredmények továbbra is relevánsak és jól alkalmazhatók legyenek.',
  ad_hoc_10: 'Pontosság',
  ad_hoc_11:
    'A módszertanokat az Ön egyedi igényeihez igazítva pontos és célzott eredményeket biztosítunk, amelyek értékes betekintést nyújtanak.',
  ad_hoc_12: 'Innováció',
  ad_hoc_13:
    'Kutatási folyamatunkban az innovációt és a kreativitást helyezzük előtérbe, új technikákat és megközelítéseket alkalmazva a rejtett lehetőségek és kihívások feltárására.',
  ad_hoc_14: 'Időszerűség',
  ad_hoc_15:
    'Az Ad Hoc kutatás gyors megvalósítást tesz lehetővé, így időben hozzáférhet a kritikus fontosságú információkhoz, és versenyelőnyben maradhat az iparágában.',
  ad_hoc_16: 'Szakértelmünk',
  ad_hoc_17:
    'A több mint 20 éves piackutatási és ügyfélélmény-területen szerzett tapasztalattal rendelkező 4Service szakértői olyan egyedi megoldásokat dolgoznak ki, amelyek elősegítik vállalkozása növekedését',
  ad_hoc_18:
    'Az Ön konkrét igényei alapján különálló eszközkészletet alkalmazunk',
  ad_hoc_19: 'Egyik módszertan sem működik az Ön számára?',
  ad_hoc_20: 'Kérje az Ad Hoc kutatást',
  ad_hoc_21: 'Egyedi problémára szabva',
  ad_hoc_22:
    'A különböző módszertanok egyes elemeinek kombinációját, valamint teljesen új megközelítést is alkalmazunk',
  ad_hoc_23: 'Egyéni megközelítés',
  ad_hoc_24: 'A megoldást gondosan, közvetlenül az Ön problémájához igazítjuk',
  ad_hoc_25: 'Tegyen többet a vártnál',
  ad_hoc_26:
    'Gyakorlati cselekvési tervet és ajánlásokat biztosítunk, amelyek segítenek vállalkozásának elérni céljait',
  ad_hoc_27: 'Nem szabványos problémával néz szembe',
  ad_hoc_28: 'Egyik módszertan sem megfelelő az Ön problémájára',
  ad_hoc_29:
    'Egyszerre több különböző módszertant vagy azok egyes részeit szeretné igénybe venni',
  ad_hoc_30: 'Kinek előnyös az Ad Hoc kutatás?',
  service_design_1: 'Néhány ügyfelünk',
  service_design_2: 'Szolgáltatástervezés',
  service_design_3:
    'Alakítsa át vállalkozását a termék- és értékesítésközpontú működésről szolgáltatás- és emberközpontú működésre',
  service_design_4: 'Beszéljen szakértőnkkel',
  service_design_5: 'Tanuljon ingyen!',
  service_design_6:
    'Gyakorlati és hasznos információkat gyűjtöttünk össze Szolgáltatástervezési Könyvtárunkban',
  service_design_7:
    'A Könyvtár minden lépés részletes leírását, releváns eszközöket és technikákat, a fontos részletekre vonatkozó tippeket, valamint bemutatóvideókat tartalmaz.',
  service_design_8: 'Lépjen a Könyvtárba',
  service_design_9: 'Használja ki a Szolgáltatástervezés előnyeit!',
  service_design_10:
    'A szolgáltatástervezés célja olyan szolgáltatások létrehozása és fejlesztése, amelyek a teljes szolgáltatási ökoszisztémát — az embereket, folyamatokat és érintkezési pontokat — figyelembe véve növelik a felhasználói elégedettséget és a működési hatékonyságot',
  service_design_11:
    'A szolgáltatástervezés nem csupán arról szól, hogy miért választja az egyik kávézót a másik helyett. Arról is szól, hogy miért tér vissza újra és újra ugyanoda, és miért mesél róla minden barátjának.',
  service_design_12:
    'Hogyan profitálhat vállalkozása a Szolgáltatástervezésből',
  service_design_13: 'Felhasználói elégedettség',
  service_design_14:
    'Hozzon létre zökkenőmentes, személyre szabott élményeket, amelyek örömet szereznek a felhasználóknak.',
  service_design_15: 'Működési hatékonyság',
  service_design_16:
    'Egyszerűsítse a folyamatokat, csökkentse a költségeket és javítsa a szolgáltatásnyújtást.',
  service_design_17: 'Márkakövetkezetesség',
  service_design_18:
    'Biztosítsa, hogy minden érintkezési pont összhangban legyen a márka értékeivel.',
  service_design_19: 'Alkalmazkodás a változásokhoz',
  service_design_20:
    'Tervezzen olyan szolgáltatásokat, amelyek a változó igényekkel együtt képesek növekedni és fejlődni.',
  service_design_21: 'Lojalitás növelése',
  service_design_22:
    'Építsen erősebb ügyfélkapcsolatokat és növelje a lojalitást kiemelkedő szolgáltatási élményekkel.',
  service_design_23: 'Versenyelőny',
  service_design_24:
    'Tűnjön ki a piacon egyedi és emlékezetes szolgáltatási élményekkel.',
  service_design_25: 'Miért',
  service_design_26: 'Miért válassza a Szolgáltatástervezést?',
  service_design_27:
    'Ez egy olyan kultúra, módszertan és gondolkodásmód, amely világszerte segíti a vállalatokat abban, hogy a termék- és értékesítésközpontú működésről az emberi igényekre és problémákra helyezzék a hangsúlyt.',
  service_design_28: 'Szolgáltatásaink',
  service_design_29: 'Ügyfélközpontú szolgáltatástervezés',
  service_design_30:
    'Ügyfélközpontú projekteket fejlesztünk és valósítunk meg új termékek létrehozására vagy meglévő termékek fejlesztésére. Képzéseket is biztosítunk a munkatársak számára, hogy önállóan tudjanak dolgozni ezekkel a változtatásokkal.',
  service_design_31: 'Munkavállalói szolgáltatástervezés',
  service_design_32:
    'Gyakorlati képzés munkavállaló-központú folyamatok, struktúrák és változtatások vállalaton belüli fejlesztéséhez és megvalósításához.',
  service_design_33: 'Jövőorientált design thinking',
  service_design_34:
    'Jövőbeli koncepciók és vállalati stratégia kidolgozása különböző forgatókönyvek és lehetséges innovációk figyelembevételével.',
  service_design_35: 'Kreativitás az üzleti életben',
  service_design_36:
    'Gyakorlati képzés, amely segít a résztvevőknek a kreativitás alkalmazásában konkrét problémák megoldására és egyedi piaci megoldások kidolgozására.',
  service_design_37: 'Workshopjaink',
  service_design_38:
    'Gyakorlati workshopokat biztosítunk résztvevőink számára világszerte elismert tanúsítvánnyal',
  service_design_39:
    'Hozzon létre az elvárásokat meghaladó termékeket, szolgáltatásokat és létesítményeket',
  service_design_40: 'Valósítson meg működőképes üzleti folyamatokat',
  service_design_41:
    'Harmonizálja a vállalat munkatársai és ügyfelei közötti kapcsolatot',
  service_design_42: 'Naptár',
  service_design_43: 'Hamarosan',
  service_design_44: 'Tudjon meg többet korábbi eseményeinkről',
  service_design_45: 'A Szolgáltatástervezés alapjai',
  service_design_46:
    'Hozzon létre az elvárásokat meghaladó termékeket, szolgáltatásokat és létesítményeket',
  service_design_47: 'EX Szolgáltatástervezés',
  service_design_48:
    'Hozzon létre az elvárásokat meghaladó termékeket, szolgáltatásokat és létesítményeket',
  service_design_49: 'Továbbiak',
  service_design_50: 'Megközelítésünk',
  service_design_51: 'A 4Service az emberközpontú szolgáltatás alapja!',
  service_design_52:
    'Segítünk a vállalatoknak kialakítani a szükséges gondolkodásmódot és emberközpontú belső környezetet létrehozni.',
  service_design_53: 'Eszközök',
  service_design_54:
    'Az Ön konkrét igényei alapján különböző technikák és eszközök egyedi kombinációját alkalmazzuk',
  service_design_55: 'Felhasználói kutatás',
  service_design_56:
    'Interjúk, felmérések, F2F és etnográfiai kutatások a felhasználói igények és viselkedés megértéséhez',
  service_design_57: 'Perszónák',
  service_design_58:
    'Különböző felhasználótípusokat képviselő fiktív karakterek, amelyek iránymutatást adnak a tervezési döntésekhez',
  service_design_59: 'Ügyfélút-térképek',
  service_design_60:
    'A felhasználói szolgáltatási élmény vizuális megjelenítése, amely azonosítja a kulcsfontosságú érintkezési pontokat és a problémás területeket',
  service_design_61: 'Ötletbörze-szekciók',
  service_design_62:
    'Együttműködésen alapuló ülések az érintettekkel ötletek és megoldások kidolgozására.',
  service_design_63: 'Prototípus-készítés',
  service_design_64:
    'A szolgáltatás előzetes verzióinak létrehozása a koncepciók tesztelésére és finomítására',
  service_design_65: 'Szolgáltatási tervrajzok',
  service_design_66:
    'Részletes diagramok, amelyek bemutatják a különböző szolgáltatási komponensek és folyamatok közötti kapcsolatokat',
  service_design_67: 'Partner',
  service_design_68: '4Service & DTA',
  service_design_69:
    'A 4Service a Design Thinking Academy hivatalos kizárólagos képviselője',
  service_design_70: 'Partnerségünk keretében:',
  service_design_71:
    '<b>gyakorlati képzéseket biztosítunk</b> a szolgáltatástervezési módszer alkalmazásával, vezető szakértők által tartott workshopokon;',
  service_design_72: '<b>minősített design thinking szakembereket képzünk</b>;',
  service_design_73:
    '<b>szolgáltatástervezési projekteket valósítunk meg</b> nemzetközi facilitátorok bevonásával számos vállalat számára.',
  service_design_74:
    'Szolgáltatástervezési Kiválósági Központokat hoztunk létre:',
  service_design_75: 'Ukrajna',
  service_design_76: 'Kazahsztán',
  service_design_77: 'Törökország',
  service_design_78: 'Grúzia',
  service_design_79: 'Azerbajdzsán',
  service_design_80: 'Tudjon meg többet eseteinkről',
  service_design_81: 'Lépjen a könyvtárba',
  service_design_82: 'Üdvözöljük a Szolgáltatástervezés világában!',
  four_opinion_1: 'Felmérés a 4Service által',
  four_opinion_2:
    'Vegyen részt online felmérésekben pénzért, és keressen otthonról',
  four_opinion_3: 'Kezdés',
  four_opinion_4: 'Előnyeink',
  four_opinion_5: 'Megbíznak bennünk',
  four_opinion_6:
    'Közösségünk több mint 90 000 ukrajnai és 100 000 kazahsztáni fogyasztót foglal magában',
  four_opinion_7: 'Méltányosan értékeljük az Ön idejét',
  four_opinion_8:
    'Nagyra értékeljük az idejét, ezért a felmérésekben való részvételért ajándékot vagy pénzjutalmat kaphat',
  four_opinion_9: 'Véleménye jelentős hatással van',
  four_opinion_10:
    'Minden megjegyzése segít a márkáknak jobban megérteni ügyfeleik igényeit',
  four_opinion_11:
    'Vegyen részt a 4Service 4Opinion felméréseiben, keressen online pénzt vagy nyerjen díjat',
  four_opinion_12: 'Csatlakozzon a 4Opinionhoz',
  four_opinion_13: 'Még több érdekes történet a csatornánkon',
  four_opinion_14: 'További részletek Ukrajnáról',
  four_opinion_15: 'További részletek Kazahsztánról',
  four_opinion_16: 'Miért minket válasszon?',
  four_opinion_17:
    'A 4Service egy nemzetközi kutatási holding, amely az ügyfélélmény-menedzsmentre specializálódott',
  four_opinion_18:
    'Az ügyfélélmény-menedzsment területén Európa 10 legjobb ügynöksége között vagyunk',
  four_opinion_19: 'Küldetésünk az ügyfélszolgáltatás fejlesztése világszerte!',
  four_opinion_20: 'Hogyan kezdhet el pénzt keresni online kérdőívekkel?',
  four_opinion_21: 'Regisztráljon a weboldalon',
  four_opinion_22: 'Értesítéseket kap az elérhető kérdőívekről',
  four_opinion_23: 'Töltse ki a kérdőíveket és keressen pénzt',
  four_opinion_24: 'Valódi vélemények válaszadóinktól',
  four_opinion_25: 'Vitaliy Kokhan',
  four_opinion_26:
    '“Kitöltöttem egy kérdőívet, és még el is felejtettem. Egy idő után Nataliya asszony felhívott, és elmondta, hogy nyertem egy nyereményt. És íme, itt van a Samsung Galaxy M52 5G telefonom. Nagyon szépen köszönöm😁”',
  four_opinion_27: 'Viktoriya Popovska',
  four_opinion_28:
    '“Megkaptam a hangszórót, nagyon szépen köszönöm a tisztességes, korrekt és izgalmas nyereményjátékot.”',
  four_opinion_29: 'Yuliya Oleksandrivna',
  four_opinion_30:
    '“Valószínűleg ez a legcsodálatosabb dolog, ami mostanában történt velem💕 Nemcsak nyertem, hanem valami igazán klassz dolgot is kaptam. Bármit el tudtam volna képzelni, de azt nem, hogy ennyire nagyszerű lesz. Még egyszer hatalmas köszönet!”',
  four_opinion_31:
    'Csak nálunk van lehetősége valódi pénzt keresni vagy nyereményt nyerni',
  four_opinion_32: 'Kövesse az elérhető kérdőíveket csatornánkon',
  four_opinion_33: 'Ugrás a csatornára',
  career_1: 'Legyen a része',
  career_2: '4Service',
  career_3:
    'Várjuk Önt egy olyan csapatban, ahol korlátlan lehetősége van a folyamatos szakmai fejlődésre!',
  career_4: 'Állásajánlatok',
  career_5: 'Nem találta meg a megfelelő állást?',
  career_6: 'Küldje el önéletrajzát, és felvesszük Önnel a kapcsolatot!',
  career_7: 'Önéletrajz küldése',
  career_8: 'Regisztrációs űrlap',
  career_9: '*Keresztnév',
  career_10: '*Vezetéknév',
  career_11: '*E-mail',
  career_12: '*Telefonszám',
  career_13: 'Önéletrajz feltöltése',
  career_14: 'Küldés',
  career_15: 'Kezdje el karrierjét a 4Service-nél',
  career_16: 'Főbb feladatok:',
  career_17: 'Elvárások:',
  career_18: 'Amit kínálunk:',
  career_19: 'Jelentkezés',
  career_20: 'A 4Service egy nemzetközi kutatási holding',
  career_21: '2001 óta működünk',
  career_22: 'Rólunk',
  career_23: 'Vállalati kultúrát fejlesztünk',
  career_24: 'Kezdeményezéseink',
  career_25: 'Világszerte javítjuk az ügyfélszolgáltatás minőségét',
  career_26: '4Service állásajánlatok',
  career_27: 'Az Ön lehetőségei a 4Service-nél',
  career_28:
    'A mentális egészség támogatása heti “Morning coffee” ülések keretében, csapatépítő programok és társadalmi kezdeményezések',
  career_29:
    'Érdekes tapasztalat a világ legismertebb márkáival való együttműködésben, mint például: <span>Mercedes, Huawei, Philip Morris</span>',
  career_30:
    'Folyamatos szakmai fejlődés szemináriumokon, képzéseken és workshopokon keresztül',
  career_31: 'Próbavásárlói szerep és hatás a jól ismert márkák fejlődésére',
  career_32:
    'Együttműködés a világ bármely pontjáról, valamint lehetőség távoli munkavégzésre vagy irodai munkára: <span>Ukrajnában, Kazahsztánban, Romániában, Ausztriában, Azerbajdzsánban, Grúziában</span>',
  career_33:
    'Saját márkájának fejlesztése eseményeken, webináriumokon és networking programokon való részvétellel',
  career: 'Karrier',
  footer_btn_1: 'Legyen próbavásárló',
  footer_btn_2: 'Töltsön ki fizetett kérdőíveket',
  diary_study_1: 'Napló',
  diary_study_2: 'Tanulmány',
  diary_study_3:
    'Kövesse nyomon és gyűjtse össze a felhasználói élmények és életmódok időbeli változásaira vonatkozó insightokat',
  diary_study_4: 'Beszéljen szakértővel',
  diary_study_5: 'Lépjen kapcsolatba velünk',
  diary_study_6: 'Kezdje el',
  diary_study_7:
    'Kérjen Diary Study kutatást, hogy egyetlen megoldásban hozzáférjen kvalitatív és kvantitatív adatokhoz, amelyek értékes betekintést nyújtanak a fogyasztói magatartásba, a piaci trendekbe és a márka teljesítményébe',
  diary_study_8: 'Az életmód és a felhasználói élmény dinamikus vizsgálata',
  diary_study_9:
    'A Diary Study mélyreható, kontextusba helyezett betekintést nyújt abba, hogyan lépnek kapcsolatba a felhasználók, segítve az olyan mintázatok és változások azonosítását, amelyek más módszerekkel nem feltétlenül lennének láthatók.',
  diary_study_10:
    'Ez a módszer lehetővé teszi az adatok valós időben, természetes környezetben történő gyűjtését, jelentősen növelve azok megbízhatóságát és relevanciáját',
  diary_study_11: 'Biztosítunk',
  diary_study_12: 'Személyre szabott Diary Study kutatásokat biztosítunk',
  diary_study_13: 'Fogyasztói elköteleződés',
  diary_study_14:
    'Online közösségeket biztosítunk olyan résztvevőkkel, akik mindennapi környezetükben hosszabb időn keresztül dokumentálják viselkedésüket, tevékenységeiket és tapasztalataikat. ',
  diary_study_15: 'Piackutatás',
  diary_study_16:
    'Megközelítésünk mélyreható piackutatáson alapul, hogy ügyfeleink egyedi igényeihez releváns és értékes adatokat biztosítsunk.',
  diary_study_17: 'Márka insightok',
  diary_study_18:
    'Mélyrehatóan vizsgáljuk a fogyasztói percepciókat és viselkedést, hogy olyan értékes insightokat tárjunk fel, amelyek formálják a márkastratégiákat.',
  diary_study_19: 'Szakértők',
  diary_study_20:
    'A több mint 20 éves ügyfélélmény-tapasztalattal rendelkező 4Service szakértői egyedi megoldásokat hoznak létre, amelyek segítik vállalkozása növekedését',
  diary_study_21: 'Projektmenedzsment',
  diary_study_22:
    'Csapatunk átfogó projektmenedzsment-támogatást nyújt, biztosítva, hogy minden részlet gondosan meg legyen tervezve és megvalósítva a gördülékeny eredmények érdekében.',
  diary_study_23: 'Tanácsadás',
  diary_study_24:
    'Szakértői tanácsadást kínálunk, hogy ügyfeleinket a projekt minden szakaszán végigvezessük, kezeljük a kihívásokat és optimalizáljuk a teljesítményt.',
  diary_study_25: 'Minőségbiztosítás',
  diary_study_26:
    'Minden szakaszban szigorú minőségi követelményeket tartunk fenn, garantálva, hogy projektjeink megfeleljenek, sőt meghaladják az elvárásokat.',
  diary_study_27: 'Előny',
  diary_study_28: 'Élvezze a velünk való együttműködés előnyeit',
  diary_study_29: '<b>Korlátlan forrás</b> az időbeli insightokhoz',
  diary_study_30: '<b>Szakértői útmutatás</b> a folyamat minden szakaszában',
  diary_study_31:
    '<b>Vállalkozások összekapcsolása</b> fogyasztókkal világszerte',
  diary_study_32:
    '<b>Kényelmes adatgyűjtés</b> mélyreható visszajelzésekkel és válaszokkal',
  diary_study_33: '<b>Hozzáférhető adatok</b> a projekt bármely szakaszában',
  diary_study_34:
    '<b>Komplex megoldások</b>, amelyek hozzájárulnak az Ön növekedéséhez',
  diary_study_35: 'Kutatás',
  diary_study_36: 'Személyre szabott kvantitatív kutatás értékes insightokkal',
  shoppers_1: 'Titkos vásárlók platformja',
  shoppers_2: 'Titkos vásárlók',
  shoppers_3: 'Csatlakozás',
  shoppers_4: 'Értékelje a szolgáltatást és keressen pénzt a 4Service-szel',
  shoppers_5: 'Kezdje el karrierjét a 4Service-nél',
  shoppers_6: 'Érdekes projekteken való munkavégzés vár Önre',
  shoppers_7: 'Csatlakozás',
  shoppers_8: 'Csatlakozzon csapatunkhoz',
  shoppers_9: 'Tudjon meg többet ›',
  shoppers_10: 'Szupervizor',
  shoppers_11:
    'Olyan vezető, aki felügyeli a csapat munkáját, felelős a tervezésért, a munkafolyamatok koordinálásáért, a minőségellenőrzésért és a szervezési kérdések megoldásáért, biztosítva a kitűzött feladatok teljesítését.',
  shoppers_12: 'Titkos vásárló',
  shoppers_13:
    'Olyan szakértő, aki üzletekbe, éttermekbe vagy más létesítményekbe látogat el az előírt forgatókönyv szerint, majd beszámol a tapasztalatairól. ',
  shoppers_14: 'Merchandiser',
  shoppers_15:
    'Olyan szakember, aki az áruk üzletekben történő kihelyezésével foglalkozik a márka vagy a vállalat szabványainak megfelelően.',
  shoppers_16: 'Auditor',
  shoppers_17:
    'Olyan szakember, aki ellenőrzi a tevékenységet annak megállapítása érdekében, hogy az megfelel-e az előírt szabványoknak és követelményeknek.',
  shoppers_18: 'Tesztelő',
  shoppers_19:
    'Olyan szakember, aki az ügyfél szemszögéből ellenőrzi a szolgáltatás, a termékek vagy a folyamatok minőségét, értékeli azok megfelelését a fogyasztói elvárásoknak, és azonosítja az esetleges problémákat.',
  shoppers_20: 'Titkos pályázó',
  shoppers_21:
    'Olyan szakember, aki elemzi az ügyfélkiszolgálás folyamatát, értékeli a kommunikáció minőségét, a reakcióidőt, az eljárások kényelmét és az interakció általános benyomását.',
  shoppers_22: 'Promóter',
  shoppers_23:
    'Olyan szakértő, aki termékeket népszerűsít a termékek bemutatásával, reklámanyagok terjesztésével, promóciók szervezésével és az ügyfelek kérdéseinek megválaszolásával. ',
  shoppers_24: 'Interjú résztvevő',
  shoppers_25:
    'A mélyinterjú résztvevője egy részletes kutatásban vesz részt, amelynek célja az adott témával, termékkel vagy szolgáltatással kapcsolatos gondolatainak, érzelmeinek, motivációinak vagy tapasztalatainak feltárása.',
  shoppers_26: 'Legyen a 4Service része',
  shoppers_27: 'Világszerte <b>dolgozunk</b>',
  shoppers_28: 'Csapatunk több mint <b>1000 szakemberből áll</b>',
  shoppers_29:
    'Több mint <b>20 éves sikeres piaci tapasztalattal</b> rendelkezünk',
  shoppers_30: 'Útmutatók',
  shoppers_31: 'Hogyan készítsen hangfelvételt a látogatásról',
  shoppers_32: 'Hogyan készítsen hangfelvételt a hívásról',
  shoppers_33: 'Nem sikerül csatolnia a hangfájlt a kérdőívhez?',
  shoppers_34:
    'Az MSPA szakmai standardok és etikai kódexe titkos vásárlók számára',
  shoppers_35: 'F.A.Q.',
  shoppers_36: 'Gyakran ismételt kérdések',
  shoppers_37: 'Mennyit lehet keresni havonta?',
  shoppers_38: 'Milyen gyakran végezhetek feladatokat a városomban?',
  shoppers_39:
    'Mit tegyek, ha a helyszín zárva van, és mekkora a jutalom egy ilyen látogatásért?',
  shoppers_40: 'Hogyan történik a jutalom kifizetése?',
  shoppers_41: 'Mennyi idő alatt kapom meg a jutalmat?',
  shoppers_42:
    'Kihez fordulhatok a jutalom kifizetésével kapcsolatos kérdésekkel?',
  shoppers_43:
    'A havi jutalom összege attól függ, hogy milyen intenzitással végzi a feladatokat.',
  shoppers_44:
    'Egy feladat elvégzésének díja 40 hrivnyától – egyszerű látogatások és hívások esetén – akár 1200 hrivnyáig terjedhet összetett és prémium látogatások esetén. Ez a projekt összetettségétől és sajátosságaitól függ.',
  shoppers_45:
    'A feladatok elvégzése kellemes hobbi lehet az Ön számára, amely összekapcsolható a mindennapi vásárlásokkal vagy a barátokkal közös kávézók, pizzériák és éttermek látogatásával',
  shoppers_46: 'a helyszínek számától és a projektek méretétől;',
  shoppers_47:
    'a rotációtól (ugyanazon helyszín látogatása legfeljebb háromhavonta / negyedévente egyszer);',
  shoppers_48:
    'attól, hogy profilja / készségei mennyire felelnek meg a projekt követelményeinek;',
  shoppers_49: 'a jelentkezés benyújtásának gyorsaságától.',
  shoppers_50: 'Ha az Ön által ellenőrzött helyszín:',
  shoppers_51:
    'Zárva van – fényképezze le a bejárati ajtót, a bezárás okáról szóló közleményt, ha van ilyen, vagy a helyszín nyitvatartását, valamint a helyszín címét tartalmazó homlokzatot.',
  shoppers_52:
    'Nem található a megadott címen – készítsen VIDEÓFELVÉTELT a környező területről, valamint fényképet a szomszédos épület homlokzatáról, amelyen látható a cím. Ezt követően forduljon a koordinátorához.',
  shoppers_53:
    'A jutalom kifizetése bankkártyára történik: magánszemélyek számára a «PrivatBank» kártyájára.',
  shoppers_54:
    'A jutalom kifizetésének határidejét személyes fiókjában tekintheti meg.',
  shoppers_55:
    'Továbbá érdeklődhet koordinátoránál, vagy felveheti a kapcsolatot a Titkos Vásárlók ügyfélszolgálatával a következő címen: ua@4service.support, az e-mail tárgyában pedig tüntesse fel annak a projektnek a nevét, amellyel kapcsolatban kérdése merült fel.',
  shoppers_56:
    'A jutalom kifizetésének általános határideje személyes fiókjában található: «Főoldal».',
  shoppers_57:
    'Ha nem kapta meg a jutalmat, és a határidő már lejárt, végezze el a következő lépéseket személyes fiókjában:',
  shoppers_58:
    '1. Ellenőrizze, hogy minden személyes adata ki van-e töltve, és nincs-e üres mező;',
  shoppers_59:
    '2. Ellenőrizze, hogy fizetési kártyájának adatai helyesen vannak-e megadva, és a kártya érvényességi ideje nem járt-e le;',
  shoppers_60:
    '3. Ellenőrizze, hogy magánszemélyek számára kiállított bankkártya van-e megadva;',
  shoppers_61:
    '4. Ellenőrizze, hogy a rendszerben szereplő teljes neve megegyezik-e a kártyán szereplő névvel (hibamentesen van-e kitöltve).',
  shoppers_62:
    'Ha minden adatot ellenőrzött, és minden helyesen van kitöltve – forduljon a Titkos Vásárlók ügyfélszolgálatához a következő címen: ua@4service.support, az e-mail tárgyában pedig tüntesse fel annak a projektnek a nevét, amellyel kapcsolatban kérdése merült fel.',
  shoppers_63: 'Alkalmazások <br /> titkos vásárlók számára',
  shoppers_64: 'Töltse le a 4Soppers alkalmazást:',
  shoppers_65: 'vagy',
  shoppers_66: 'Lépjen kapcsolatba velünk',
  shoppers_67: 'Chat az ügyfélszolgálattal',
  shoppers_68: 'Telefon:',
  shoppers_69: 'E-mail:',
  shoppers_70: 'Maradtak kérdései?',
  shoppers_71: 'Ügyfélszolgálat <br /> terepi munkatársak számára',
  shoppers_72: 'Kapcsolatfelvétel',
  shoppers_73: 'Terepi munkatársak ügyfélszolgálata',
  shoppers_74:
    'Kérdések a látogatásokkal, kifizetésekkel és a titkos vásárlói munkával kapcsolatos egyéb részletekkel kapcsolatban',
  shoppers_75:
    'Hozzájárulok személyes adataim feldolgozásához az alábbiak szerint:',
  shoppers_76: 'Az Ön teljes neve',
  shoppers_77: 'A probléma lényege',
  shoppers_78: 'Az Ön bejelentkezési neve',
  shoppers_79: 'Kapcsolattartási telefonszám',
  shoppers_80: 'Fizetési határidők',
  shoppers_81: 'Egyéb',
  shoppers_82: 'Lépjen kapcsolatba velünk',
  employee_experience_1: 'Munkavállalói élmény',
  employee_experience_2: 'Üzleti sikere a munkavállalói élménnyel kezdődik',
  employee_experience_3: 'Lépjen kapcsolatba velünk',
  employee_experience_4: 'Az Ön sikertörténete itt kezdődik',
  employee_experience_5:
    'A több mint 20 éves piackutatási és ügyfélélmény-szakértelemmel rendelkező 4Service szakértői egyedi megoldásokat hoznak létre, amelyek segítik vállalkozása fejlődését.',
  employee_experience_6:
    'Szolgáltatásaink biztosítják a vállalkozások számára a szükséges eszközöket a megalapozott döntések meghozatalához, a stratégiák finomításához és az adott iparágban elért sikerek előmozdításához.',
  employee_experience_7:
    'Az Ön egyedi igényeihez leginkább megfelelő módszertant választjuk',
  employee_experience_8: 'Munkavállalói életút térkép',
  employee_experience_9:
    'A munkavállalói életút teljes folyamatát feltérképezzük a toborzástól a kilépésig, azonosítva azokat a kulcsfontosságú érintkezési pontokat, amelyek hatással vannak az élményükre. Ez segít meghatározni a fejlesztendő területeket és a lehetőségeket az elégedettség és az elkötelezettség növelésére minden szakaszban',
  employee_experience_10: 'Munkavállalói életút térkép benchmarkkal',
  employee_experience_11:
    'A munkavállalói életút feltérképezését egy lépéssel tovább visszük azzal, hogy összehasonlítjuk munkavállalói élményeit az iparági benchmarkokkal. Ez segít azonosítani a belső folyamatok egyszerűsítésének, a munkavállalói lojalitás növelésének és a legjobb gyakorlatok alkalmazásának lehetőségeit.',
  employee_experience_12: 'Munkáltatói márka egészségének kutatása',
  employee_experience_13:
    'Felmérjük, hogyan érzékelik munkavállalói vállalatának márkáját belülről. Az erős belső márka motiváltabb és lojálisabb munkaerőt eredményez, ami jobb ügyfélkapcsolatokat és erősebb külső megítélést tesz lehetővé.',
  employee_experience_14: 'Munkavállalói Net Promoter Score (eNPS)',
  employee_experience_15:
    'Az eNPS segítségével mérjük, mennyire valószínű, hogy munkavállalói ajánlanák vállalatát nagyszerű munkahelyként. Ez az egyszerű, mégis hatékony mutató betekintést nyújt a munkavállalói elégedettség és lojalitás általános szintjébe.',
  employee_experience_16:
    'Munkavállalói elkötelezettségi és elégedettségi index (ECSI)',
  employee_experience_17:
    'ECSI-módszertanunk azt értékeli, mennyire elkötelezettek és elégedettek munkavállalói a szerepükkel és a vállalattal. Ez segít felmérni elkötelezettségük szintjét és azokat a területeket, ahol fejlesztésekre van szükség a megtartás növeléséhez.',
  employee_experience_18:
    'Mélységi interjúk korábbi és jelenlegi munkavállalókkal',
  employee_experience_19:
    'Interjúkat készítünk korábbi munkavállalókkal annak feltárására, miért távoznak, és hogyan javítható a megtartás. A jelenlegi munkatársakkal folytatott beszélgetések feltárják az ügyfélkiszolgálás javításának, az elkötelezettség növelésének és a KPI-ok elérését akadályozó tényezők leküzdésének lehetőségeit.',
  employee_experience_20: 'UGC-elemzés',
  employee_experience_21:
    'A felhasználók által létrehozott tartalmak (UGC) elemzése során szakosodott weboldalakról, közösségi médiából, fórumokról és videoplatformokról gyűjtünk értékeléseket. Ez az elemzés segít megérteni a valós ügyfélelvárásokat és problémákat, azonosítani a trendeket és a fogyasztói preferenciák változásait, valamint meghatározni a márka erősségeit és gyengeségeit a versenytársakhoz képest.',
  employee_experience_22: 'Titkos munkavállaló',
  employee_experience_23:
    'A titkos munkavállaló egy vállalat értékelése egy potenciális munkavállaló szemszögéből. Felméri, mennyire jól szervezettek a belső folyamatok, hogyan kommunikálnak a jelenlegi munkavállalók a jelöltekkel, valamint hogy a vállalat mennyire hatékonyan tartja be szolgáltatási és kommunikációs standardjait.',
  employee_experience_24: 'Motivációs látogatások',
  employee_experience_25:
    'A motivációs látogatások jutalmazzák azokat a munkavállalókat, akik megfelelnek a szolgáltatási standardoknak, például kiváló ügyfélkapcsolatot alakítanak ki vagy sikeres upsellinget végeznek. A Mystery Shoppered azonosítják a legjobb teljesítőket, ezáltal növelik a motivációt és ösztönzik a többieket, hogy példájukat követve díjakat és elismerést szerezzenek.',
  employee_experience_26: 'Service Design',
  employee_experience_27:
    'A Service Design segítségével azonosítjuk az üzleti kihívásokat és innovatív megoldásokat tárunk fel, olyan stratégiákat kialakítva, amelyek javítják a szolgáltatásnyújtást, valamint választ adnak az ügyfelek és a munkavállalók igényeire.',
  employee_experience_28: 'HR-kutatás',
  employee_experience_29:
    'A HR-kutatás segít mérni, hogy a munkavállalók mennyire azonosulnak a vállalat küldetésével és értékeivel, illetve mennyire hatékonyan közvetítik azokat az ügyfelek felé.',
  employee_experience_30:
    'Közös értékteremtés a munkavállalókkal (fókuszcsoportok)',
  employee_experience_31:
    'A munkavállalókat közvetlenül bevonva közös értékteremtő fókuszcsoportokat szervezünk visszajelzések és betekintések gyűjtésére. Ez az együttműködésen alapuló folyamat lehetőséget ad munkatársainak arra, hogy hozzájáruljanak munkakörnyezetük alakításához, erősítve a felelősségvállalás és az elkötelezettség érzését.',
  employee_experience_32: 'Miért érdemes befektetni a munkavállalói élménybe?',
  employee_experience_33: 'Csökkentse a munkavállalói fluktuációt',
  employee_experience_34:
    'Tartsa meg legjobb munkatársait olyan munkahely kialakításával, ahol szívesen maradnak és fejlődnek.',
  employee_experience_35: 'Növelje a munkavállalói lojalitást',
  employee_experience_36:
    'Építsen hosszú távú elkötelezettséget és lojalitást munkatársaiban, csökkentve a költséges újratoborzás szükségességét.',
  employee_experience_37: 'Zökkenőmentes alkalmazkodás a változásokhoz',
  employee_experience_38:
    'Csökkentse az új szabályokkal és kezdeményezésekkel szembeni ellenállást, biztosítva a vállalaton belüli gördülékenyebb átmenetet.',
  employee_experience_39: 'Növelje a termelékenységet',
  employee_experience_40:
    'Segítse csapatát az új folyamatok elfogadásában és abban, hogy sikeresen teljesítsenek szerepköreikben.',
  employee_experience_41: 'Csökkentse az üzleti költségeket',
  employee_experience_42:
    'Egyszerűsítse a folyamatokat, ami költségmegtakarításhoz és a bevételek növekedéséhez vezet.',
  employee_experience_43:
    'A kiváló munkavállalói élmény ösztönzi az üzleti növekedést',
  employee_experience_44:
    'A munkavállalói élmény (EX) magában foglal mindent, amivel a munkavállalók találkoznak és amit átélnek a vállalatnál töltött teljes életútjuk során.',
  employee_experience_45:
    'A pozitív EX elősegíti a vállalati célokkal való összhangot, növeli a motivációt és erősíti az elkötelezettséget.',
  employee_experience_46:
    'Az elégedett és elkötelezett munkavállalók kiemelkedő szolgáltatást nyújtanak, ami elégedett ügyfelekhez és fenntartható növekedéshez vezet.',
  employee_experience_47:
    'Az EX-be történő befektetés tovagyűrűző hatást eredményez – jobb megtartást, nagyobb termelékenységet és erősebb üzleti eredményeket.',
  employee_experience_48:
    'Az Ön EX + CX értékei közvetlenül hatnak vállalkozására',
  employee_experience_49:
    'A munkavállalói élmény (EX) és az ügyfélélmény (CX) szorosan összekapcsolódik. Az elégedett csapat nagyobb valószínűséggel nyújt kiemelkedő szolgáltatást, ami magasabb ügyfélelégedettséghez vezet. Integrált EX- és CX-megközelítésünkkel összehangolhatja belső vállalati kultúráját a külső ügyfélkiszolgálás kiválóságával.',
  employee_experience_50:
    'A munkavállalói és ügyfélélményre vonatkozó ismeretek integrálásával átfogó megközelítést biztosítunk mindkettő fejlesztéséhez. Az eredmény egy erősebb, összetartóbb vállalati kultúra, amely elősegíti az üzleti sikert',
  employee_experience_51: 'Elégedett munkáltató',
  employee_experience_52: 'Kiváló szolgáltatás',
  employee_experience_53: 'Elégedett ügyfél',
  cati_1: 'CATI',
  cati_2: 'Hatékony számítógéppel támogatott telefonos felmérések',
  cati_3: 'Lépjen kapcsolatba velünk',
  cati_4: 'Megbíznak bennünk',
  cati_5:
    '<b>A CATI (Computer Assisted Telephone Interviewing)</b> olyan adatgyűjtési módszer, amely telefonos felméréseket alkalmaz, ahol az operátorok speciális szoftverrel rögzítik a válaszokat, biztosítják a kérdések logikáját és elemzik az eredményeket.',
  cati_6: 'A CATI fő előnyei a 4Service-nél:',
  cati_7: 'A felmérések lebonyolításának <b>gyorsasága</b>',
  cati_8: '<b>Magas adatminőség</b>',
  cati_9: 'Rugalmasság a kérdőívek <b>testreszabásában</b>',
  cati_10: 'A folyamat <b>automatizálása</b>',
  cati_11: 'Az <b>eszközök széles választéka</b> a minőségellenőrzéshez',
  cati_12:
    'Lehetőség a <b>nehezen elérhető válaszadói kategóriák</b> megkérdezésére',
  cati_13: 'Minden <b>beszélgetés</b> <b>rögzítése</b> a későbbi ellenőrzéshez',
  cati_14: 'Lehetőség egy nagy <b>célközönség gyors elérésére</b>',
  cati_15:
    'A többi adatgyűjtési módszerhez képest <b>költséghatékonyabb</b> módszer',
  cati_16: 'Megoldja',
  cati_17: 'Milyen feladatok oldhatók meg telefonos felmérésekkel:',
  cati_18:
    '<span>Piaci szegmentációs kutatás.</span> A különböző fogyasztói csoportok azonosítása a pontos célzás és a hatékony marketingstratégiák érdekében',
  cati_19:
    '<span>Ügyfélelégedettség értékelése.</span> A fogyasztói lojalitás mérése termékekkel és szolgáltatásokkal kapcsolatban SCI- és NPS-indexek segítségével',
  cati_20:
    '<span>NPS-menedzsment és akcióterv megvalósítása.</span> Telefonos felmérések alkalmazása az ügyfélélmény aktív javítására a contact center segítségével',
  cati_21:
    '<span>Kereslet- és piaci trendek elemzése.</span> A termékek és szolgáltatások népszerűségének vizsgálata, ígéretes régiók és növekedési irányok azonosítása',
  cati_22:
    '<span>Versenykörnyezet elemzése.</span> A márka piaci pozicionálásának értékelése, összehasonlítása a versenytársakkal és növekedési lehetőségek azonosítása',
  cati_23: 'Kinek',
  cati_24: 'A CATI ideális:',
  cati_25: 'Terméket bevezető vállalatok számára',
  cati_26:
    'Naprakész piaci adatok gyűjtéséhez, a versenykörnyezet elemzéséhez és a fogyasztói preferenciák vizsgálatához',
  cati_27: 'Ügyfelekkel dolgozó márkák és vállalatok számára',
  cati_28:
    'Az ügyfélelégedettség szintjének (Customer Satisfaction, NPS) értékeléséhez, az igények elemzéséhez és a visszajelzések gyűjtéséhez',
  cati_29: 'Kiskereskedelem és e-kereskedelem számára',
  cati_30:
    'A fogyasztói magatartás megértéséhez, új termékek teszteléséhez és a vásárlási döntéseket befolyásoló tényezők azonosításához',
  cati_31: 'Bankok és pénzügyi intézmények számára',
  cati_32:
    'A szolgáltatás értékeléséhez, a vállalat iránti bizalom szintjének méréséhez és a szolgáltatásokkal kapcsolatos visszajelzések gyűjtéséhez',
  cati_33: 'Társadalmi szervezetek számára',
  cati_34: 'Szociológiai kutatások végzéséhez és a közvélemény elemzéséhez',
  cati_35: 'Állami intézmények és civil szervezetek számára',
  cati_36:
    'Statisztikai adatok gyűjtéséhez, társadalmi kérdések vizsgálatához és kutatási programok megvalósításához',
  cati_37: 'Minőség',
  cati_38: 'A hívásminőség értékelésének kritériumai',
  cati_39: 'Alapvető kommunikációs készségek',
  cati_40:
    'A köszönési és híváslezárási standardok betartása, valamint a válaszadó számára kényelmes nyelvre való áttérés',
  cati_41: 'Kommunikációs stílus',
  cati_42:
    'Pontos beszéd, udvariasság, barátságos hangnem és a válaszadóval való bizalmi kapcsolat kialakításának képessége',
  cati_43: 'A beszélgetés irányítása',
  cati_44:
    'Az aktív hallgatás technikáinak alkalmazása, a válaszadó bevonása és a párbeszéd hatékony irányítása',
  cati_45: 'A témában való jártasság',
  cati_46:
    'A felmérés témájának mélyreható ismerete és a válaszadó további kérdéseinek megfelelő megválaszolására való képesség',
  cati_47: 'A kérdőív kitöltésének pontossága',
  cati_48:
    'A válaszok pontos, torzításmentes rögzítése, az utasítások követése és a felmérés kitöltése során előforduló hibák elkerülése',
  cati_49: 'Miért a 4Service',
  cati_50: 'Miért válassza a 4Service CATI szolgáltatását?',
  cati_51:
    'A CATI olyan vállalatok számára ideális, amelyek telefonos felmérések segítségével pontos, strukturált adatokat szeretnének szerezni',
  cati_52: 'Saját kapcsolattartó központ',
  cati_53:
    'Több mint 70 000 sikeres hívást bonyolítottunk le, az ügyféligények 100%-os teljesítésével',
  cati_54: 'Minőségi garancia',
  cati_55:
    'Minden hívás 100%-os validálása – az adatok pontosságának biztosítása',
  cati_56: 'Egyéni megközelítés',
  cati_57:
    'Egyedi kérdőívek kidolgozása az ügyfelek konkrét igényeihez igazítva',
  cati_58: 'Fejlett szoftver',
  cati_59: 'VolPtime bármilyen összetettségű CATI-felmérések lebonyolításához',
  cati_60: 'Tapasztalat a B2B területén',
  cati_61:
    'Jogi személyekkel dolgozunk, és különböző üzleti és ipari ágazatok vezető szakembereit kérdezzük meg',
  cati_62:
    'Küldje el megkeresését, és megtaláljuk az Ön számára legjobb megoldást!',
  cati_63: 'Technológia',
  cati_64:
    'Modern technológiákat alkalmazunk az eredmények elemzésére és vállalkozása fejlesztésére',
  cati_65: 'Lehetőségek:',
  cati_66: '<span>VolPtime</span> – professzionális szoftver',
  cati_67: 'Bejövő (forródrót)/kimenő automatikus vonalak szervezése',
  cati_68:
    'Statisztikák operátorok, az egyes megkereséstípusok és a konzultáció időtartama szerint',
  cati_69: 'A kapcsolattartó központ működésének online monitorozása',
  cati_70: 'Minden telefonos hangkonzultáció rögzítése',
  cati_71: 'Távoli és egyszerű szoftverkonfiguráció',
  cati_72:
    '<span>Survey Monkey</span> – professzionális szolgáltatás kérdőívek programozásához',
  cati_73: 'Különböző összetettségi szintű kérdőívek programozása',
  cati_74: 'Minden kutatási igény figyelembevételével',
  cati_75: 'Egyszerűség, átláthatóság és kényelem a válaszadók számára',
  cati_76: 'Minőség',
  cati_77: 'Az ügyfelekkel folytatott párbeszédek minőségének értékelése',
  cati_78: 'Ellenőrzőlista-alapú értékelési rendszer',
  cati_79:
    'A szolgáltatás minőségét egy speciális ellenőrzőlista segítségével mérjük, amely alapján a minőségértékelést végző munkatársak átlagos pontszámot adnak a beszámolási időszak során',
  cati_80: 'Célértékeknek való megfelelés mutatói',
  cati_81:
    'A standardoknak való megfelelést meghatározott szintek alapján értékeljük, amelyek nem lehetnek 90%-nál alacsonyabbak. Ezek a mutatók a munkatárs tapasztalatától függően módosíthatók',
  cati_82: 'A hívások monitorozása felvételeken és valós időben',
  cati_83:
    'A hívások mintegy 40%-át felvételeken, 20%-át pedig valós időben ellenőrizzük, ami lehetővé teszi a lehetséges standardeltérésekre való gyors reagálást',
  cati_84: 'Szakértők',
  cati_85: 'Saját kapcsolattartó központtal rendelkezünk',
  cati_86: 'Kapcsolattartó központ vezetője',
  cati_87: 'Toborzási vezetők',
  cati_88: 'Ukrajnai távoli telephely',
  cati_89: 'Kazahsztáni távoli telephely',
  cati_90: 'Technikai koordinátor',
  cati_91: 'Projektmenedzserek',
  cati_92: 'Projektmenedzserek',
  cati_93: 'Képzési és minőség-ellenőrzési osztály',
  cati_94: 'Operátorok – 60 fő (20%-uk folyékonyan beszél angolul)',
  cati_95: 'Operátorok – 20 fő',
  cati_96: 'A minőség-ellenőrzési osztály vezetője',
  cati_97: 'Minőség-ellenőrzési szakemberek',
  cati_98: 'Képzési trénerek',
};
